<template>
  <div class="gx-cloud">
    <gx-loading :show="loading" />
    <!-- <h1 class="gx-main__title">云商品库</h1> -->

    <!-- Tabs -->
    <div class="gx-cloud__tabs">
      <button
        v-for="(t, i) in tabDefs"
        :key="i"
        class="gx-cloud__tab"
        :class="{ 'gx-cloud__tab--on': tab === i }"
        @click="switchTab(i)"
      >
        {{ t.label }}
        <span v-if="tab === i" class="gx-cloud__tab-beam"></span>
      </button>
    </div>

    <!-- Tab1: 商品导入 -->
    <div v-if="tab === 0">
      <div class="gx-cloud__import-head">
        <button class="gx-cloud__btn gx-cloud__btn--primary" @click="handleAdd">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1v12M1 7h12" stroke="currentColor" stroke-width="2" stroke-linecap="round" /></svg>
          新增商品
        </button>
        <button class="gx-cloud__btn" @click="handleRefresh">
          <svg width="13" height="13" viewBox="0 0 14 14" fill="none"><path d="M13 7a6 6 0 1 1-1.76-4.24M13 1v4h-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
          刷新列表
        </button>
        <span class="gx-cloud__import-tip">支持 1688 链接批量导入 / TB、PDD 采集包（zip）导入</span>
      </div>
      <div class="gx-cloud__card">
      <div class="gx-cloud__table">
        <table>
          <thead>
            <tr>
              <th v-for="h in ['批次号', '文件名', '数量', '商品来源', '进度', '状态', '时间', '操作']" :key="h">{{ h }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in importList" :key="r.id">
              <td><a class="gx-cloud__batch-link" @click="handleView(r)">{{ r.batch_no || r.id }}</a></td>
              <td class="gx-cloud__file" :title="r.file_name">{{ r.file_name || '--' }}</td>
              <td class="gx-cloud__counts">
                <span style="color: rgb(26, 26, 46);">导入:{{ r.total_count || 0 }}</span>
                <span class="gx-cloud__ok" style="color: rgb(82, 196, 26);"> 成功:{{ r.success_count || 0 }}</span>
                <span v-if="r.fail_count > 0" class="gx-cloud__fail" style="color: rgb(200, 68, 60);"> 失败:{{ r.fail_count }}</span>
                <span v-if="r.duplicate_count > 0" class="gx-cloud__dup" style="color: rgb(251, 146, 60);"> 重复:{{ r.duplicate_count }}</span>
              </td>
              <td>
                <span class="gx-cloud__src" style="font-weight: 600;"  :class="sourceCls(r.source_web)">{{ sourceLabel(r.source_web) }}</span>
              </td>
              <td>
                <div class="gx-cloud__progress">
                  <span class="gx-cloud__progress-bar"><span class="gx-cloud__progress-fill" :style="{ width: (r.progress_percent || 0) + '%' }"></span></span>
                  <span class="gx-cloud__progress-val">{{ r.progress_percent || 0 }}%</span>
                </div>
              </td>
              <td>
                <span class="gx-cloud__status" :class="importStatusCls(r.status)" style="font-weight: 600;">{{ r.status_text || statusText(r.status) }}</span>
              </td>
              <td class="gx-cloud__mono gx-cloud__dim" style="color: rgb(153, 153, 153);">{{ r.created_at }}</td>
              <td><button class="gx-cloud__op" @click="handleView(r)">查看</button></td>
            </tr>
            <tr v-if="!importList.length">
              <td :colspan="8" class="gx-cloud__empty">暂无导入批次</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- <div class="gx-cloud__pager"> -->
        <!-- <div class="gx-cloud__pager-left">
          <span class="gx-cloud__pager-total">共 {{ importPage.total }} 条</span>
          <page-size-select :value="importPage.limit" :options="importPageSizeOptions" @change="onImportPageSizeChange" />
        </div>
        <div class="gx-cloud__pager-btns">
          <button class="gx-cloud__page gx-cloud__page--arrow" :disabled="importPage.page <= 1" @click="getImports(importPage.page - 1)">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M7.5 2.5L4 6l3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
          <button v-for="n in importPages" :key="n" class="gx-cloud__page" :class="{ 'gx-cloud__page--on': n === importPage.page }" @click="getImports(n)">{{ n }}</button>
          <button class="gx-cloud__page gx-cloud__page--arrow" :disabled="importPage.page >= importTotalPages" @click="getImports(importPage.page + 1)">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M4.5 2.5L8 6l-3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
        </div> -->
                <!-- 分页 -->
        <div style="padding: 10px 14px;background: rgb(245, 240, 232);">
          <Pagination :total="importPage.total" :page.sync="importPage.page" :limit.sync="importPage.limit" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="getImports(importPage.page)"  layout="total, sizes, prev, pager, next, jumper" />
        </div>
      <!-- </div> -->
      </div><!-- /gx-cloud__card -->
    </div>

    <!-- Tab2: 云商品列表 -->
    <div v-else-if="tab === 1">
      <div class="gx-cloud__filter gx-cloud__filter--cloud">
        <div class="search-wrap custom-form-wrap">
          <el-form inline size="mini" :model="cloudSearch" ref="searchForm">
            <div class="gx-cloud__filter-row">
              <el-form-item label="批次号">
                <el-input v-model="cloudSearch.batch_no" placeholder="请输入批次号"/>
              </el-form-item>
              <el-form-item label="关键词">
                <el-input v-model="cloudSearch.keyword" placeholder="请输入关键词"/>
              </el-form-item>
              <el-form-item label="来源ID">
                <el-input v-model="cloudSearch.source_product_id" placeholder="请输入来源ID"/>
              </el-form-item>
              <el-form-item label="铺货平台ID">
                <el-input v-model="cloudSearch.platform_product_id" placeholder="请输入铺货平台ID"/>
              </el-form-item>
              <el-form-item label="全部来源">
                <el-select v-model="cloudSearch.source_web" clearable placeholder="全部来源" class="w200" @change="handleFilterChange">
                  <el-option label="1688" :value="2"></el-option>
                  <el-option label="TB" :value="3"></el-option>
                  <el-option label="PDD" :value="4"></el-option>
                  <el-option label="DY（调研中）" :value="5"></el-option>
                  <el-option label="WX" :value="6"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="分组">
                <el-select v-model="cloudSearch.group_id" clearable placeholder="全部分组" class="w200" @change="handleGroupFilterChange">
                  <el-option v-for="g in groupList" :key="g.id" :label="g.name" :value="g.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="子分组">
                <el-select v-model="cloudSearch.child_group_id" clearable placeholder="子分组" class="w200" @change="handleFilterChange">
                  <el-option v-for="g in child_groupList" :key="g.id" :label="g.name" :value="g.id"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="gx-cloud__filter-row">
              <el-form-item label="价格区间">
                <div style="display: flex; align-items: center; gap: 10px;">
                  <el-input v-model="cloudSearch.min_price" placeholder="最低价" style="width: 100px;"/>
                  <span class="gx-cloud__range-sep">-</span>
                  <el-input v-model="cloudSearch.max_price" placeholder="最高价" style="width: 100px;"/>
                </div>
              </el-form-item>
              <el-form-item label="是否包邮">
                <el-select v-model="cloudSearch.distribution_free_postage" clearable placeholder="全部" class="w200" @change="handleFilterChange">
                  <el-option label="包邮" :value="1"></el-option>
                  <el-option label="不包邮" :value="0"></el-option>
                  <el-option label="未知" value="unknown"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="运费显示省份">
                <el-select v-model="cloudSearch.freight_province_code" clearable placeholder="选择后新增运费显示" class="w200" @change="handleFilterChange">
                  <el-option v-for="g in provinceOptions" :key="g.value" :label="g.label" :value="g.value"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="gx-cloud__filter-row gx-cloud__filter-row--time-tags">
              <el-form-item label="月份时效">
                <button
                  v-for="month in monthTagOptions"
                  :key="month"
                  type="button"
                  class="gx-cloud__time-tag-filter-btn"
                  :class="{ 'gx-cloud__time-tag-filter-btn--on': cloudSearch.month_tags.includes(month) }"
                  @click="toggleCloudTimeTag('month_tags', month)"
                >{{ month }}</button>
              </el-form-item>
              <el-form-item label="季节时效">
                <button
                  v-for="season in seasonTagOptions"
                  :key="season"
                  type="button"
                  class="gx-cloud__time-tag-filter-btn gx-cloud__time-tag-filter-btn--season"
                  :class="{ 'gx-cloud__time-tag-filter-btn--on': cloudSearch.season_tags.includes(season) }"
                  @click="toggleCloudTimeTag('season_tags', season)"
                >{{ season }}</button>
              </el-form-item>
            </div>
            <div class="gx-cloud__filter-row">
              <el-form-item label="sku替换状态">
                <el-select v-model="cloudSearch.sku_status" clearable placeholder="全部状态" class="w200" @change="handleFilterChange">
                  <el-option v-for="g in skuStatus" :key="g.value" :label="g.label" :value="g.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品标记状态">
                <el-select v-model="cloudSearch.sku_mark_status" clearable placeholder="全部状态" class="w200" @change="handleFilterChange">
                  <el-option v-for="g in skuMarkStatus" :key="g.value" :label="g.label" :value="g.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="标题替换状态">
                <el-select v-model="cloudSearch.ai_title_status" clearable placeholder="全部状态" class="w200" @change="handleFilterChange">
                  <el-option v-for="g in aiTitleStatus" :key="g.value" :label="g.label" :value="g.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="缺少sku图">
                <el-select v-model="cloudSearch.is_sku_miss" clearable placeholder="全部" class="w200" @change="handleFilterChange">
                  <el-option label="否" :value="1"></el-option>
                  <el-option label="是" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="gx-cloud__filter-row gx-cloud__filter-row--distribution">
              <el-form-item label="排除已铺货">
                <el-select
                  v-model="excludeSelect"
                  @change="handleExcludeFilterChange"
                  clearable
                  placeholder="请选择"
                  style="width: 100%;"
                >
                  <el-option label="排除全部已铺货" value="all" />
                  <el-option-group v-if="excludeShopList.length" label="按店铺排除">
                    <el-option
                      v-for="shop in excludeShopList"
                      :key="shop.shop_id"
                      :label="shop.shop_name"
                      :value="String(shop.shop_id)"
                    />
                  </el-option-group>
                </el-select>
              </el-form-item>
              <el-form-item label="铺货状态" v-if="cloudSearch.exclude_distributed.length">
                <el-select v-model="cloudSearch.distribution_free_postage" clearable placeholder="全部" class="w200" @change="handleFilterChange">
                  <el-option label="待铺货" :value="1"></el-option>
                  <el-option label="铺货中" :value="2"></el-option>
                  <el-option label="铺货成功" :value="3"></el-option>
                  <el-option label="铺货失败" :value="4"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="触发铺货成功">
                <el-select v-model="cloudSearch.has_distribute_success" clearable placeholder="全部" class="w200" @change="handleFilterChange">
                  <el-option label="是" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="触发铺货失败">
                <el-select v-model="cloudSearch.has_distribute_fail" clearable placeholder="全部" class="w200" @change="handleFilterChange">
                  <el-option label="是" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="触发商品驳回">
                <el-select v-model="cloudSearch.has_distribute_review_fail" clearable placeholder="全部" class="w200" @change="handleFilterChange">
                  <el-option label="是" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="触发商品封禁">
                <el-select v-model="cloudSearch.has_distribute_ban" clearable placeholder="全部" class="w200" @change="handleFilterChange">
                  <el-option label="是" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="gx-cloud__fitem gx-cloud__fitem--btns">
          <button class="gx-cloud__btn gx-cloud__btn--primary" @click="handleCloudSearch">查询</button>
<!--          <button class="gx-cloud__btn" @click="handleCloudRefresh">-->
<!--            <svg width="12" height="12" viewBox="0 0 14 14" fill="none"><path d="M13 7a6 6 0 1 1-1.76-4.24M13 1v4h-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>-->
<!--            刷新-->
<!--          </button>-->
          <button class="gx-cloud__btn" @click="handleCloudReset">重置</button>
        </div>
      </div>

      <!-- 批量操作栏 -->
      <div class="gx-cloud__actionrow__list">
        <button class="gx-cloud__btn gx-cloud__btn--primary" :disabled="!cloudSelectedList.length" @click="openDistribute">铺货({{ cloudSelectedList.length }})</button>
        <button class="gx-cloud__btn" @click="handleCloudBatchEdit">批量编辑</button>
        <button class="gx-cloud__btn gx-cloud__btn--danger" :disabled="!cloudSelectedList.length" @click="handleCloudBatchDelete">批量删除</button>
        <button class="gx-cloud__btn" :disabled="!cloudSelectedList.length" @click="openBatchTimeTags">设置时效</button>
        <button v-if="cloudSearch.status == 4" class="gx-cloud__btn gx-cloud__btn--recover" :disabled="!cloudSelectedList.length" @click="handleCloudBatchRecover">一键恢复</button>
        <button class="gx-cloud__btn" @click="handleCloudImageSearch">批量SKU替换</button>
        <button class="gx-cloud__btn" @click="handleAICloudBatchImageSearch">AI批量SKU替换</button>
        <button class="gx-cloud__btn gx-cloud__btn--mark" @click="handleAICloudBatchProductMark">AI批量找货源标记</button>
        <button class="gx-cloud__btn" @click="handleCloudBatchLinkReplace">批量替换指定链接SKU</button>
        <button class="gx-cloud__btn" :disabled="!cloudSelectedList.length" @click="handleBatchSetGroup">设置分组</button>
      </div>

      <!-- 列表面板卡片：批量操作 + 状态tabs + 表格 + 分页 -->
      <div class="gx-cloud__card">
      <!-- 状态切换栏 -->
      <div class="gx-cloud__status-tabs">
        <button
          v-for="t in cloudStatusTabs"
          :key="t.val"
          class="gx-cloud__status-tab"
          :class="{ 'gx-cloud__status-tab--on': cloudSearch.status === t.val }"
          @click="handleCloudStatusTabClick(t.val)"
        >
          {{ t.label }}
          <span v-if="t.num > 0" class="gx-cloud__status-num">{{ t.num }}</span>
        </button>
      </div>

      <div class="gx-cloud__table gx-cloud__table--goods">
        <table>
          <thead>
            <tr>
              <th class="gx-cloud__col-check">
                <span class="gx-cloud__check" :class="{ 'gx-cloud__check--on': allChecked }" @click="toggleAll">
                  <svg v-if="allChecked" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                </span>
              </th>
              <th>时间</th>
              <th>商品来源</th>
              <th>分组</th>
              <th>类目</th>
              <th>商品时效</th>
              <th>商品信息</th>
              <th>上货状态</th>
              <th>铺店详情</th>
              <th>上家明细</th>
              <th>下架提醒</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in cloudList" :key="row.id">
              <td>
                <span class="gx-cloud__check" :class="{ 'gx-cloud__check--on': cloudSelectedList.includes(row) }" @click="toggleOne(row)">
                  <svg v-if="cloudSelectedList.includes(row)" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                </span>
              </td>
              <td class="gx-cloud__cell-time">
                <div><span class="gx-cloud__cell-label">上新：</span>{{ row.created_at_text || '--' }}</div>
                <div><span class="gx-cloud__cell-label">更新：</span>{{ row.updated_at_text || '--' }}</div>
              </td>
              <td>
                <div v-if="row.source_web">
                  <span class="gx-cloud__src" :class="sourceCls(row.source_web)">{{ sourceLabel(row.source_web) }}</span>
                </div>
              </td>
              <td>
                <template v-if="row.group_name">
                  <div class="gx-cloud__gname" :title="formatGroupName(row).split('|')[0]">{{ formatGroupName(row).split('|')[0] }}</div>
                  <div v-if="formatGroupName(row).split('|')[1]" class="gx-cloud__gname gx-cloud__gname--sub" :title="formatGroupName(row).split('|')[1]">{{ formatGroupName(row).split('|')[1] }}</div>
                </template>
                <span v-else class="gx-cloud__dim">--</span>
              </td>
              <td><span class="gx-cloud__dim">--</span></td>
              <td class="gx-cloud__cell-validity">
                <div class="gx-cloud__cell-stack-line">
                  <span class="gx-cloud__cell-label">月份：</span>
                  <span v-if="formatMonthTags(row.month_tags)" class="gx-cloud__time-tag-text">{{ formatMonthTags(row.month_tags) }}</span>
                  <span v-else class="gx-cloud__dim">--</span>
                </div>
                <div class="gx-cloud__cell-stack-line">
                  <span class="gx-cloud__cell-label">季节：</span>
                  <div v-if="normalizeSeasonTags(row.season_tags).length" class="gx-cloud__season-tags">
                    <span
                      v-for="season in normalizeSeasonTags(row.season_tags)"
                      :key="season"
                      class="gx-cloud__season-tag"
                      :class="'gx-cloud__season-tag--' + season"
                    >{{ season }}季</span>
                  </div>
                  <span v-else class="gx-cloud__dim">--</span>
                </div>
              </td>
              <td>
                <div class="gx-cloud__goods gx-cloud__goods--row">
                  <span class="gx-cloud__thumb gx-cloud__thumb--preview" style="width: 80px; height: 80px;">
                    <el-image
                      v-if="row.main_image"
                      class="gx-cloud__thumb-image"
                      :src="row.main_image"
                      :preview-src-list="[row.main_image]"
                      fit="cover"
                      alt="商品主图"
                    >
                      <span slot="error">🛍️</span>
                    </el-image>
                    <span v-else>🛍️</span>
                  </span>
                  <div class="gx-cloud__goods-body">
                    <div class="gx-cloud__goods-name" :title="row.title">{{ row.title || '--' }}</div>
                    <div v-if="row.source_product_id" class="gx-cloud__cell-sub">ID：{{ row.source_product_id }}</div>
                    <span v-if="!row.source_web && !row.source_product_id" class="gx-cloud__dim">--</span>
                    <div class="gx-cloud__gtags gx-cloud__gtags--product">
                      <span class="gx-cloud__gtag" :class="'gx-cloud__gtag--' + ((skuStatus[row.sku_status] && skuStatus[row.sku_status].type) || 'selected-tag')">SKU：{{ skuStatusLabel(row.sku_status) }}</span>
                      <span class="gx-cloud__gtag" :class="'gx-cloud__gtag--' + ((skuMarkStatus[row.sku_mark_status] && skuMarkStatus[row.sku_mark_status].type) || 'selected-tag')">标记：{{ skuMarkStatusLabel(row.sku_mark_status) }}</span>
                      <span class="gx-cloud__gtag" :class="'gx-cloud__gtag--' + ((aiTitleStatus[row.ai_title_status] && aiTitleStatus[row.ai_title_status].type) || 'selected-tag')">标题：{{ aiTitleStatusLabel(row.ai_title_status) }}</span>
                      <span v-if="row.is_sku_miss == 2" class="gx-cloud__gtag gx-cloud__gtag--notFond-tag">缺失SKU图：是</span>
                      <span v-else-if="row.is_sku_miss == 1" class="gx-cloud__gtag gx-cloud__gtag--replaced-tag">缺失SKU图：否</span>
                      <span v-else class="gx-cloud__gtag gx-cloud__gtag--selected-tag">缺失SKU图：--</span>
                    </div>
                  </div>
                </div>
              </td>
              <td style="font-size: 10px;">
                <div style="color: rgb(82, 196, 26);margin-bottom: 4px;">上货成功：{{ row.distribute_success_count || 0 }}</div>
                <div style="color: rgb(200, 68, 60);margin-bottom: 4px;">上货失败：{{ row.distribute_fail_count || 0 }}</div>
                <div style="color: rgb(251, 146, 60);margin-bottom: 4px;">商品驳回：{{ row.distribute_review_fail_count || 0 }}</div>
                <div style="color: rgb(74, 74, 106);">商品封禁：{{ row.distribute_ban_count || 0 }}</div>
              </td>
              <td class="gx-cloud__metric">
                <div>铺店数量 <b>{{ distributeShopCount(row, 'total') }}</b></div>
                <div>总销量 <b>{{ salesSnapshotValue(row, 'total') }}</b></div>
              </td>
              <td class="gx-cloud__supplier-detail">
                <div>
                  <span class="gx-cloud__cell-label">上家价格：</span>
                  <span v-if="row.price || row.price === 0" class="gx-cloud__price">¥{{ row.price }}</span>
                  <span v-else class="gx-cloud__dim">--</span>
                </div>
                <div>是否包邮：{{ row.distribution_free_postage === true ? '是' : (row.distribution_free_postage === false ? '否' : '未知') }}</div>
                <div v-if="cloudSearch.freight_province_code">发往{{ provinceName(cloudSearch.freight_province_code) }}：{{ row.destination_freight_status === 'unknown' ? '未知' : row.destination_freight + ' 元' }}</div>
                <button v-if="row.distribution_free_postage === false" class="gx-cloud__op" @click="handleViewFreight(row)">查看运费</button>
              </td>
              <td>
                <span class="gx-cloud__dim">--</span>
              </td>
              <td>
                <div class="gx-cloud__ops">
                  <button v-if="row.status === 1" class="gx-cloud__op gx-cloud__op--edit" @click="openEdit(row)">编辑</button>
                  <button class="gx-cloud__op" @click="openOneTimeTags(row)">设置时效</button>
                  <button v-if="row.status === 1" class="gx-cloud__op gx-cloud__op--primary" @click="openSkuReplace(row)">SKU替换</button>
                  <button v-if="row.status === 1" class="gx-cloud__op" @click="handleLinkReplace(row)">替换指定链接sku</button>
                  <button v-if="row.status === 1" class="gx-cloud__op gx-cloud__op--primary" @click="openDistributeRecord(row)">铺货日志</button>
                  <button class="gx-cloud__op" @click="openReplaceLog(row)">SKU替换记录</button>
                  <button class="gx-cloud__op" @click="handleViewProductMarks(row)">查看标记货源</button>
                  <button v-if="row.ai_title_status == 2" class="gx-cloud__op" @click="handleViewReplaceTitleLogs(row)">标题替换记录</button>
                  <button v-if="cloudSearch.status == 4" class="gx-cloud__op gx-cloud__op--recover" @click="recoverOne(row)">恢复</button>
                  <button class="gx-cloud__op gx-cloud__op--danger" @click="deleteCloud(row)">删除</button>
                </div>
              </td>
            </tr>
            <tr v-if="!cloudList.length">
              <td :colspan="12" class="gx-cloud__empty">暂无云商品数据</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="gx-cloud__pager">
        <div class="gx-cloud__pager-left">
          <span class="gx-cloud__pager-total">共 {{ cloudPage.total }} 条</span>
          <page-size-select :value="cloudPage.limit" :options="cloudPageSizeOptions" @change="onCloudPageSizeChange" />
        </div>
        <div class="gx-cloud__pager-btns">
          <button class="gx-cloud__page gx-cloud__page--arrow" :disabled="cloudPage.page <= 1" @click="getClouds(cloudPage.page - 1)">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M7.5 2.5L4 6l3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
          <button v-for="n in cloudPages" :key="n" class="gx-cloud__page" :class="{ 'gx-cloud__page--on': n === cloudPage.page }" @click="getClouds(n)">{{ n }}</button>
          <button class="gx-cloud__page gx-cloud__page--arrow" :disabled="cloudPage.page >= cloudTotalPages" @click="getClouds(cloudPage.page + 1)">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M4.5 2.5L8 6l-3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
        </div>
      </div> -->
        <div style="padding: 10px 14px;background: rgb(245, 240, 232);">
          <Pagination :total="cloudPage.total" :page.sync="cloudPage.page" :limit.sync="cloudPage.limit" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="getClouds(cloudPage.page)"  layout="total, sizes, prev, pager, next, jumper" />
        </div>
      </div><!-- /gx-cloud__card -->
    </div>

    <!-- Tab3: 共享商品库 -->
    <div v-else-if="tab === 2">
      <div class="gx-cloud__filter">
        <div class="search-wrap custom-form-wrap">
          <el-form inline size="mini" :model="shareSearch" ref="searchForm">
              <el-form-item label="来源ID">
                <el-input v-model="shareSearch.source_product_id" placeholder="请输入来源ID"/>
              </el-form-item>
            <el-form-item label="批次号">
                <el-input v-model="shareSearch.batch_no" placeholder="请输入批次号"/>
              </el-form-item>
            <el-form-item label="关键词">
                <el-input v-model="shareSearch.keyword" placeholder="请输入关键词"/>
            </el-form-item>
            <el-form-item label="sku替换状态">
              <el-select v-model="shareSearch.sku_status" clearable placeholder="全部状态" class="w200"  @change="handleShareSearch">
                  <el-option v-for="g in skuStatus" :key="g.value" :label="g.label" :value="g.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否包邮">
              <el-select v-model="shareSearch.distribution_free_postage" clearable placeholder="全部" class="w200"  @change="handleShareSearch">
                <el-option label="包邮" :value="1"></el-option>
                <el-option label="不包邮" :value="0"></el-option>
                <el-option label="未知" value="unknown"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="运费显示省份">
              <el-select v-model="shareSearch.freight_province_code" clearable placeholder="选择后新增运费显示" class="w200"  @change="handleShareSearch">
                <el-option v-for="g in provinceOptions" :key="g.value" :label="g.label" :value="g.value"></el-option>
              </el-select>
            </el-form-item>
           <el-form-item label="价格区间">
              <div style="display: flex; align-items: center;gap: 10px;">
                <el-input v-model="shareSearch.min_price" placeholder="最低价" style="width: 100px;"/>
                <span class="gx-cloud__range-sep">-</span>
                <el-input v-model="shareSearch.max_price" placeholder="最高价" style="width: 100px;"/>
              </div>
            </el-form-item>


            <el-form-item label="触发铺货成功">
              <el-select v-model="shareSearch.has_distribute_success" clearable placeholder="全部" class="w200"  @change="handleShareSearch">
                <el-option label="是" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="触发铺货失败">
              <el-select v-model="shareSearch.has_distribute_fail" clearable placeholder="全部" class="w200"  @change="handleShareSearch">
                <el-option label="是" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="触发商品封禁">
              <el-select v-model="shareSearch.has_distribute_ban" clearable placeholder="全部" class="w200"  @change="handleShareSearch">
                <el-option label="是" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="触发商品驳回">
              <el-select v-model="shareSearch.has_distribute_review_fail" clearable placeholder="全部" class="w200"  @change="handleShareSearch">
                <el-option label="是" :value="1"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="排除已铺货">
                <el-select
                  v-model="shareExcludeSelect"
                  @change="handleShareExcludeFilterChange"
                  clearable
                  placeholder="请选择"
                  style="width: 100%;"
                >
                  <!-- 普通选项 -->
                  <el-option label="排除全部已铺货" value="all" />

                  <!-- 分组选项（对应原生 optgroup） -->
                  <el-option-group
                    v-if="excludeShopList.length"
                    label="按店铺排除"
                  >
                    <el-option
                      v-for="shop in excludeShopList"
                      :key="shop.shop_id"
                      :label="shop.shop_name"
                      :value="String(shop.shop_id)"
                    />
                  </el-option-group>
                </el-select>
            </el-form-item>
            <el-form-item label="铺货状态" v-if="shareSearch.exclude_distributed.length">
                <el-select v-model="shareSearch.distribution_status" clearable placeholder="全部" class="w200"  @change="handleShareSearch">
                  <el-option label="待铺货" :value="1"></el-option>
                  <el-option label="铺货中" :value="2"></el-option>
                  <el-option label="铺货成功" :value="3"></el-option>
                  <el-option label="铺货失败" :value="4"></el-option>
                </el-select>
              </el-form-item>
            <el-form-item label="分组">
              <el-select v-model="shareSearch.group_id" clearable placeholder="全部" class="w200"  @change="handleShareGroupChange">
                  <el-option v-for="g in groupList" :key="g.id" :label="g.name" :value="g.id"></el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="子分组">
              <el-select v-model="shareSearch.child_group_id" clearable placeholder="全部" class="w200"  @change="handleShareSearch">
                  <el-option v-for="g in shareChildGroupList" :key="g.id" :label="g.name" :value="g.id"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="gx-cloud__fitem gx-cloud__fitem--btns">
          <button class="gx-cloud__btn gx-cloud__btn--primary" @click="handleShareSearch">查询</button>
          <button class="gx-cloud__btn" @click="handleShareReset">重置</button>
        </div>
      </div>
      <div class="gx-cloud__actionrow">
        <button class="gx-cloud__btn gx-cloud__btn--primary" :disabled="!shareSelectedList.length" @click="openShareDistribute">铺货({{ shareSelectedList.length }})</button>
      </div>
      <div class="gx-cloud__card">
      <div class="gx-cloud__table">
        <table>
          <thead>
            <tr>
              <th style="width: 36px">
                <span class="gx-cloud__check" :class="{ 'gx-cloud__check--on': shareAllChecked }" @click="toggleShareAll">
                  <svg v-if="shareAllChecked" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                </span>
              </th>
              <th>商品信息</th>
              <th>运费</th>
              <th>分组(主+子)</th>
              <th>状态</th>
              <th>时间</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in shareList" :key="row.id">
              <td>
                <span class="gx-cloud__check" :class="{ 'gx-cloud__check--on': shareSelectedList.includes(row) }" @click="toggleShareOne(row)">
                  <svg v-if="shareSelectedList.includes(row)" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                </span>
              </td>
              <td>
                <div class="gx-cloud__goods">
                  <span class="gx-cloud__thumb"><img v-if="row.main_image" :src="row.main_image" alt="" /><span v-else>🛍️</span></span>
                  <div class="gx-cloud__goods-body">
                    <div class="gx-cloud__goods-name" :title="row.title">{{ row.title }}</div>
                    <div class="gx-cloud__goods-meta">价格：<b class="gx-cloud__gold">¥{{ row.price }}</b></div>
                    <div class="gx-cloud__goods-meta">来源ID：{{ row.source_product_id }}</div>
                    <!-- <div class="gx-cloud__goods-meta"><span :class="skuStatusCls(row.sku_status)">SKU：{{ skuStatusLabel(row.sku_status) }}</span></div> -->
                     <div class="gx-cloud__gtags">
                      <span class="gx-cloud__gtag" :class="'gx-cloud__gtag--' + ((skuStatus[row.sku_status] && skuStatus[row.sku_status].type) || 'selected-tag')">SKU：{{ skuStatusLabel(row.sku_status) }}</span>
                    </div>
                  </div>
                </div>
              </td>
              <td class="gx-cloud__freight">
                <div>是否包邮：{{ row.distribution_free_postage === true ? '是' : (row.distribution_free_postage === false ? '否' : '未知') }}</div>
                <div v-if="shareSearch.freight_province_code">发往{{ provinceName(shareSearch.freight_province_code) }}：{{ row.destination_freight_status === 'unknown' ? '未知' : row.destination_freight + ' 元' }}</div>
                <button v-if="row.distribution_free_postage === false" class="gx-cloud__op" @click="handleViewFreight(row, 1)">查看运费</button>
              </td>
              <td>
                <template v-if="row.group_name">
                  <div class="gx-cloud__gname" :title="formatGroupName(row).split('|')[0]">{{ formatGroupName(row).split('|')[0] }}</div>
                  <div v-if="formatGroupName(row).split('|')[1]" class="gx-cloud__gname gx-cloud__gname--sub" :title="formatGroupName(row).split('|')[1]">{{ formatGroupName(row).split('|')[1] }}</div>
                </template>
                <span v-else class="gx-cloud__dim">--</span>
              </td>
              <td>
                <span class="gx-cloud__status" :style="cloudStatusStyle(row)">{{ row.status_text || row.status || '--' }}</span>
              </td>
              <td class="gx-cloud__time" style="color: rgb(153, 153, 153);">
                <div>创建: {{ row.created_at_text }}</div>
                <div>更新: {{ row.updated_at_text }}</div>
              </td>
            </tr>
            <tr v-if="!shareList.length">
              <td :colspan="6" class="gx-cloud__empty">暂无共享商品数据</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="gx-cloud__pager">
        <div class="gx-cloud__pager-left">
          <span class="gx-cloud__pager-total">共 {{ sharePage.total }} 条</span>
          <page-size-select :value="sharePage.limit" :options="sharePageSizeOptions" @change="onSharePageSizeChange" />
        </div>
        <div class="gx-cloud__pager-btns">
          <button class="gx-cloud__page gx-cloud__page--arrow" :disabled="sharePage.page <= 1" @click="getShares(sharePage.page - 1)">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M7.5 2.5L4 6l3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
          <button v-for="n in sharePages" :key="n" class="gx-cloud__page" :class="{ 'gx-cloud__page--on': n === sharePage.page }" @click="getShares(n)">{{ n }}</button>
          <button class="gx-cloud__page gx-cloud__page--arrow" :disabled="sharePage.page >= shareTotalPages" @click="getShares(sharePage.page + 1)">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M4.5 2.5L8 6l-3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
        </div>
      </div> -->
      <div style="padding: 10px 14px;background: rgb(245, 240, 232);">
        <Pagination :total="sharePage.total" :page.sync="sharePage.page" :limit.sync="sharePage.limit" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="getShares(sharePage.page)"  layout="total, sizes, prev, pager, next, jumper" />
      </div>
      </div><!-- /gx-cloud__card -->
    </div>

    <!-- Tab4: 铺货列表 -->
    <div v-else-if="tab === 3">
      <el-alert
          class="gx-cloud__dist-alert"
          title="系统后台自动铺货中。已铺货商品请至【我的商品】查看；若长时间显示【待铺货】，请检查店铺点数、授权状态及是否达到发布上限。"
          type="warning"
          show-icon
          :closable="false">
      </el-alert>
      <div class="gx-cloud__filter gx-cloud__filter--dist">
         <div class="search-wrap custom-form-wrap">
            <el-form inline size="mini" :model="distributeSearch" ref="searchForm">
              <el-form-item>
                <el-select v-model="distributeSearch.shop_type" clearable placeholder="全部平台" class="w200"  @change="handleDistributeSearch">
                    <el-option v-for="g in shopTypeList" :key="g.shop_type" :label="g.name" :value="g.shop_type"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model="distributeSearch.shop_id" clearable placeholder="全部店铺" class="w200"  @change="handleDistributeSearch">
                    <el-option v-for="g in filterShopList" :key="g.shop_id" :label="g.shop_name" :value="g.shop_id"  v-if="!distributeSearch.shop_type || g.shop_type == distributeSearch.shop_type"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                  <el-input v-model="distributeSearch.keyword" placeholder="请输入关键词"/>
              </el-form-item>
              <el-form-item prop="start_at">
                <el-date-picker v-model="distributeSearch.start_at" type="daterange" align="right" unlink-panels @change="handleDistributeSearch"
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable style="width: 240px">
                </el-date-picker>
              </el-form-item>
            </el-form>
          </div>
        <!-- <div class="gx-cloud__fitem">
          <input v-model="distributeSearch.start_date" type="date" class="gx-cloud__input gx-cloud__input--date" @change="handleDistributeSearch" />
          <span class="gx-cloud__range-sep">至</span>
          <input v-model="distributeSearch.end_date" type="date" class="gx-cloud__input gx-cloud__input--date" @change="handleDistributeSearch" />
        </div> -->
        <div class="gx-cloud__fitem gx-cloud__fitem--btns">
          <button class="gx-cloud__btn gx-cloud__btn--primary" @click="handleDistributeSearch">查询</button>
          <button class="gx-cloud__btn" @click="handleDistributeReset">重置</button>
        </div>
      </div>

      <div class="gx-cloud__dist-tabs">
        <button
          v-for="t in distributeStatusTabs"
          :key="t.val"
          class="gx-cloud__dist-tab"
          :class="{ 'gx-cloud__dist-tab--on': distributeSearch.status === t.val }"
          @click="handleStatusTabClick(t.val)"
        >
          <span>{{ t.label }}</span>
          <span v-if="t.num > 0" class="gx-cloud__dist-num">{{ t.num.toLocaleString() }}</span>
        </button>
      </div>

      <div class="gx-cloud__card">
      <div class="gx-cloud__table gx-cloud__table--dist">
        <table>
          <thead>
            <tr>
              <th>铺货时间</th>
              <th>店铺</th>
              <th>商品信息</th>
              <th>上货状态</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in distributeList" :key="row.id">
              <td class="gx-cloud__dist-time gx-cloud__mono gx-cloud__dim" style="color: rgb(153, 153, 153);">{{ row.created_at_text }}</td>
              <td class="gx-cloud__dist-shop">
                <div class="gx-cloud__dist-shopname" :title="row.shop_name">{{ row.shop_name || '--' }}</div>
                <span class="gx-cloud__plat" :class="distributePlatform(row).cls">{{ distributePlatform(row).label }}</span>
              </td>
              <td>
                <div class="gx-cloud__goods">
                  <span class="gx-cloud__thumb"><img v-if="row.product_image" :src="row.product_image" alt="" /><span v-else>🛍️</span></span>
                  <div class="gx-cloud__goods-body">
                    <div class="gx-cloud__goods-name" :title="row.product_title">{{ row.product_title }}</div>
                    <div class="gx-cloud__goods-meta">价格：<b class="gx-cloud__gold">¥{{ row.product_price }}</b></div>
                    <div class="gx-cloud__goods-meta">来源商品ID：{{ row.source_product_id }} <a class="gx-cloud__view-link" @click="handleViewGoods(row)">查看</a></div>
                  </div>
                </div>
              </td>
              <td>
                <div class="gx-cloud__statuscell">
                  <span class="gx-cloud__status" :style="distributeStatusStyle(row)">{{ row.status_text || row.status || '--' }}</span>
                  <div v-if="row.status === 3" class="gx-cloud__err" :title="row.err_msg">{{ row.err_msg || '' }}</div>
                </div>
              </td>
            </tr>
            <tr v-if="!distributeList.length">
              <td :colspan="4" class="gx-cloud__empty">暂无铺货记录</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="gx-cloud__pager">
        <div class="gx-cloud__pager-left">
          <span class="gx-cloud__pager-total">共 {{ distributePage.total }} 条</span>
          <page-size-select :value="distributePage.limit" :options="distributePageSizeOptions" @change="onDistributePageSizeChange" />
        </div>
        <div class="gx-cloud__pager-btns">
          <button class="gx-cloud__page gx-cloud__page--arrow" :disabled="distributePage.page <= 1" @click="getDistributeList(distributePage.page - 1)">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M7.5 2.5L4 6l3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
          <button v-for="n in distributePages" :key="n" class="gx-cloud__page" :class="{ 'gx-cloud__page--on': n === distributePage.page }" @click="getDistributeList(n)">{{ n }}</button>
          <button class="gx-cloud__page gx-cloud__page--arrow" :disabled="distributePage.page >= distributeTotalPages" @click="getDistributeList(distributePage.page + 1)">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M4.5 2.5L8 6l-3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
        </div>
      </div> -->
            <div style="padding: 10px 14px;background: rgb(245, 240, 232);">
        <Pagination :total="distributePage.total" :page.sync="distributePage.page" :limit.sync="distributePage.limit" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="getDistributeList(distributePage.page)"  layout="total, sizes, prev, pager, next, jumper" />
      </div>
      </div><!-- /gx-cloud__card -->
    </div>

    <!-- Tab5: 分组管理 -->
    <div v-else>
      <div class="gx-cloud__actionrow" style="padding: 0 0 12px;">
        <button class="gx-cloud__btn gx-cloud__btn--primary" @click="handleAddGroup">
          <svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M5.5 1v9M1 5.5h9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" /></svg>
          新增主分组
        </button>
         <div class="search-wrap custom-form-wrap">
          <el-form inline size="mini" :model="groupSearch">
              <el-form-item label="主分组名称">
                <el-input v-model="groupSearch.main_name" placeholder="主分组名称模糊搜索" @keyup.enter.native="handleGroupSearch"/>
              </el-form-item>
              <el-form-item label="子分组名称">
                <el-input v-model="groupSearch.child_name" placeholder="子分组名称模糊搜索" @keyup.enter.native="handleGroupSearch"/>
              </el-form-item>
          </el-form>
        </div>
        <button class="gx-cloud__btn gx-cloud__btn--primary" @click="handleGroupSearch" style="height: 26px;font-size: 12px;">查询</button>
        <button class="gx-cloud__btn" @click="refreshGroupList" style="height: 26px;">重置</button>
      </div>
      <div class="gx-cloud__card">
      <div class="gx-cloud__table gx-cloud__table--group">
        <table>
          <thead>
            <tr>
              <th class="gx-cloud__group-expand-col"></th>
              <th>主分组名称</th>
              <th>子分组数</th>
              <th>排序</th>
              <th>商品总数</th>
              <th>更新时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="g in groupTableData">
              <tr :key="'p' + g.id">
                <td class="gx-cloud__group-expand-col">
                  <button class="gx-cloud__group-expand" :class="{ 'gx-cloud__group-expand--on': groupExpandedParentId === g.id }" @click="handleGroupParentToggle(g)">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M4 2.5L8 6 4 9.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                  </button>
                </td>
                <td class="gx-cloud__gm-name">
                  <span class="gx-cloud__gm-tag">{{ g.name }}</span>
                  <span v-if="g.is_shared" class="gx-cloud__group-shared">共享</span>
                </td>
                <td class="gx-cloud__gm-count">{{ g.child_count || 0 }}</td>
                <td class="gx-cloud__mono">
                  <span>{{ g.sort || 0 }}</span>
                  <span v-if="g.editable" class="gx-cloud__sort-actions">
                    <button class="gx-cloud__sort-move" title="上移" :disabled="isGroupMoveLoading(g)" @click="moveGroup(g, 'up')">↑</button>
                    <button class="gx-cloud__sort-move" title="下移" :disabled="isGroupMoveLoading(g)" @click="moveGroup(g, 'down')">↓</button>
                  </span>
                </td>
                <td class="gx-cloud__gm-count">{{ g.product_count || 0 }}</td>
                <td class="gx-cloud__mono gx-cloud__dim"  style="color: rgb(153, 153, 153);">{{ g.updated_at }}</td>
                <td>
                  <div v-if="g.editable" class="gx-cloud__gm-ops">
                    <button class="gx-cloud__gm-op gx-cloud__gm-op--add" @click="handleAddChildGroup(g)">新增子分组</button>
                    <button class="gx-cloud__gm-op gx-cloud__gm-op--edit" @click="handleEditGroup(g)">编辑</button>
                    <button class="gx-cloud__gm-op gx-cloud__gm-op--del" @click="handleDeleteGroup(g)">删除</button>
                  </div>
                  <span v-else class="gx-cloud__dim">-</span>
                </td>
              </tr>
              <tr v-if="groupExpandedParentId === g.id" :key="'children-' + g.id" class="gx-cloud__group-children-row">
                <td colspan="7">
                  <div class="gx-cloud__group-children" v-loading="groupChildrenLoading">
                    <table class="gx-cloud__group-children-table">
                      <thead>
                        <tr>
                          <th>子分组名称</th>
                          <th>商品数量</th>
                          <th>排序</th>
                          <th>更新时间</th>
                          <th>操作</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="c in groupChildrenData" :key="'c' + c.id">
                          <td class="gx-cloud__gm-name gx-cloud__gm-name--child">
                            <span class="gx-cloud__gm-tag">{{ c.name }}</span>
                            <span v-if="c.is_shared" class="gx-cloud__group-shared">共享</span>
                          </td>
                          <td class="gx-cloud__gm-count">{{ c.product_count || 0 }}</td>
                          <td class="gx-cloud__mono">
                            <span>{{ c.sort || 0 }}</span>
                            <span v-if="c.editable" class="gx-cloud__sort-actions">
                              <button class="gx-cloud__sort-move" title="上移" :disabled="isGroupMoveLoading(c)" @click="moveGroup(c, 'up')">↑</button>
                              <button class="gx-cloud__sort-move" title="下移" :disabled="isGroupMoveLoading(c)" @click="moveGroup(c, 'down')">↓</button>
                            </span>
                          </td>
                          <td class="gx-cloud__mono gx-cloud__dim">{{ c.updated_at }}</td>
                          <td>
                            <div v-if="c.editable" class="gx-cloud__gm-ops">
                              <button class="gx-cloud__gm-op gx-cloud__gm-op--edit" @click="handleEditGroup(c)">编辑</button>
                              <button class="gx-cloud__gm-op gx-cloud__gm-op--del" @click="handleDeleteGroup(c)">删除</button>
                            </div>
                            <span v-else class="gx-cloud__dim">-</span>
                          </td>
                        </tr>
                        <tr v-if="!groupChildrenLoading && !groupChildrenData.length">
                          <td colspan="5" class="gx-cloud__empty">暂无匹配的子分组</td>
                        </tr>
                      </tbody>
                    </table>
                    <button v-if="groupChildrenData.length < groupChildrenPage.total" class="gx-cloud__op gx-cloud__group-more" :disabled="groupChildrenLoading" @click="loadMoreGroupChildren(g.id)">
                      加载更多（{{ groupChildrenData.length }}/{{ groupChildrenPage.total }}）
                    </button>
                  </div>
                </td>
              </tr>
            </template>
            <tr v-if="groupLoading">
              <td :colspan="7" class="gx-cloud__empty">加载中...</td>
            </tr>
            <tr v-else-if="!groupTableData.length">
              <td :colspan="7" class="gx-cloud__empty">暂无分组，请点击上方按钮新增</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="gx-cloud__pager">
        <span class="gx-cloud__pager-total">共 {{ groupPage.total }} 条</span>
        <div class="gx-cloud__pager-btns">
          <button class="gx-cloud__page gx-cloud__page--arrow" :disabled="groupPage.page <= 1" @click="getGroupList(groupPage.page - 1)">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M7.5 2.5L4 6l3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
          <button v-for="n in groupPages" :key="n" class="gx-cloud__page" :class="{ 'gx-cloud__page--on': n === groupPage.page }" @click="getGroupList(n)">{{ n }}</button>
          <button class="gx-cloud__page gx-cloud__page--arrow" :disabled="groupPage.page >= groupTotalPages" @click="getGroupList(groupPage.page + 1)">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M4.5 2.5L8 6l-3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
        </div>
      </div> -->
      <div style="padding: 10px 14px;background: rgb(245, 240, 232);">
        <Pagination :total="groupPage.total" :page.sync="groupPage.page" :limit.sync="groupPage.limit" :page-sizes="[10, 20, 50, 100]" @pagination="getGroupList(groupPage.page)" layout="total, sizes, prev, pager, next, jumper" />
      </div>
      </div><!-- /gx-cloud__card -->
    </div>

    <!-- 弹窗：导入商品 -->
    <div v-if="importShow" class="gx-cloud__modal" @click.self="importShow = false">
      <div class="gx-cloud__modal-box gx-cloud__modal-box--lg">
        <div class="gx-cloud__modal-head">
          <span class="gx-cloud__modal-title">导入商品</span>
          <button class="gx-cloud__modal-close" @click="importShow = false">✕</button>
        </div>
        <div class="gx-cloud__modal-body">
          <div class="gx-cloud__field">
            <label class="gx-cloud__label">商品来源：</label>
            <div class="gx-cloud__source-row">
              <button
                v-for="s in sourceList"
                :key="s.value"
                v-if="[2, 3, 4, 5, 6].includes(s.value)"
                type="button"
                class="gx-cloud__source-btn"
                :class="{ 'gx-cloud__source-btn--on': importInfo.source_web === s.value }"
                @click="selectSource(s.value)"
              >
                {{ s.label }}
              </button>
            </div>
          </div>
          <div class="gx-cloud__field" v-if="[3, 4, 5,6].includes(importInfo.source_web)">
            <label class="gx-cloud__label">商品解析：</label>
            <select v-model="importInfo.source_method" class="gx-cloud__select gx-cloud__select--full" @change="changeSourceMethod">
              <option value="">请选择解析方式</option>
              <option v-for="item in sourceMethod" :key="item.value" :value="item.value">{{ item.label }}</option>
            </select>
          </div>
          <div class="gx-cloud__field">
            <label class="gx-cloud__label">加入分组：</label>
            <select v-model="importInfo.group_id" class="gx-cloud__select gx-cloud__select--full" @change="changeGroupId">
              <option value="">不加入分组</option>
              <option v-for="g in groupList" :key="g.id" :value="g.id">{{ g.name }}</option>
            </select>
          </div>
          <div class="gx-cloud__field" v-if="importInfo.group_id">
            <label class="gx-cloud__label">加入子分组：</label>
            <select v-model="importInfo.child_group_id" class="gx-cloud__select gx-cloud__select--full">
              <option value="">不加入子分组</option>
              <option v-for="g in child_groupList" :key="g.id" :value="g.id">{{ g.name }}</option>
            </select>
          </div>
          <div class="gx-cloud__field"  v-if="importInfo.source_web===2">
            <label class="gx-cloud__label">商品（1688 链接）：</label>
            <textarea v-model="importInfo.produceLinks" class="gx-cloud__textarea" rows="8" placeholder="请输入1688商品链接，每个商品需换行"></textarea>
          </div>
          <div class="gx-cloud__field" v-else>
            <label class="gx-cloud__label">商品（zip 压缩包）：</label>
            <div class="gx-cloud__upload-row">
              <button class="gx-cloud__btn gx-cloud__btn--primary" :disabled="imLoading" @click="handleUpload">
                {{ imLoading ? '文件解析中...' : '上传' }}
              </button>
              <input ref="zipInput" type="file" accept=".zip" style="display: none" @change="handleZipChange" />
            </div>
            <div v-if="zipFileName && !imLoading" class="gx-cloud__upload-info">
              从【{{ zipFileName }}】中获取到 <b class="gx-cloud__gold">{{ importInfo.products.length || 0 }}</b> 个商品，将分为 <b class="gx-cloud__gold">{{ batchNum }}</b> 个批次进行导入，单个批次最多 {{ importSize }} 条。
              <div class="gx-cloud__dim">优先文件 1.5M 大小一个批次，可能超过 {{ batchNum }} 个批次上传。</div>
              <div v-if="upLoading">当前进度：{{ importInfo.page }}/{{ batchNum }}。</div>
            </div>
          </div>

        </div>
        <div class="gx-cloud__modal-foot">
          <button class="gx-cloud__btn" @click="importShow = false">取消</button>
          <button class="gx-cloud__btn gx-cloud__btn--primary" :disabled="upLoading" @click="handleImport">
            {{ upLoading ? (upErr ? '继续导入...' : '导入中...') : (upErr ? '继续导入' : '确定导入') }}
          </button>
        </div>
      </div>
    </div>

    <!-- 弹窗：铺货到店铺 -->
    <div v-if="distributeShow" class="gx-cloud__modal" @click.self="distributeShow = false">
      <div class="gx-cloud__modal-box gx-cloud__modal-box--lg gx-cloud__modal-box--dist">
        <div class="gx-cloud__modal-head">
          <span class="gx-cloud__modal-title">铺货到店铺（只显示授权正常的店铺）</span>
          <button class="gx-cloud__modal-close" @click="distributeShow = false">✕</button>
        </div>
        <div class="gx-cloud__modal-body">
          <div class="gx-cloud__shop-tabs">
            <button class="gx-cloud__shop-tab" :class="{ 'gx-cloud__shop-tab--on': cloudShopTab === 'douyin' }" @click="cloudShopTab = 'douyin'">抖店 ({{ cloudShopListByType.douyin.length }})</button>
            <button class="gx-cloud__shop-tab" :class="{ 'gx-cloud__shop-tab--on': cloudShopTab === 'wechat' }" @click="cloudShopTab = 'wechat'">微信小店 ({{ cloudShopListByType.wechat.length }})</button>
          </div>
          <div class="gx-cloud__dist-checkall" @click="handleShopCheckAll(cloudShopTab, !cloudCheckAll(cloudShopTab))">
            <span class="gx-cloud__check" :class="{ 'gx-cloud__check--on': cloudCheckAll(cloudShopTab) }">
              <svg v-if="cloudCheckAll(cloudShopTab)" width="9" height="9" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#FFFFFF" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" /></svg>
            </span>
            <span>全选</span>
          </div>
          <div class="gx-cloud__shop-panel">
            <div class="gx-cloud__shop-list">
              <div
                v-for="s in cloudShopListByType[cloudShopTab]"
                :key="s.shop_id"
                class="gx-cloud__shop-item"
                :class="{ 'gx-cloud__shop-item--on': cloudSelectedShopIds.includes(s.shop_id) }"
                @click="toggleCloudShop(s.shop_id)"
              >
                <span class="gx-cloud__check" :class="{ 'gx-cloud__check--on': cloudSelectedShopIds.includes(s.shop_id) }">
                  <svg v-if="cloudSelectedShopIds.includes(s.shop_id)" width="9" height="9" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#FFFFFF" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" /></svg>
                </span>
                <span class="gx-cloud__shop-avatar">{{ (s.shop_name || '').slice(0, 1) }}</span>
                <span class="gx-cloud__shop-name" :title="s.shop_name">{{ s.shop_name }}</span>
              </div>
              <div v-if="!cloudShopListByType[cloudShopTab].length" class="gx-cloud__empty">暂无{{ cloudShopTab === 'douyin' ? '抖店' : '微信小店' }}</div>
            </div>
          </div>
        </div>
        <div class="gx-cloud__modal-foot">
          <button class="gx-cloud__btn" @click="distributeShow = false">取消</button>
          <button class="gx-cloud__btn gx-cloud__btn--primary" :disabled="cloudDistributeLoading || !cloudSelectedShopIds.length" @click="submitCloudDistribute">
            {{ cloudDistributeLoading ? '铺货中...' : '确定铺货（' + cloudSelectedShopIds.length + '）' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 弹窗：SKU替换（以图搜款） -->
    <div v-if="imageSearchShow" class="gx-cloud__modal gx-cloud__modal--wide" @click.self="imageSearchShow = false">
      <div class="gx-cloud__modal-box gx-cloud__modal-box--xl">
        <div class="gx-cloud__modal-head">
          <span class="gx-cloud__modal-title">{{ replace_title }}</span>
          <button class="gx-cloud__modal-close" @click="handleCancelImageSearch">✕</button>
        </div>
        <div class="gx-cloud__modal-body gx-cloud__modal-body--sku-replace over-hide">
          <div class="gx-cloud__sku-replace-filter">
            <div class="gx-cloud__sku-filter-strategies">
              <span class="gx-cloud__search-strategy" :class="{ 'gx-cloud__search-strategy--on': strategyType === 1 }" @click="changeStrategy(1)">优先策略</span>
              <span class="gx-cloud__search-strategy" :class="{ 'gx-cloud__search-strategy--on': strategyType === 2 }" @click="changeStrategy(2)">默认策略</span>
            </div>
            <div class="gx-cloud__sku-filter-head">
              <span class="gx-cloud__sku-filter-title">过滤条件</span>
              <button class="gx-cloud__op" @click="filterVisible = !filterVisible">{{ filterVisible ? '收起 ▲' : '展开 ▼' }}</button>
            </div>
            <div v-if="filterVisible" class="gx-cloud__filter-panel gx-cloud__filter-panel--sku-replace">
              <div v-for="group in filterOptions" :key="group.key" class="gx-cloud__filter-group">
                <span class="gx-cloud__filter-group-title">{{ group.title }}：</span>
                <span
                  v-for="opt in group.options"
                  :key="opt.value"
                  class="gx-cloud__filter-tag"
                  :class="{ 'gx-cloud__filter-tag--on': pendingFilters.findIndex(i => i.value == opt.value) > -1 }"
                  @click="changeFilter(opt)"
                >{{ opt.label }}</span>
              </div>
              <div class="gx-cloud__filter-actions">
                <button class="gx-cloud__op" @click="handleClearAllFilters">全部清空</button>
                <button class="gx-cloud__op gx-cloud__op--primary" @click="handleApplyFilters">应用</button>
              </div>
            </div>
          </div>
          <div class="gx-cloud__sku-box">
            <!-- 左侧：待搜商品列表 -->
            <div class="gx-cloud__sku-left">
              <div class="gx-cloud__sku-filters">
                <select v-model="skuGroupId" class="gx-cloud__select" @change="searchSkuGroupReplaceList">
                  <option value="">全部分组</option>
                  <option v-for="g in groupList" :key="g.id" :value="g.id">{{ g.name }}</option>
                </select>
                <select v-model="skuStatusValue" class="gx-cloud__select" @change="searchSkuReplaceList">
                  <option value="">全部状态</option>
                  <option v-for="(v, k) in skuStatus" :key="k" :value="v.value">{{ v.label }}</option>
                </select>
                <select v-model="skuChildGroupId" class="gx-cloud__select" @change="searchSkuReplaceList">
                  <option value="">全部子分组</option>
                  <option v-for="g in sku_child_groupList" :key="g.id" :value="g.id">{{ g.name }}</option>
                </select>
                <select v-model="appraisalStatusValue" class="gx-cloud__select" @change="searchSkuReplaceList">
                  <option value="">全部检测</option>
                  <option v-for="(v, k) in appraisal_status" :key="k" :value="v.value">{{ v.label }}</option>
                </select>
                <select v-model="skuIsSkuMiss" class="gx-cloud__select" @change="searchSkuReplaceList">
                  <option value="">是否缺少sku图</option>
                  <option value="1">不缺sku图</option>
                  <option value="2">缺少sku图</option>
                </select>
                <select v-model="skuMarkStatusValue" class="gx-cloud__select" @change="searchSkuReplaceList">
                  <option value="">标记状态</option>
                  <option v-for="(v, k) in skuMarkStatus" :key="k" :value="v.value">{{ v.label }}</option>
                </select>
              </div>
              <div class="gx-cloud__sku-products">
                <div
                  v-for="(item, index) in imageSearchList"
                  :key="item.id"
                  class="gx-cloud__sku-item"
                  :class="{ 'gx-cloud__sku-item--on': currentSearchProduct && currentSearchProduct.id === item.id, 'gx-cloud__sku-item--done': replacedProductIds.includes(item.id) }"
                  @click="handleSelectSearchProduct(item)"
                >
                  <span class="gx-cloud__sku-thumb"><img v-if="item.main_image" :src="item.main_image" alt="" /></span>
                  <div class="gx-cloud__sku-item-body">
                    <div class="gx-cloud__sku-item-title" :title="item.title">{{ item.title }}</div>
                    <div class="gx-cloud__sku-item-meta"><span class="gx-cloud__gold">¥{{ item.price }}</span><span v-if="item.updated_at_text" class="gx-cloud__dim">{{ item.updated_at_text }}</span></div>
                    <div class="gx-cloud__sku-item-meta">
                      <span :class="(aiMarkMode ? skuMarkStatusCls(item.sku_mark_status): skuStatusCls(item.sku_status))">{{aiMarkMode ? skuMarkStatusLabel(item.sku_mark_status) : skuStatusLabel(item.sku_status)}}</span>
                      <button v-if="(aiMarkMode ? item.sku_mark_status || 1 : item.sku_status) == 1" class="gx-cloud__op" @click.stop="aiMarkMode ? handleProductMarkNotFound(item,index) : handleMarkNotFound(item,index)">找不到关联商品</button>
                      <button v-if="(aiMarkMode ? item.sku_mark_status || 1 : item.sku_status) == 3" class="gx-cloud__op" @click.stop="aiMarkMode ? handleProductMarkNotFoundCancel(item,index) : handleCancelNotFound(item,index)">{{ aiMarkMode ? '设为未标记' : '设为待替换' }}</button>
                    </div>
                  </div>
                </div>
                <div v-if="!imageSearchList.length" class="gx-cloud__empty">暂无商品</div>
              </div>
              <div class="gx-cloud__sku-pagination">
                <sku-list-pagination :total="skuPage.total" :page="skuPage.page" :limit="skuPage.limit" @pagination="handleSkuPagination" />
              </div>
            </div>
            <!-- 右侧：当前商品SKU + 搜索结果 -->
            <div class="gx-cloud__sku-right">
              <div v-if="currentSearchProduct" class="gx-cloud__sku-detail">
                <div class="gx-cloud__sku-detail-head">
                  <div class="gx-cloud__sku-detail-title" :title="currentSearchProduct.title">{{ currentSearchProduct.title }}</div>
                  <button class="gx-cloud__op" @click="skuVisible = !skuVisible">{{ skuVisible ? '收起' : '展开' }}</button>
                </div>
                <div v-if="skuVisible" class="gx-cloud__sku-detail-body">
                  <div v-if="currentProductDetail && currentProductDetail.skus && currentProductDetail.skus.length">
                    <div v-for="(sku, i) in currentProductDetail.skus" :key="i" class="gx-cloud__sku-line">
                      <span class="gx-cloud__dim">{{ sku.attributes_text || '默认规格' }}</span>
                      <span class="gx-cloud__gold">¥{{ sku.price }}</span>
                    </div>
                  </div>
                  <div v-else class="gx-cloud__dim">暂无SKU详细信息</div>
                </div>
              </div>

              <div class="gx-cloud__search-panel">
                <div class="gx-cloud__search-head">
                  <div class="gx-cloud__search-title">
                    <span class="gx-cloud__search-count">1688相似商品 <b v-if="imageSearchResult.length">(共 {{ imageSearchResult.length }} 条)</b></span>
                  </div>
                  <div class="gx-cloud__search-tools">
                    <select v-model="priceSort" class="gx-cloud__select" @change="changePriceSort">
                      <option value="">排序</option>
                      <option value="price_desc">价格从高到低</option>
                      <option value="price_asc">价格从低到高</option>
                    </select>
                  </div>
                </div>

                <div class="gx-cloud__search-results">
                  <div v-for="(r, i) in imageSearchResult" :key="i" class="gx-cloud__result" :class="{ 'gx-cloud__result--replaced': currentSearchProduct && replacedTargetMap[currentSearchProduct.id] === r.offer_id }">
                    <div class="gx-cloud__result-img"><img :src="r.image" alt="" /><span v-if="currentSearchProduct && replacedTargetMap[currentSearchProduct.id] === r.offer_id" class="gx-cloud__result-badge">已替换</span></div>
                    <div class="gx-cloud__result-info">
                      <div class="gx-cloud__result-title" :title="r.title">{{ r.title }}</div>
                      <div class="gx-cloud__result-price"><span class="gx-cloud__gold">¥{{ r.price }}</span><span v-if="r.consign_price && r.consign_price !== r.price" class="gx-cloud__consign">代发:{{ r.consign_price }}</span></div>
                      <div v-if="r.tags && r.tags.length" class="gx-cloud__result-tags"><span v-for="(tag, ti) in r.tags" :key="ti" v-if="tag.enable" class="gx-cloud__mini-tag">{{ tag.text }}</span></div>
                    </div>
                    <div class="gx-cloud__result-actions">
                      <button class="gx-cloud__op gx-cloud__op--primary" @click="handleUseResult(r)">{{ aiMarkMode ? '标记' : '替换' }}</button>
                      <button class="gx-cloud__op" @click="handleViewProduct(r)">查看</button>
                    </div>
                  </div>
                  <div v-if="!imageSearchResult.length && !imageSearchLoading && currentSearchProduct" class="gx-cloud__empty">未找到相似商品</div>
                  <div v-if="!currentSearchProduct" class="gx-cloud__empty">请选择左侧商品进行搜款</div>
                  <div v-if="imageSearchLoading" class="gx-cloud__empty">搜款中...</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="gx-cloud__modal-foot">
          <span class="gx-cloud__shop-count"> {{ aiMarkMode ? '已标记' : '已替换' }}: {{getReplacedCount()}} / {{imageSearchList.length}}</span>
          <span v-if="aiReplace || aiMarkMode" class="gx-cloud__ai-tip">
            <template v-if="aiOperationPricesLoading">会员权益价格加载中...</template>
            <template v-else-if="aiOperationPricesError">会员权益价格加载失败</template>
            <template v-else>{{ aiOperationPriceText }}</template>
            &nbsp;当前AI算力：{{ formatPrice(power_num, 0) }}.{{ formatPrice(power_num, 1) }}
          </span>
          <button v-if="aiReplace || aiMarkMode" class="gx-cloud__btn" @click="searchSkuReplaceList">刷新</button>
          <button class="gx-cloud__btn" @click="handleCancelImageSearch">关闭</button>
        </div>
      </div>
    </div>

    <!-- 弹窗：批量替换指定链接SKU -->
    <div v-if="batchLinkVisible" class="gx-cloud__modal gx-cloud__modal--wide" @click.self="batchLinkVisible = false">
      <div class="gx-cloud__modal-box gx-cloud__modal-box--xl">
        <div class="gx-cloud__modal-head">
          <span class="gx-cloud__modal-title">批量替换指定链接SKU</span>
          <button class="gx-cloud__modal-close" @click="handleCancelImageSearch">✕</button>
        </div>
        <div class="gx-cloud__modal-body over-hide">
          <div class="gx-cloud__sku-box">
            <div class="gx-cloud__sku-left">
              <div class="gx-cloud__sku-filters">
                <select v-model="skuGroupId" class="gx-cloud__select" @change="searchSkuGroupReplaceList">
                  <option value="">全部分组</option>
                  <option v-for="g in groupList" :key="g.id" :value="g.id">{{ g.name }}</option>
                </select>
                <select v-model="skuStatusValue" class="gx-cloud__select" @change="searchSkuReplaceList">
                  <option value="">全部状态</option>
                  <option v-for="(v, k) in skuStatus" :key="k" :value="v.value">{{ v.label }}</option>
                </select>
                <select v-model="skuChildGroupId" class="gx-cloud__select" @change="searchSkuReplaceList">
                  <option value="">全部子分组</option>
                  <option v-for="g in sku_child_groupList" :key="g.id" :value="g.id">{{ g.name }}</option>
                </select>
                <select v-model="appraisalStatusValue" class="gx-cloud__select" @change="searchSkuReplaceList">
                  <option value="">全部检测</option>
                  <option v-for="(v, k) in appraisal_status" :key="k" :value="v.value">{{ v.label }}</option>
                </select>
                <select v-model="skuIsSkuMiss" class="gx-cloud__select" @change="searchSkuReplaceList">
                  <option value="">是否缺少sku图</option>
                  <option value="1">不缺sku图</option>
                  <option value="2">缺少sku图</option>
                </select>
                <select v-model="skuMarkStatusValue" class="gx-cloud__select" @change="searchSkuReplaceList">
                  <option value="">标记状态</option>
                  <option v-for="(v, k) in skuMarkStatus" :key="k" :value="v.value">{{ v.label }}</option>
                </select>
              </div>
              <div class="gx-cloud__sku-products">
                <div
                  v-for="(item, index) in imageSearchList"
                  :key="item.id"
                  class="gx-cloud__sku-item"
                  :class="{ 'gx-cloud__sku-item--on': currentSearchProduct && currentSearchProduct.id === item.id, 'gx-cloud__sku-item--done': replacedProductIds.includes(item.id) }"
                  @click="handleSelectLinkProduct(item, index)"
                >
                  <span class="gx-cloud__sku-thumb"><img v-if="item.main_image" :src="item.main_image" alt="" /></span>
                  <div class="gx-cloud__sku-item-body">
                    <div class="gx-cloud__sku-item-title" :title="item.title">{{ item.title }}</div>
                    <div class="gx-cloud__sku-item-meta"><span class="gx-cloud__gold">¥{{ item.price }}</span><span v-if="item.updated_at_text" class="gx-cloud__dim">{{ item.updated_at_text }}</span></div>
                    <div class="gx-cloud__sku-item-meta"><span :class="skuStatusCls(item.sku_status)">{{ skuStatusLabel(item.sku_status) }}</span></div>
                  </div>
                </div>
                <div v-if="!imageSearchList.length" class="gx-cloud__empty">暂无商品</div>
              </div>
              <div class="gx-cloud__sku-pagination">
                <sku-list-pagination :total="skuPage.total" :page="skuPage.page" :limit="skuPage.limit" @pagination="handleSkuPagination" />
              </div>
            </div>
            <div class="gx-cloud__sku-right">
              <div v-if="currentSearchProduct" class="gx-cloud__sku-detail">
                <div class="gx-cloud__sku-detail-head">
                  <div class="gx-cloud__sku-detail-title" :title="currentSearchProduct.title">{{ currentSearchProduct.title }}</div>
                  <button class="gx-cloud__op" @click="skuVisible = !skuVisible">{{ skuVisible ? '收起' : '展开' }}</button>
                </div>
                <div v-if="skuVisible" class="gx-cloud__sku-detail-body">
                  <div v-if="currentProductDetail && currentProductDetail.skus && currentProductDetail.skus.length">
                    <div v-for="(sku, i) in currentProductDetail.skus" :key="i" class="gx-cloud__sku-line">
                      <span class="gx-cloud__dim">{{ sku.attributes_text || '默认规格' }}</span>
                      <span class="gx-cloud__gold">¥{{ sku.price }}</span>
                    </div>
                  </div>
                  <div v-else class="gx-cloud__dim">暂无SKU详细信息</div>
                </div>
              </div>
              <div class="gx-cloud__search-panel">
                <div class="gx-cloud__search-head">
                  <div class="gx-cloud__search-title">AI替换备选链接</div>
                </div>
                <div class="gx-cloud__link-box">
                  <div class="gx-cloud__link-input">
                    <span class="gx-cloud__dim">商品链接：</span>
                    <input v-model="replaceLink" class="gx-cloud__input gx-cloud__input--full" placeholder="请输入1688商品链接" />
                    <button class="gx-cloud__btn gx-cloud__btn--primary" :disabled="lrLoading" @click="submitBatchLinkReplace">{{ lrLoading ? '替换中...' : '替换' }}</button>
                  </div>
                  <div v-for="(item, i) in alternativeLinks" :key="i" class="gx-cloud__link-item">
                    <button class="gx-cloud__op" :disabled="item.is_current" @click="replaceLink = item.backup_url">{{ item.backup_url }}</button>
                    <a :href="item.backup_url" target="_blank" rel="noopener noreferrer" class="gx-cloud__view-link">查看</a>
                  </div>
                  <div v-if="!alternativeLinks.length" class="gx-cloud__empty">暂无备选链接</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="gx-cloud__modal-foot">
          <button class="gx-cloud__btn" @click="handleCancelImageSearch">关闭</button>
        </div>
      </div>
    </div>

    <!-- 弹窗：替换商品SKU（单个指定链接） -->
    <div v-if="linkReplaceVisible" class="gx-cloud__modal" @click.self="linkReplaceVisible = false">
      <div class="gx-cloud__modal-box">
        <div class="gx-cloud__modal-head">
          <span class="gx-cloud__modal-title">替换商品SKU：{{ linkReplaceForm.title }}</span>
          <button class="gx-cloud__modal-close" @click="linkReplaceVisible = false">✕</button>
        </div>
        <div class="gx-cloud__modal-body">
          <div class="gx-cloud__field">
            <label class="gx-cloud__label">商品来源：</label>
            <span>1688</span>
          </div>
          <div class="gx-cloud__field">
            <label class="gx-cloud__label">AI替换备选链接：</label>
            <div v-for="(item, i) in (linkReplaceForm.replaceable || [])" :key="i" class="gx-cloud__link-item">
              <button class="gx-cloud__op" :disabled="item.is_current" @click="linkReplaceForm.produceLink = item.backup_url">{{ item.backup_url }}</button>
              <a :href="item.backup_url" target="_blank" rel="noopener noreferrer" class="gx-cloud__view-link">查看</a>
            </div>
          </div>
          <div class="gx-cloud__field">
            <label class="gx-cloud__label">商品链接：</label>
            <input v-model="linkReplaceForm.produceLink" class="gx-cloud__input gx-cloud__input--full" placeholder="请输入1688商品链接" />
          </div>
        </div>
        <div class="gx-cloud__modal-foot">
          <button class="gx-cloud__btn" @click="linkReplaceVisible = false">取消</button>
          <button class="gx-cloud__btn gx-cloud__btn--primary" :disabled="lrLoading" @click="submitLinkReplace">{{ lrLoading ? '替换中...' : '确定' }}</button>
        </div>
      </div>
    </div>

    <!-- 弹窗：SKU替换记录 -->
    <div v-if="replaceLogShow" class="gx-cloud__modal" @click.self="replaceLogShow = false">
      <div class="gx-cloud__modal-box gx-cloud__modal-box--lg">
        <div class="gx-cloud__modal-head">
          <span class="gx-cloud__modal-title">SKU替换记录</span>
          <button class="gx-cloud__modal-close" @click="replaceLogShow = false">✕</button>
        </div>
        <div class="gx-cloud__modal-body">
          <div class="gx-cloud__tip">点击链接可查看详情</div>
          <div class="gx-cloud__table gx-cloud__table--plain">
            <table>
              <thead>
                <tr>
                  <th>时间</th>
                  <th>链接</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(r, i) in replaceLogList" :key="i">
                  <td class="gx-cloud__mono">{{ r.created_at_text || r.created_at || '--' }}</td>
                  <td><a :href="r.url" target="_blank" rel="noopener noreferrer" class="gx-cloud__link">{{ r.url }}</a></td>
                </tr>
                <tr v-if="!replaceLogList.length">
                  <td :colspan="2" class="gx-cloud__empty">暂无替换记录</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="gx-cloud__pager" v-if="replaceLogPage.total > 0">
            <span class="gx-cloud__pager-total">共 {{ replaceLogPage.total }} 条</span>
            <div class="gx-cloud__pager-btns">
              <button class="gx-cloud__page gx-cloud__page--arrow" :disabled="replaceLogPage.page <= 1" @click="getReplaceLogPage(replaceLogPage.page - 1)">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M7.5 2.5L4 6l3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" /></svg>
              </button>
              <button v-for="n in replaceLogPages" :key="n" class="gx-cloud__page" :class="{ 'gx-cloud__page--on': n === replaceLogPage.page }" @click="getReplaceLogPage(n)">{{ n }}</button>
              <button class="gx-cloud__page gx-cloud__page--arrow" :disabled="replaceLogPage.page >= replaceLogTotalPages" @click="getReplaceLogPage(replaceLogPage.page + 1)">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M4.5 2.5L8 6l-3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" /></svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗：标题替换记录 -->
    <div v-if="replaceTitleLogShow" class="gx-cloud__modal" @click.self="replaceTitleLogShow = false">
      <div class="gx-cloud__modal-box gx-cloud__modal-box--lg">
        <div class="gx-cloud__modal-head">
          <span class="gx-cloud__modal-title">标题替换记录</span>
          <button class="gx-cloud__modal-close" @click="replaceTitleLogShow = false">✕</button>
        </div>
        <div class="gx-cloud__modal-body">
          <div class="gx-cloud__table gx-cloud__table--plain">
            <table>
              <thead>
                <tr>
                  <th>时间</th>
                  <th>标题</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(r, i) in replaceTitleLogList" :key="i">
                  <td class="gx-cloud__mono">{{ r.updated_at || '--' }}</td>
                  <td class="gx-cloud__log-group">
                    <div>原：{{ r.title }}</div>
                    <div class="gx-cloud__log-ai">AI：{{ r.new_title }}</div>
                    <div v-if="r.update_title">改：{{ r.update_title }}</div>
                  </td>
                </tr>
                <tr v-if="!replaceTitleLogList.length">
                  <td :colspan="2" class="gx-cloud__empty">暂无替换记录</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗：各省首件运费 -->
    <div v-if="freightDetailVisible" class="gx-cloud__modal" @click.self="freightDetailVisible = false">
      <div class="gx-cloud__modal-box gx-cloud__modal-box--sm">
        <div class="gx-cloud__modal-head">
          <span class="gx-cloud__modal-title">各省首件运费</span>
          <button class="gx-cloud__modal-close" @click="freightDetailVisible = false">✕</button>
        </div>
        <div class="gx-cloud__modal-body">
          <div class="gx-cloud__table gx-cloud__table--plain">
            <table>
              <thead>
                <tr>
                  <th>发往省份</th>
                  <th>首件运费</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(r, i) in freightDetails" :key="i">
                  <td>{{ r.province_name || '--' }}</td>
                  <td>{{ r.destination_freight_status === 'calculated' ? r.destination_freight + ' 元' : '未知' }}</td>
                </tr>
                <tr v-if="!freightDetails.length">
                  <td :colspan="2" class="gx-cloud__empty">暂无运费数据</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗：批量编辑云商品 -->
    <cloud-product-batch-edit
      ref="cloudProductBatchEdit"
      :visible="cloudEditShow"
      :title="cloudEditMode === 'batch' ? '批量编辑云商品' : '编辑云商品'"
      :count="cloudEditUseRemoteList ? cloudEditPage.total : cloudEditSourceList.length"
      @close="closeCloudEdit"
    />
    <div v-if="batchTimeTagShow" class="gx-cloud__modal" @click.self="batchTimeTagShow = false">
      <div class="gx-cloud__modal-box gx-cloud__modal-box--sm">
        <div class="gx-cloud__modal-head">
          <span class="gx-cloud__modal-title">设置时效标签（{{ timeTagTargetIds.length }}个商品）</span>
          <button class="gx-cloud__modal-close" @click="batchTimeTagShow = false">✕</button>
        </div>
        <div class="gx-cloud__modal-body">
          <div class="gx-cloud__field gx-cloud__time-tag-setting">
            <label class="gx-cloud__label">月份时效</label>
            <div class="gx-cloud__time-tag-options">
              <button
                v-for="month in monthTagOptions"
                :key="month"
                type="button"
                class="gx-cloud__time-tag-filter-btn"
                :class="{ 'gx-cloud__time-tag-filter-btn--on': batchMonthTags.includes(month) }"
                @click="toggleBatchTimeTag('month', month)"
              >{{ month }}</button>
            </div>
          </div>
          <div class="gx-cloud__field gx-cloud__time-tag-setting">
            <label class="gx-cloud__label">季节时效</label>
            <div class="gx-cloud__time-tag-options">
              <button
                v-for="season in seasonTagOptions"
                :key="season"
                type="button"
                class="gx-cloud__time-tag-filter-btn gx-cloud__time-tag-filter-btn--season"
                :class="{ 'gx-cloud__time-tag-filter-btn--on': batchSeasonTags.includes(season) }"
                @click="toggleBatchTimeTag('season', season)"
              >{{ season }}</button>
            </div>
          </div>
          <div class="gx-cloud__dim">提交值会覆盖所选商品的现有标签；不选择即清空对应标签。</div>
        </div>
        <div class="gx-cloud__modal-foot">
          <button class="gx-cloud__btn" :disabled="batchTimeTagLoading" @click="batchTimeTagShow = false">取消</button>
          <button class="gx-cloud__btn gx-cloud__btn--primary" :disabled="batchTimeTagLoading" @click="submitBatchTimeTags">
            {{ batchTimeTagLoading ? '保存中...' : '确定' }}
          </button>
        </div>
      </div>
    </div>
    <!--弹窗：查看标记货源-->
    <div v-if="productMarkViewShow" class="gx-cloud__modal" @click.self="productMarkViewShow = false">
      <div class="gx-cloud__modal-box gx-cloud__modal-box--xl">
        <div class="gx-cloud__modal-head">
          <span class="gx-cloud__modal-title">查看标记货源</span>
          <button class="gx-cloud__modal-close" @click="productMarkViewShow = false">✕</button>
        </div>
        <div class="gx-cloud__modal-body">
          <div class="gx-cloud__table gx-cloud__table--plain">
            <table>
              <thead>
              <tr>
                <th>图片</th>
                <th>标题</th>
                <th>商品ID</th>
                <th>价格</th>
                <th>商家名称</th>
                <th>标记时间</th>
                <th>操作</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(r, i) in productMarkViewItems" :key="i">
                <td class="gx-cloud__mono">
                  <el-image v-if="r.image" :src="r.image" fit="cover" style="width:65px;height:65px" :preview-src-list="[r.image]"></el-image><span v-else>-</span>
                </td>
                <td class="gx-cloud__mono">{{ r.title || '--' }}</td>
                <td class="gx-cloud__mono">{{ r.offer_id || '--' }}</td>
                <td class="gx-cloud__mono">{{ r.price || '--' }}</td>
                <td class="gx-cloud__mono">{{ r.shop_name || '--' }}</td>
                <td class="gx-cloud__mono">{{ r.mark_at_text || '--' }}</td>
                <td>
                  <a :href="`https://detail.1688.com/offer/${r.offer_id}.html`" target="_blank" rel="noopener noreferrer" class="gx-cloud__link" v-if="r.offer_id">查看商品</a>
                  <span v-else>-</span>
                </td>
              </tr>
              <tr v-if="!productMarkViewItems.length">
                <td :colspan="7" class="gx-cloud__empty">暂无标记</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- 图片选择弹窗 -->
    <image-source-dialog
      :visible.sync="imageSourceDialog.visible"
      :title="imageSourceDialog.title"
      :action="uploadAction"
      :headers="uploadHeaders"
      :multiple="imageSourceDialog.multiple"
      :existing-urls="imageSourceDialog.existingUrls"
      :direct-upload="true"
      :sts-action="ossStsAction"
      @select="handleImageSourceSelect"
    />

    <!-- 弹窗：设置分组 -->
    <div v-if="batchGroupShow" class="gx-cloud__modal" @click.self="batchGroupShow = false">
      <div class="gx-cloud__modal-box gx-cloud__modal-box--sm">
        <div class="gx-cloud__modal-head">
          <span class="gx-cloud__modal-title">设置商品分组</span>
          <button class="gx-cloud__modal-close" @click="batchGroupShow = false">✕</button>
        </div>
        <div class="gx-cloud__modal-body">
          <div class="gx-cloud__batch-count">已选商品：{{ cloudSelectedList.length }} 个</div>
          <div class="gx-cloud__field">
            <label class="gx-cloud__label">选择分组</label>
            <select v-model="batchGroupId" class="gx-cloud__select gx-cloud__select--full" @change="changeSetGroupId">
              <option value="0">不加入分组</option>
              <option v-for="g in groupList" :key="g.id" :value="g.id">{{ g.name }}</option>
            </select>
          </div>
          <div class="gx-cloud__field" v-if="batchGroupId != 0">
            <label class="gx-cloud__label">选择子分组</label>
            <select v-model="batchChildGroupId" class="gx-cloud__select gx-cloud__select--full">
              <option value="0">不加入分组</option>
              <option v-for="g in set_child_groupList" :key="g.id" :value="g.id">{{ g.name }}</option>
            </select>
          </div>
          <div class="gx-cloud__dim">选择"不加入分组"将去除商品的当前分组</div>
        </div>
        <div class="gx-cloud__modal-foot">
          <button class="gx-cloud__btn" @click="batchGroupShow = false">取消</button>
          <button class="gx-cloud__btn gx-cloud__btn--primary" :disabled="batchGroupLoading" @click="submitBatchSetGroup">
            {{ batchGroupLoading ? '设置中...' : '确定' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 弹窗：新增/编辑分组 -->
    <div v-if="groupFormShow" class="gx-cloud__modal" @click.self="groupFormShow = false">
      <div class="gx-cloud__modal-box gx-cloud__modal-box--sm">
        <div class="gx-cloud__modal-head">
          <span class="gx-cloud__modal-title">{{ groupFormEdit ? '编辑分组' : '新增分组' }}</span>
          <button class="gx-cloud__modal-close" @click="groupFormShow = false">✕</button>
        </div>
        <div class="gx-cloud__modal-body">
          <div class="gx-cloud__field" v-if="!groupFormEdit && groupForm.grade === 2">
            <label class="gx-cloud__label">主分组 <i class="gx-cloud__req">*</i></label>
            <select v-model="groupForm.parent_id" class="gx-cloud__select gx-cloud__select--full">
              <option v-for="g in groupList" :key="g.id" :value="g.id">{{ g.name }}</option>
            </select>
          </div>
          <div class="gx-cloud__field">
            <label class="gx-cloud__label">分组名称 <i class="gx-cloud__req">*</i></label>
            <input v-model="groupForm.name" class="gx-cloud__input gx-cloud__input--full" maxlength="50" placeholder="请输入分组名称" />
          </div>
          <div class="gx-cloud__field" v-if="!groupFormEdit && groupForm.grade === 1">
            <label class="gx-cloud__label">首个子分组 <i class="gx-cloud__req">*</i></label>
            <input v-model="groupForm.child_name" class="gx-cloud__input gx-cloud__input--full" maxlength="50" placeholder="请输入首个子分组名称" />
          </div>
          <div class="gx-cloud__field">
            <label class="gx-cloud__label">排序</label>
            <input v-model.number="groupForm.sort" type="number" min="0" max="9999" class="gx-cloud__input gx-cloud__input--full" />
            <div class="gx-cloud__dim">按升序排列，数值越小排序越前</div>
          </div>
        </div>
        <div class="gx-cloud__modal-foot">
          <button class="gx-cloud__btn" @click="groupFormShow = false">取消</button>
          <button class="gx-cloud__btn gx-cloud__btn--primary" :disabled="groupFormLoading" @click="submitGroupForm">
            {{ groupFormLoading ? '保存中...' : '确定' }}
          </button>
        </div>
      </div>
    </div>
    <distribute-record-dialog :visible.sync="distributeRecordShow" :product="distributeRecordProduct" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import JSZip from 'jszip'
import common from '@/assets/js/utils/common.js'
import areaData from '@/assets/js/data/area.js'
import config from '@/assets/js/conf/config'
import GxLoading from '../../components/newUi/GxLoading.vue'
import PageSizeSelect from '../../components/newUi/PageSizeSelect.vue'
import gxLoading from '../../mixins/gxLoading'
import ImageSourceDialog from '../uc_product/components/ImageSourceDialog.vue'
import CloudProductBatchEdit from '../../components/cloudProductBatchEdit/CloudProductBatchEdit.vue'
import DistributeRecordDialog from './components/DistributeRecordDialog.vue'
import SkuListPagination from './components/SkuListPagination.vue'
import Pagination from "../../components/newUi/Pagination.vue";

const MAINLAND_PROVINCE_CODES = ['110000', '120000', '130000', '140000', '150000', '210000', '220000', '230000', '310000', '320000', '330000', '340000', '350000', '360000', '370000', '410000', '420000', '430000', '440000', '450000', '460000', '500000', '510000', '520000', '530000', '540000', '610000', '620000', '630000', '640000', '650000', '710000', '810000', '820000']
const MONTH_TAG_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
const SEASON_TAG_OPTIONS = ['春', '夏', '秋', '冬']

export default {
  name: 'NewCloudLibPage',
  components: { ImageSourceDialog, GxLoading, PageSizeSelect, CloudProductBatchEdit, DistributeRecordDialog, SkuListPagination, Pagination },
  mixins: [gxLoading],
  data() {
    return {
      tab: 0,
      userinfo: null,
      // 导入
      importList: [],
      importPage: { limit: 20, page: 1, total: 0 },
      importPageSizeOptions: [10, 20, 50, 100, 200],
      importLoading: false,
      importShow: false,
      importInfo: { products: [], source_method: '', source_web: 3, page: 1, group_id: '', child_group_id: '', produceLinks: '', startIndex: 0 },
      zipFileName: '',
      batchNum: 0,
      importSize: 100,
      imLoading: false,
      upLoading: false,
      upErr: false,
      sourceList: [{ value: 9, label: '星好货' }, { value: 3, label: 'TB' }, { value: 4, label: 'PDD' }, { value: 2, label: '1688' }, { value: 5, label: 'DY' }, { value: 6, label: 'WX' }],
      collectList: [{ value: 2, label: '万象' }, { value: 3, label: '老虎' }, { value: 6, label: '萤火虫' }, { value: 8, label: '大王' }],
      pdd_collectList: [{ value: 4, label: '极速' }, { value: 5, label: '晨飞' }, { value: 7, label: '星云' }, { value: 9, label: '大王' }, { value: 10, label: '兵哥哥' }, { value: 13, label: '豪哥' }],
      dy_collectList: [{ value: 11, label: '万象(json)' }],
      wx_collectList: [{ value: 12, label: '小店助手' }],
      // 云商品列表
      cloudList: [],
      cloudPage: { limit: 20, page: 1, total: 0 },
      cloudPageSizeOptions: [10, 20, 50, 100, 200, 1000, 2000],
      cloudSearch: {
        status: '', keyword: '', batch_no: '', source_product_id: '', platform_product_id: '',
        source_web: '', distribution_free_postage: '', freight_province_code: '',
        min_price: '', max_price: '', sku_status: '',sku_mark_status: '', ai_title_status: '',
        exclude_distributed: [], distribute_status: '', group_id: '', child_group_id: '', is_sku_miss: '',
        has_distribute_success: '', has_distribute_fail: '', has_distribute_ban: '', has_distribute_review_fail: '',
        month_tags: [], season_tags: []
      },
      monthTagOptions: MONTH_TAG_OPTIONS,
      seasonTagOptions: SEASON_TAG_OPTIONS,
      cloudStats: { total: 0, pending_count: 0, success_count: 0, fail_count: 0, duplicate_count: 0, offline_count: 0 },
      excludeSelect: '',
      excludeShopList: [],
      cloudSelectedList: [],
      productMarkViewShow: false,
      productMarkViewItems: [],
      productMarkViewLoading:false,
      distributeRecordShow: false,
      distributeRecordProduct: null,
      // 共享商品库
      shareList: [],
      sharePage: { limit: 20, page: 1, total: 0 },
      sharePageSizeOptions: [10, 20, 50, 100, 200],
      shareSearch: {
        batch_no: '', keyword: '', sku_status: '', distribution_free_postage: '',
        freight_province_code: '', min_price: '', max_price: '',
        exclude_distributed: [], distribute_status: '', group_id: '', child_group_id: ''
      },
      shareExcludeSelect: '',
      shareChildGroupList: [],
      shareSelectedList: [],
      // 铺货列表
      distributeList: [],
      distributePage: { limit: 20, page: 1, total: 0 },
      distributePageSizeOptions: [10, 20, 50, 100, 200],
      distributeSearch: { status: '', shop_id: '', keyword: '', shop_type: '', start_date: '', end_date: '' },
      distributeStats: { total: 0, distributed_count: 0, pending_count: 0, fail_count: 0, success_count: 0 },
      filterShopList: [],
      shopTypeList: [{ name: '抖店', shop_type: 1 }, { name: '微信', shop_type: 7 }],
      // 分组
      groupList: [],
      groupTableData: [],
      groupPage: { limit: 20, page: 1, total: 0 },
      groupSearch: { main_name: '', child_name: '' },
      child_groupList: [],
      groupLoading: false,
      groupExpandedParentId: null,
      groupChildrenData: [],
      groupChildrenLoading: false,
      groupChildrenPage: { limit: 50, page: 1, total: 0 },
      groupParentRequestId: 0,
      groupChildrenRequestId: 0,
      groupMoveLoading: {},
      groupForm: { id: null, name: '', child_name: '', grade: 1, parent_id: '', sort: 0 },
      groupFormEdit: false,
      groupFormShow: false,
      groupFormLoading: false,
      // 通用状态映射
      skuStatus: {
        1: { label: '待替换', value: 1, type: 'selected-tag' },
        2: { label: '已替换', value: 2, type: 'replaced-tag' },
        3: { label: '找不到', value: 3, type: 'notFond-tag' }
      },
      skuMarkStatus:{
        1:{label:'未标记',value:1,type:'selected-tag'},
        2:{label:'已标记',value:2,type:'replaced-tag'},
        3:{label:'找不到',value:3,type:'notFond-tag'}
      },
      aiTitleStatus: {
        1: { label: '待替换', value: 1, type: 'selected-tag' },
        2: { label: '已替换', value: 2, type: 'replaced-tag' },
        9: { label: '异常', value: 3, type: 'notFond-tag' }
      },
      appraisal_status: {
        3: { label: '有违规', value: 2, type: 'replaced-tag' },
        4: { label: '无违规', value: 3, type: 'notFond-tag' }
      },
      provinceOptions: MAINLAND_PROVINCE_CODES.map(value => ({ value, label: areaData.province_list[value] })),
      // 铺货
      distributeShow: false,
      shareDistributeMode: false,
      cloudShopList: [],
      cloudShopLoading: false,
      cloudSelectedShopIds: [],
      cloudShopTab: 'douyin',
      cloudShopSelect: '',
      cloudDistributeLoading: false,
      // 运费
      freightDetailVisible: false,
      freightDetails: [],
      // SKU替换（以图搜款）
      imageSearchShow: false,
      replace_title: 'SKU替换',
      aiReplace: false,
      aiMarkMode: false,
      power_num: 0,
      aiOperationPrices: { replace: null, mark: null },
      aiOperationPricesLoading: false,
      aiOperationPricesError: false,
      skuPage: { limit: 20, page: 1, total: 0 },
      skuLoading: false,
      imageSearchList: [],
      skuGroupId: '',
      skuChildGroupId: '',
      skuStatusValue: '',
      skuMarkStatusValue:'',
      appraisalStatusValue: '',
      skuIsSkuMiss: '',
      sku_child_groupList: [],
      currentSearchProduct: null,
      currentSearchProductIndex: -1,
      currentProductDetail: null,
      imageSearchLoading: false,
      imageSearchResult: [],
      imageSearchResultCopy: [],
      priceSort: '',
      skuVisible: false,
      searchFilters: [],
      pendingFilters: [],
      filterVisible: false,
      strategyType: '',//策略类型 1-优先策略 2-默认策略
      strategyCache:{},//策略缓存
      filterOptions: [
        { title: '发货时效', key: 'shipping', options: [
          { label: '当天发货', value: 'shipInToday' }, { label: '24小时发货', value: 'shipIn24Hours' }, { label: '48小时发货', value: 'shipIn48Hours' }] },
        { title: '揽收率', key: 'getRate', options: [
          { label: '24小时揽收率 <95%', value: 'getRate24HLv1' }, { label: '24小时揽收率 ≥95%', value: 'getRate24HLv2' }, { label: '24小时揽收率 ≥99%', value: 'getRate24HLv3' },
          { label: '48小时揽收率 <95%', value: 'getRate48HLv1' }, { label: '48小时揽收率 ≥95%', value: 'getRate48HLv2' }, { label: '48小时揽收率 ≥99%', value: 'getRate48HLv3' }] },
        { title: '退款率', key: 'refundRate', options: [
          { label: '品质退款率 ≤0.005%', value: 'rfdQualityRateLv1' }, { label: '品质退款率 ≤0.15%', value: 'rfdQualityRateLv2' }, { label: '品质退款率 ≤0.30%', value: 'rfdQualityRateLv3' }, { label: '品质退款率 >0.3%', value: 'rfdQualityRateLv4' },
          { label: '总退款率 ≤1%', value: 'rfdRateLv1' }, { label: '总退款率 ≤3%', value: 'rfdRateLv2' }, { label: '总退款率 ≤5%', value: 'rfdRateLv3' }, { label: '总退款率 >5%', value: 'rfdRateLv4' }] },
        { title: '服务保障', key: 'service', options: [
          { label: '7天无理由退换货', value: 'noReason7DReturn' }, { label: '实力商家', value: 'powerMerchant' }, { label: '认证工厂', value: 'certifiedFactory' }] },
        { title: '履约质量', key: 'quality', options: [
          { label: '综合体验分 5星', value: 'totalEpScoreLv1' }, { label: '综合体验分 4.5-5.0星', value: 'totalEpScoreLv2' }, { label: '综合体验分 4-4.5星', value: 'totalEpScoreLv3' }, { label: '综合体验分 4星以下', value: 'totalEpScoreLv4' }] },
        { title: '增值服务', key: 'addedService', options: [
          { label: '免费贊账', value: 'freeCredit' }, { label: '支持一件代发', value: 'isOnePsale' }, { label: '一件代发包邮', value: 'isOnePsaleFreePost' },
          { label: '支持抖音密文打单', value: 'dyCiphertext' }, { label: '支持快手密文打单', value: 'ksCiphertext' }, { label: '支持微信小店密文下单', value: 'wxCiphertext' },
          { label: '支持淘宝密文下单', value: 'tbCiphertext' }, { label: '支持拼多多密文下单', value: 'pddCiphertext' }, { label: '支持小红书密文下单', value: 'xhsCiphertext' }, { label: '支持京东密文下单', value: 'jdCiphertext' }] }
      ],
      selectedReplaceMap: {},
      replacedTargetMap: {},
      replacedProductIds: [],
      imageSearchCache: {},
      // 批量替换指定链接
      batchLinkVisible: false,
      alternativeLinks: [],
      replaceLink: '',
      lrLoading: false,
      // 单个指定链接替换
      linkReplaceVisible: false,
      linkReplaceForm: { title: '', productId: null, replaceable: [], produceLink: '' },
      // SKU替换记录
      replaceLogShow: false,
      replaceLogList: [],
      replaceLogPage: { limit: 10, page: 1, total: 0 },
      replaceLogItemId: null,
      // 标题替换记录
      replaceTitleLogShow: false,
      replaceTitleLogList: [],
      // 批量编辑
      cloudEditShow: false,
      cloudEditMode: 'single',
      cloudEditList: [],
      cloudEditSourceList: [],
      cloudEditCurrent: null,
      cloudEditForm: { id: null, title: '', main_images: [], three_four_images: [], white_images: [], detail_images: [], albb_attributes: '', skuSpecs: [], skus: [], skuValueImages: {} },
      cloudEditLoading: false,
      cloudEditSaving: false,
      cloudEditDirty: false,
      cloudEditUseRemoteList: false,
      cloudEditGroupId: '',
      cloudEditChildGroupId: '',
      cloudEditChildGroupList: [],
      cloudEditSkuStatus: '',
      cloudEditAppraisalStatus: '',
      cloudEditDistributeStatus: '',
      cloudEditPage: { limit: 10, page: 1, total: 0 },
      imageSourceDialog: { visible: false, title: '添加图片', multiple: true, existingUrls: [] },
      uploadAction: config.baseApi + '/merchant/shop/uploadImage',
      ossStsAction: config.baseApi + '/merchant/shop/ossUploadToken',
      // 设置分组
      batchGroupShow: false,
      batchGroupId: 0,
      batchChildGroupId: 0,
      set_child_groupList: [],
      batchGroupLoading: false,
      batchTimeTagShow: false,
      batchTimeTagLoading: false,
      batchMonthTags: [],
      batchSeasonTags: [],
      timeTagTargetIds: [],
      timeTagMode: 'batch'
    }
  },
  computed: {
    tabDefs() {
      const defs = [
        { label: '商品导入' },
        { label: '云商品列表' },
        { label: '共享商品库' },
        { label: '铺货列表' },
        { label: '分组管理' }
      ]
      if (this.userinfo && this.userinfo.view_share != 2) {
        defs.splice(2, 1)
      }
      return defs
    },
    importTotalPages() { return Math.max(1, Math.ceil(this.importPage.total / this.importPage.limit)) },
    importPages() { return this.pageNums(this.importPage.page, this.importTotalPages) },
    cloudTotalPages() { return Math.max(1, Math.ceil(this.cloudPage.total / this.cloudPage.limit)) },
    cloudPages() { return this.pageNums(this.cloudPage.page, this.cloudTotalPages) },
    shareTotalPages() { return Math.max(1, Math.ceil(this.sharePage.total / this.sharePage.limit)) },
    sharePages() { return this.pageNums(this.sharePage.page, this.shareTotalPages) },
    distributeTotalPages() { return Math.max(1, Math.ceil(this.distributePage.total / this.distributePage.limit)) },
    distributePages() { return this.pageNums(this.distributePage.page, this.distributeTotalPages) },
    groupTotalPages() { return Math.max(1, Math.ceil(this.groupPage.total / this.groupPage.limit)) },
    groupPages() { return this.pageNums(this.groupPage.page, this.groupTotalPages) },
    aiOperationPriceText() {
      const operation = this.aiMarkMode ? 'mark' : 'replace'
      const price = this.aiOperationPrices[operation]
      if (!price) return '会员权益价格加载失败'
      const actionName = this.aiMarkMode ? 'AI商品标记模块算力：' : 'AI替换1688sku模块算力：'
      return `${actionName}企业版会员 ${price.enterprise.amount}${price.enterprise.unit} - 普通会员 ${price.normal.amount}${price.normal.unit}`
    },
    replaceLogTotalPages() { return Math.max(1, Math.ceil(this.replaceLogPage.total / this.replaceLogPage.limit)) },
    replaceLogPages() { return this.pageNums(this.replaceLogPage.page, this.replaceLogTotalPages) },
    cloudEditTotalPages() { return Math.max(1, Math.ceil(this.cloudEditPage.total / this.cloudEditPage.limit)) },
    cloudEditPages() { return this.pageNums(this.cloudEditPage.page, this.cloudEditTotalPages) },
    allChecked() { return this.cloudList.length > 0 && this.cloudSelectedList.length === this.cloudList.length },
    shareAllChecked() { return this.shareList.length > 0 && this.shareSelectedList.length === this.shareList.length },
    cloudStatusTabs() {
      const s = this.cloudStats || {}
      return [
        { label: '全部商品', val: '', num: s.total || 0 },
        { label: '待处理', val: 0, num: s.pending_count || 0 },
        { label: '成功', val: 1, num: s.success_count || 0 },
        { label: '失败', val: 2, num: s.fail_count || 0 },
        { label: '重复跳过', val: 3, num: s.duplicate_count || 0 },
        { label: '检测下架', val: 4, num: s.offline_count || 0 }
      ]
    },
    distributeStatusTabs() {
      const s = this.distributeStats || {}
      return [
        { label: '全部铺货', val: '', num: s.total || 0 },
        { label: '待铺货', val: 1, num: s.pending_count || 0 },
        { label: '铺货中', val: 2, num: s.distributed_count || 0 },
        { label: '铺货失败', val: 3, num: s.fail_count || 0 },
        { label: '铺货成功', val: 4, num: s.success_count || 0 }
      ]
    },
    cloudShopListByType() {
      const douyin = this.cloudShopList.filter(item => item.shop_type == 1)
      const wechat = this.cloudShopList.filter(item => item.shop_type == 7)
      return { douyin, wechat }
    },
    uploadHeaders() {
      const token = localStorage.getItem(config.tokenKey)
      return { Authorization: `Bearer ${token}` }
    },
    sourceMethod(){
      if(this.importInfo.source_web === 3)  return this.collectList
      if(this.importInfo.source_web === 5)  return this.dy_collectList
      if(this.importInfo.source_web === 6)  return this.wx_collectList
      return this.pdd_collectList
    }
  },
  created() {
    const query = this.$route.query
    if (query.source_product_id) {
      this.tab =query.tab?Number(query.tab): 1
      if(this.tab===1) this.cloudSearch.source_product_id = String(query.source_product_id)
      if(this.tab===2) this.shareSearch.source_product_id = String(query.source_product_id)
    } else if (query.menu && query.menu === 'cloud') {
      // this.tab = 1
    }
    this.getImports(1)
    this.getClouds(1)
    this.loadGroups()
    this.getShares(1)
    this.getUserInfo()
    this.loadAiOperationPrices()
    this.getExcludeShopList()
    //策略缓存
    this.strategyCache = localStorage.getItem('strategyCache')?JSON.parse(localStorage.getItem('strategyCache')):{ex_time:0,value:{}}
    if(this.strategyCache.ex_time< new Date().getTime()){
      localStorage.removeItem('strategyCache')
      this.strategyCache ={ex_time:0,value:{}}
    }
  },
  methods: {
    ...mapActions({
      getImportList: 'ucenter/getImportList',
      opImportCreate: 'ucenter/opImportCreate',
      opImportCreate1688: 'ucenter/opImportCreate1688',
      getCloudProductList: 'ucenter/getCloudProductList',
      getCloudProductGroups: 'ucenter/getCloudProductGroups',
      getCloudProductGroupParents: 'ucenter/getCloudProductGroupParents',
      getCloudProductGroupChildren: 'ucenter/getCloudProductGroupChildren',
      getCloudProductEditDetail: 'ucenter/getCloudProductEditDetail',
      getCloudProductDistributeRecords: 'ucenter/getCloudProductDistributeRecords',
      getCloudProductFreightDetails: 'ucenter/getCloudProductFreightDetails',
        saveCloudProductEdit: 'ucenter/saveCloudProductEdit',
        saveCloudProductEditV2: 'ucenter/saveCloudProductEditV2',
      batchUpdateCloudProductTimeTags: 'ucenter/batchUpdateCloudProductTimeTags',
      getShareCloudProductList: 'ucenter/getShareCloudProductList',
      deleteCloudProducts: 'ucenter/deleteCloudProducts',
      opSkuMarkNotFound: 'ucenter/opSkuMarkNotFound',
      opSkuCancelNotFound: 'ucenter/opSkuCancelNotFound',
      getReplaceLogList: 'ucenter/getReplaceLogList',
      opGetFindByProductid: 'ucenter/opGetFindByProductid',
      opCloudProductBatchSetGroup: 'ucenter/opCloudProductBatchSetGroup',
      opRecoverCloudProduct: 'ucenter/opRecoverCloudProduct',
      opCloudProductGroupCreate: 'ucenter/opCloudProductGroupCreate',
      opCloudProductGroupUpdate: 'ucenter/opCloudProductGroupUpdate',
      opCloudProductGroupMove: 'ucenter/opCloudProductGroupMove',
      opCloudProductGroupDelete: 'ucenter/opCloudProductGroupDelete',
      getDistributeShopSel: 'ucenter/getDistributeShopSel',
      createCloudProductDistribute: 'ucenter/createCloudProductDistribute',
      getDistributeItems: 'ucenter/getDistributeItems',
      getDdShopList: 'ucenter/getDdShopList',
      getImageSearchList: 'ucenter/getImageSearchList',
      doReplaceCloudProducts: 'ucenter/doReplaceCloudProducts',
      getUserinfoData: 'ucenter/getUserinfoData',
      doMarkCloudProduct: 'ucenter/doMarkCloudProduct',
      opProductMarkNotFound: 'ucenter/opProductMarkNotFound',
      opProductMarkNotFoundCancel: 'ucenter/opProductMarkNotFoundCancel',
      getProductMarkable: 'ucenter/getProductMarkable',
      fetchMembershipPlans: 'ucenter/fetchMembershipPlans',
    }),
    pageNums(page, total) {
      const nums = []
      const start = Math.max(1, Math.min(page - 2, total - 4))
      for (let i = start; i <= Math.min(total, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    },
    switchTab(i) {
      if (this.userinfo && this.userinfo.view_share != 2 && i > 1) i += 1
      this.tab = i
      if (i === 1 && !this.cloudList.length) {
        this.getClouds(1)
      } else if (i === 2) {
        this.getShares(1)
      } else if (i === 3) {
        if (!this.distributeList.length) this.getDistributeList(1)
        if (!this.filterShopList.length) this.getFilterShopList()
      } else if (i === 4) {
        this.getGroupList(1)
      }
    },
    /* ── 用户信息 ── */
     getUserInfo() {
       this.getUserinfoData({
         data: {},
         success: (res) => {
           if (res.code === 200) {
             this.userinfo = res.data
             this.power_num = res.data.power_num || 0
           }
         }
       })
     },
    loadAiOperationPrices() {
      if (this.aiOperationPricesLoading) return
      this.aiOperationPricesLoading = true
      this.aiOperationPricesError = false
      this.fetchMembershipPlans({
        data: {},
        success: (res) => {
          this.aiOperationPricesLoading = false
          const plans = res && res.code === 200 && res.data && Array.isArray(res.data.plans) ? res.data.plans : []
          const enterprise = plans.find(plan => Number(plan.level_key) === 1)
          const normal = plans.find(plan => Number(plan.level_key) === 9)
          const priceFor = (key) => {
            const enterpriseBenefit = enterprise && Array.isArray(enterprise.benefits) ? enterprise.benefits.find(item => item.key === key) : null
            const normalBenefit = normal && Array.isArray(normal.benefits) ? normal.benefits.find(item => item.key === key) : null
            if (!enterpriseBenefit || !normalBenefit || [enterpriseBenefit.amount, normalBenefit.amount].some(amount => amount === undefined || amount === null || amount === '')) return null
            return {
              enterprise: { amount: enterpriseBenefit.amount, unit: enterpriseBenefit.unit || '算力/个' },
              normal: { amount: normalBenefit.amount, unit: normalBenefit.unit || '算力/个' }
            }
          }
          this.aiOperationPrices = {
            replace: priceFor('ai_replace_1688_sku'),
            mark: priceFor('ai_product_mark')
          }
          this.aiOperationPricesError = !this.aiOperationPrices.replace || !this.aiOperationPrices.mark
        },
        error: () => {
          this.aiOperationPricesLoading = false
          this.aiOperationPricesError = true
        }
      })
    },
     getExcludeShopList() {
       if (this.excludeShopList.length > 0) return
       this.getDistributeShopSel({
         data: {},
         success: (res) => {
           if (res.code === 200) {
             this.excludeShopList = res.data || []
           }
         }
       })
     },
    /* ── 导入列表 ── */
    onImportPageSizeChange(size) {
      this.importPage.limit = size
      this.importPage.page = 1
      this.getImports(1)
    },
    onCloudPageSizeChange(size) {
      this.cloudPage.limit = size
      this.cloudPage.page = 1
      this.getClouds(1)
    },
    onSharePageSizeChange(size) {
      this.sharePage.limit = size
      this.sharePage.page = 1
      this.getShares(1)
    },
    onDistributePageSizeChange(size) {
      this.distributePage.limit = size
      this.distributePage.page = 1
      this.getDistributeList(1)
    },
    getImports(page) {
      this.importLoading = true
      this.importPage.page = page
      this.getImportList({
        data: { page_size: this.importPage.limit, page: this.importPage.page },
        success: (res) => {
          this.importLoading = false
          if (res.code === 200) {
            this.importList = res.data.list || []
            this.importPage.total = res.data.total || 0
            this.importSize = res.data.limit || 100
          }
        }
      })
    },
    handleRefresh() {
      this.importPage.page = 1
      this.getImports(1)
    },
    sourceLabel(v) {
      const found = this.sourceList.find(i => i.value == v)
      return found ? found.label : (v || '--')
    },
    // 商品来源平台 → 样式类（1688 琥珀 / TB 红 / PDD 橙 / DY 深 / WX 绿）
    sourceCls(v) {
      const map = {
        2: 'gx-cloud__src--ali',
        3: 'gx-cloud__src--tb',
        4: 'gx-cloud__src--pdd',
        5: 'gx-cloud__src--dy',
        6: 'gx-cloud__src--wx'
      }
      return map[v] || 'gx-cloud__src--other'
    },
    statusText(status) {
      return ['待处理', '处理中', '已完成', '已取消'][status] || '--'
    },
    importStatusCls(status) {
      const map = {
        0: 'gx-cloud__status--wait',
        1: 'gx-cloud__status--run',
        2: 'gx-cloud__status--ok',
        3: 'gx-cloud__status--cancel'
      }
      return map[status] || ''
    },
    handleView(row) {
      this.tab = 1
      this.cloudSearch = {
        status: '', keyword: '', batch_no: row.batch_no, source_product_id: '', platform_product_id: '',
        source_web: '', distribution_free_postage: '', freight_province_code: '',
        min_price: '', max_price: '', sku_status: '', ai_title_status: '',
        exclude_distributed: [], distribute_status: '', group_id: '', child_group_id: '', is_sku_miss: '',
        has_distribute_success: '', has_distribute_fail: '', has_distribute_ban: '', has_distribute_review_fail: ''
      }
      this.cloudPage.page = 1
      this.$nextTick(() => {
        this.getClouds(1)
        this.getExcludeShopList()
      })
    },
    /* ── 导入商品 ── */
    handleAdd() {
      this.zipFileName = ''
      this.importInfo = { products: [], source_method: '', source_web: 3, page: 0, group_id: '', child_group_id: '', produceLinks: '', startIndex: 0 }
      this.batchNum = 0
      this.upErr = false
      this.importShow = true
      this.$nextTick(() => {
        if (this.$refs.zipInput) this.$refs.zipInput.value = ''
      })
    },
    handleUpload() {
      if (this.$refs.zipInput) this.$refs.zipInput.click()
    },
    changeSourceWeb() {
      this.importInfo.products = []
      this.importInfo.source_method = ''
      this.batchNum = 0
    },
    selectSource(val) {
      if (this.importInfo.source_web === val) return
      this.importInfo.source_web = val
      this.changeSourceWeb()
    },
    changeSourceMethod() {
      this.importInfo.products = []
      this.batchNum = 0
    },
    changeGroupId() {
      this.$set(this.importInfo, 'child_group_id', '')
      this.child_groupList = this.groupList.find(i => i.id === this.importInfo.group_id)?.child_groups || []
    },
    async handleZipChange(e) {
      const [file] = e.target.files || []
      if (!file) return
      if (!/\.zip$/i.test(file.name)) {
        this.$message.error('请上传zip压缩包文件')
        this.resetZipInput()
        return
      }
      this.imLoading = true
      this.zipFileName = file.name || ''
      this.importInfo.products = []
      this.importInfo.page = 0
      this.importInfo.startIndex = 0
      this.batchNum = 0
      this.upErr = false
      try {
        const buffer = await this.readFileAsArrayBuffer(file)
        const zip = await JSZip.loadAsync(buffer)
        const readTxtTasks = []
        const invalidZipFiles = []
        const addInvalidZipFile = (relativePath) => {
          if (relativePath && !invalidZipFiles.includes(relativePath)) invalidZipFiles.push(relativePath)
        }
        zip.forEach((relativePath, fileEntry) => {
          // if (!fileEntry.dir && relativePath.toLowerCase().endsWith('.txt')) {
          if (!fileEntry.dir && ((relativePath.toLowerCase().endsWith(".txt")&&this.importInfo.source_method!=11)||(relativePath.toLowerCase().endsWith(".json")&&(this.importInfo.source_method===11 || this.importInfo.source_method===13)))){
              readTxtTasks.push(
              fileEntry.async('uint8array').then(async (uint8Array) => {
                try {
                  let content
                  const isUTF8 = common.isUTF8(uint8Array)
                  content = isUTF8 ? new TextDecoder('utf-8').decode(uint8Array) : new TextDecoder('gbk').decode(uint8Array)
                  if (this.isValidJSON(content)) {
                    let isValid = false
                    const jsondata = JSON.parse(content)
                    switch (this.importInfo.source_method) {
                      case 1: isValid = !!(jsondata.FromItem && jsondata.FromItem.ItemPicUrl); break
                      case 2: isValid = !!(jsondata.productPicUrl || jsondata.itemImgs); break
                      case 3: isValid = !!(jsondata.item_imgs); break
                      case 4: isValid = !!(jsondata.goods && jsondata.goods.hd_url); break
                      case 5: isValid = !!(jsondata.goods && jsondata.goods.hd_url); break
                      case 6: isValid = !!(jsondata.result && jsondata.result.source); break
                      case 7: isValid = !!(jsondata['主图']); break
                      case 8: isValid = !!(jsondata.item_id); break
                      case 9: isValid = !!(jsondata.store && jsondata.store.initDataObj && jsondata.store.initDataObj.goods && jsondata.store.initDataObj.goods.hdThumbUrl); break
                      case 10: isValid = !!(jsondata.store?.initDataObj?.goods?.topGallery?.[0]?.url);  break;
                      case 11: isValid = !!(jsondata?.main_images?.length); break;
                      case 12: isValid = !!(jsondata?.headImg?.length); break;
                      case 13:
                        isValid = !!(
                            jsondata.goods?.goods_id &&
                            jsondata.goods?.goods_name &&
                            (jsondata.goods?.hd_url || jsondata.goods?.image_url || jsondata.goods?.thumb_url) &&
                            Array.isArray(jsondata.sku) &&
                            jsondata.sku.length
                        );
                        break;
                      default: break
                    }
                    if (!isValid) {
                      addInvalidZipFile(relativePath)
                      return null
                    }
                    if (this.importInfo.source_method === 4 || this.importInfo.source_method === 5) {
                      const data = {
                        goods: {
                          goods_id: jsondata.goods && jsondata.goods.goods_id,
                          goods_name: jsondata.goods && jsondata.goods.goods_name,
                          market_price: jsondata.goods && jsondata.goods.market_price,
                          hd_url: jsondata.goods && jsondata.goods.hd_url,
                          gallery: jsondata.goods && jsondata.goods.gallery,
                          decoration: jsondata.goods && jsondata.goods.decoration,
                          goods_property: jsondata.goods && jsondata.goods.goods_property,
                          preview_share_link: jsondata.goods && jsondata.goods.preview_share_link
                        },
                        sku: (jsondata.sku || []).map(item => ({
                          sku_id: item.sku_id, sku_price: item.sku_price, group_price: item.group_price,
                          normal_price: item.normal_price, thumb_url: item.thumb_url, price_display: item.price_display,
                          quantity: item.quantity, specs: item.specs
                        }))
                      }
                      if (this.importInfo.source_method === 4) {
                        data.ui = { carousel_section: jsondata.ui && jsondata.ui.carousel_section }
                      }
                      if (this.importInfo.source_method === 5) {
                        data.price = jsondata.price
                      }
                      return data
                    }
                    else if (this.importInfo.source_method === 6) {
                      const dataInfo = jsondata.result && jsondata.result.data
                      if (!dataInfo || !dataInfo.item || !dataInfo.skuCore || !dataInfo.skuBase ||
                        !dataInfo.componentsVO || !dataInfo.componentsVO.priceVO || !dataInfo.componentsVO.priceVO.price ||
                        !dataInfo.componentsVO.priceVO.price.priceMoney || !dataInfo.plusViewVO || !dataInfo.plusViewVO.industryParamVO ||
                        !dataInfo.plusViewVO.industryParamVO.basicParamList) {
                        addInvalidZipFile(relativePath)
                        return null
                      }
                      const data = {}
                      data.item = dataInfo.item
                      data.skuCore = dataInfo.skuCore
                      data.skuBase = dataInfo.skuBase
                      data.videos = (dataInfo.item.videos && dataInfo.item.videos[0] && dataInfo.item.videos[0].url) || null
                      data.priceMoney = dataInfo.componentsVO.priceVO.price.priceMoney
                      data.basicParamList = dataInfo.plusViewVO.industryParamVO.basicParamList
                      return data
                    }
                    else if (this.importInfo.source_method === 7) {
                      return jsondata
                    }
                    else if (this.importInfo.source_method === 9) {
                      const dataInfo = jsondata.store && jsondata.store.initDataObj && jsondata.store.initDataObj.goods
                      if (!dataInfo || !dataInfo.goodsID || !dataInfo.hdThumbUrl || !dataInfo.goodsName ||
                        !dataInfo.ui || !dataInfo.ui.new_price_section || !dataInfo.skus || !dataInfo.goodsProperty ||
                        !dataInfo.detailGallery || !dataInfo.viewImageData) {
                        addInvalidZipFile(relativePath)
                        return null
                      }
                      return {
                        shareLink: dataInfo.shareLink || '',
                        img: dataInfo.hdThumbUrl,
                        goodsID: dataInfo.goodsID,
                        goodsName: dataInfo.goodsName,
                        new_price_section: dataInfo.ui.new_price_section,
                        skus: dataInfo.skus,
                        goodsProperty: dataInfo.goodsProperty,
                        viewImageData: dataInfo.viewImageData,
                        detailGallery: dataInfo.detailGallery
                      }
                    }
                    else if (this.importInfo.source_method === 10){ //兵哥哥
                      const dataInfo = jsondata.store?.initDataObj?.goods;
                      if (!dataInfo||!dataInfo.goodsID) {
                        addInvalidZipFile(relativePath)
                        return null; // 直接退出，不返回数据
                      }
                      return {
                        goodsID: String(dataInfo.goodsID),
                        goodsName: dataInfo.goodsName,
                        minGroupPrice: dataInfo.minGroupPrice,
                        viewImageData: dataInfo.viewImageData?.length ? dataInfo.viewImageData : dataInfo.topGallery,
                        detailGallery: dataInfo.detailGallery,
                        skus: dataInfo.skus,
                        goodsProperty: dataInfo.goodsProperty ?? [],
                        shareLink: dataInfo.shareLink ?? ''
                      };
                    }
                    else if (this.importInfo.source_method === 11){ //万象json
                      const dataInfo = jsondata;
                      if (!dataInfo||!dataInfo.goods_id) {
                        addInvalidZipFile(relativePath)
                        return null; // 直接退出，不返回数据
                      }
                      return {
                        goods_id: String(dataInfo.goods_id),
                        goods_title: dataInfo.goods_title,
                        main_images: dataInfo.main_images,
                        desc_images: dataInfo.desc_images,
                        specs: dataInfo.specs,
                        skus: dataInfo.skus,
                        min_price: dataInfo.min_price,
                        show_price: dataInfo.show_price,
                        product_format: dataInfo.product_format ?? [],
                        share_url: dataInfo.share_url ?? dataInfo.goods_url ?? ''
                      };
                    }
                    else if (this.importInfo.source_method === 12) { //小店助手
                      const sourceId = String(jsondata.expressInfo?.productId || '');
                      const banners = Array.isArray(jsondata.headImg) ? jsondata.headImg.filter(Boolean) : [];
                      const details = Array.isArray(jsondata.detail?.detailImg) ? jsondata.detail.detailImg.filter(Boolean) : [];
                      const rawSkus = Array.isArray(jsondata.skuList?.skuInfo) ? jsondata.skuList.skuInfo : [];
                      if (!jsondata.title || banners.length < 1 || details.length < 1 || !rawSkus.length) {
                        addInvalidZipFile(relativePath); return null;
                      }
                      const specBySku = {};
                      (Array.isArray(jsondata.productSaleAttrs) ? jsondata.productSaleAttrs : []).forEach(group => {
                        (group.items || []).forEach(item => (item.skuIds || []).forEach(skuId => {
                          const key = String(skuId);
                          (specBySku[key] || (specBySku[key] = [])).push({ name: group.key || '规格', value: item.value || '默认', image: item.imgUrl || '' });
                        }));
                      });
                      return {
                        source_product_id: sourceId,
                        title: jsondata.title,
                        main_images: banners,
                        desc_images: details,
                        video_url: jsondata.headVideoInfo?.[0]?.videoUrl || '',
                        price: Number(jsondata.skuList?.minPrice || 0),
                        attributes: (jsondata.param || []).map(i => i.paramV2).filter(i => i?.attrName && i?.attrValueName).map(i => ({ name: i.attrName, value: i.attrValueName })),
                        skus: rawSkus.map(s => ({ sku_id: String(s.skuId || ''), price: Number(s.price || 0), stock: Number(s.stock ?? s.stockNum ?? s.quantity ?? s.inventory ?? 999),
                          specs: specBySku[String(s.skuId)] || [{ name: '规格', value: '默认', image: '' }] })) };
                    }
                    else if (this.importInfo.source_method === 13) { //豪哥
                      const goods = jsondata.goods;
                      const skus = Array.isArray(jsondata.sku) ? jsondata.sku : [];
                      const gallery = (Array.isArray(goods?.gallery) ? goods.gallery : []).map((item, index) => ({ item, index })).sort((a, b) => {
                        const aId = Number(a.item?.id), bId = Number(b.item?.id), aValid = String(a.item?.id ?? '').trim() !== '' && Number.isFinite(aId), bValid = String(b.item?.id ?? '').trim() !== '' && Number.isFinite(bId);
                        return aValid && bValid ? aId - bId || a.index - b.index : aValid ? -1 : bValid ? 1 : a.index - b.index;
                      }).map(entry => entry.item);
                      const carousel = gallery.filter(item => String(item?.type) === '1' && typeof item?.url === 'string' && item.url.trim()).map(item => item.url).filter((url, index, list) => list.indexOf(url) === index).slice(0, 5);
                      if (carousel.length < 3) gallery.forEach(item => {
                        if (String(item?.type) !== '13' || typeof item?.url !== 'string' || !item.url.trim() || carousel.includes(item.url) || carousel.length === 5) return;
                        carousel.push(item.url);
                      });
                      if (carousel.length < 3) gallery.forEach(item => {
                        const width = Number(item?.width), height = Number(item?.height);
                        if (String(item?.type) !== '2' || !Number.isFinite(width) || !Number.isFinite(height) || width !== height || typeof item?.url !== 'string' || !item.url.trim() || carousel.includes(item.url) || carousel.length === 5) return;
                        carousel.push(item.url);
                      });
                      const galleryDetails = gallery.filter(item => String(item?.type) === '2' && typeof item?.url === 'string' && item.url.trim());
                      const decorationDetails = (Array.isArray(goods?.decoration) ? goods.decoration : []).flatMap(section => (Array.isArray(section?.contents) ? section.contents : []).map(item => item?.img_url).filter(Boolean));
                      const details = decorationDetails.length ? decorationDetails : galleryDetails;
                      if (!goods?.goods_id || !goods?.goods_name || !(goods?.hd_url || goods?.image_url || goods?.thumb_url) || carousel.length < 3 || details.length < 1 || !skus.length || !skus.some(s => Number(s?.group_price || s?.normal_price || s?.price || 0) > 0)) {
                        addInvalidZipFile(relativePath); return null;
                      }
                      return {
                        goods: {
                          goods_id: goods.goods_id,
                          goods_name: goods.goods_name,
                          image_url: goods.image_url,
                          hd_url: goods.hd_url,
                          thumb_url: goods.thumb_url,
                          gallery: goods.gallery,
                          decoration: goods.decoration,
                          goods_property: goods.goods_property||[

                          ],
                          preview_share_link: goods.preview_share_link,
                          share_link: goods.share_link
                        },
                        sku: skus.map(s=>({
                          sku_id: s.sku_id,
                          goods_id: s.goods_id,
                          thumb_url: s.thumb_url,
                          quantity: s.quantity,
                          default_quantity: s.default_quantity,
                          group_price: s.group_price,
                          normal_price: s.normal_price,
                          price: s.price,
                          sku_price : s.sku_price,
                          specs: s.specs
                        })),
                        price: jsondata.price,
                        category: jsondata.category,
                        source_url: jsondata.source_url
                      };
                    }
                    return jsondata
                  }
                  addInvalidZipFile(relativePath)
                  return null
                } catch (parseErr) {
                  addInvalidZipFile(relativePath)
                  return null
                }
              })
            )
          }
        })
        const txts = await Promise.all(readTxtTasks)
        this.importInfo.products = txts.filter(item => item !== null && item !== undefined)
        if (this.importInfo.source_method === 13) {
          const seen = new Set();
          this.importInfo.products = this.importInfo.products.filter(item => {
            const id = String(item.goods?.goods_id || '');
            if (!id || seen.has(id)) return false;
            seen.add(id);
            return true;
          });
        }
        if (invalidZipFiles.length > 0) {
          const showInvalidZipFiles = invalidZipFiles.slice(0, 10)
          const invalidZipFileMessage = [`有${invalidZipFiles.length}个文件数据存在格式不对，请检查商品解析方式：`]
          showInvalidZipFiles.forEach(item => invalidZipFileMessage.push(`【${this.escapeHtml(item)}】`))
          if (invalidZipFiles.length > 10) invalidZipFileMessage.push('……')
          this.$message.error({ dangerouslyUseHTMLString: true, message: invalidZipFileMessage.join('<br/>'), duration: 8000 })
        }
        if (!this.importInfo.products.length) {
          this.$message.error({ message: '导入数据无效，请检查商品解析方式', duration: 5000 })
        }
        this.batchNum = Math.ceil(this.importInfo.products.length / this.importSize)
      } catch (err) {
        this.$message.error('解压或读取文件失败，请重试')
      } finally {
        this.imLoading = false
        this.resetZipInput()
      }
    },
    readFileAsArrayBuffer(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (evt) => resolve(evt.target.result)
        reader.onerror = (err) => reject(err)
        reader.readAsArrayBuffer(file)
      })
    },
    resetZipInput() {
      if (this.$refs.zipInput) this.$refs.zipInput.value = ''
    },
    escapeHtml(value) {
      return String(value).replace(/[&<>"']/g, (char) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      }[char]))
    },
    isValidJSON(content) {
      try {
        JSON.parse(content)
        return true
      } catch (e) {
        return false
      }
    },
    handleImport() {
      if(this.importInfo.source_web === 2){
        if (!this.importInfo.produceLinks) {
          this.$message.error('请输入1688商品链接')
          return
        }
        this.importGoods1688()
      }else{
        if (!this.importInfo.source_method) {
          this.$message.error('请选择商品解析方式')
          return
        }
        if (!this.importInfo.products.length) {
          this.$message.error('请先上传并解析zip压缩包')
          return
        }
        this.upLoading = true
        this.importInfo.startIndex = 0
        this.importInfo.page = 0
        this.upErr = false
        this.importCreate()
      }
    },
    importGoods1688() {
      const links = this.importInfo.produceLinks.split(/\r\n|\r|\n|,|，/g).map(item => item.trim()).filter(item => (item !== '' && item !== '-'))
      const goodsIds = links.map(item => {
        const url = item.substring(0, item.indexOf('?') > -1 ? item.indexOf('?') : item.length)
        if (url.indexOf('html') > -1) {
          const arr = url.split('/')
          return arr[arr.length - 1].split('.')[0]
        }
        return ''
      }).filter(item => item !== '')
      if (!goodsIds.length) {
        this.$message.error('请填写正确的1688商品链接')
        return
      }
      this.$confirm(`是否确认导入${goodsIds.length}个商品？`, '提示', { type: 'warning' }).then(() => {
        this.upLoading = true
        const params = { productIds: goodsIds.join(',') }
        if (this.importInfo.group_id) params.group_id = this.importInfo.group_id
        if (this.importInfo.child_group_id) params.child_group_id = this.importInfo.child_group_id
        this.opImportCreate1688({
          data: params,
          success: (res) => {
            this.upLoading = false
            if (res.code === 200) {
              this.$message.success('导入任务创建成功')
            } else {
              this.$message.error(res.message)
            }
            this.importShow = false
            this.getImports(1)
          }
        })
      }).catch(() => {})
    },
    async importCreate() {
      try {
        const totalList = this.importInfo.products
        if (!totalList || totalList.length === 0 || this.importInfo.startIndex >= totalList.length) {
          this.upLoading = false
          this.$message.success('全部导入完成')
          this.importShow = false
          this.getImports(1)
          return
        }
        if (this.importInfo.page == 1 || this.upErr) {
          this.upLoading = true
        }
        const startIndex = this.importInfo.startIndex
        let endIndex = startIndex
        const MAX_SIZE = 1024 * 1024 * 1.3
        for (let i = startIndex; i < totalList.length; i++) {
          const testBatch = totalList.slice(startIndex, i + 1)
          const size = new Blob([JSON.stringify(testBatch)]).size
          if (size > MAX_SIZE || (i - 101) === startIndex) break
          endIndex = i + 1
        }
        const batchProducts = totalList.slice(startIndex, endIndex)
        const nextPage = this.importInfo.page + 1
        const params = {
          products: batchProducts,
          source_web: this.importInfo.source_web,
          source_method: this.importInfo.source_method,
          file_name: this.zipFileName.split('.')[0] + '_' + nextPage
        }
        if (this.importInfo.group_id) params.group_id = this.importInfo.group_id
        if (this.importInfo.child_group_id) params.child_group_id = this.importInfo.child_group_id
        this.opImportCreate({
          data: params,
          success: (res) => {
            if (res.code === 200) {
              this.upErr = false
              this.importInfo.startIndex = endIndex
              this.importInfo.page += 1
              this.importCreate()
            } else {
              this.upLoading = false
              this.upErr = this.importInfo.page > 0
              this.$message.error(res.message)
            }
          }
        })
      } catch (e) {
        this.$message.error(e)
        this.upLoading = false
      }
    },
    /* ── 云商品列表 ── */
    getClouds(page) {
      this.cloudPage.page = page
      const params = this.buildCloudListParams(this.cloudPage.page, this.cloudPage.limit, this.cloudSearch)
      this.loadingStart()
      this.getCloudProductList({
        data: params,
        success: (res) => {
          this.loadingEnd()
          if (res.code === 200) {
            this.cloudList = res.data.list || []
            this.cloudPage.total = res.data.total || 0
            if (res.data.stats && this.cloudSearch.status === '' && this.cloudPage.page === 1) {
              this.cloudStats = res.data.stats
              if (res.data.stats.total !== undefined) {
                this.cloudPage.total = res.data.stats.total
              }
            } else if (this.cloudPage.page === 1 && !this.hasCloudSearchFilter()) {
              const currentTotal = res.data.total || 0
              const status = this.cloudSearch.status
              if (status !== '') {
                const keyMap = { 0: 'pending_count', 1: 'success_count', 2: 'fail_count', 3: 'duplicate_count', 4: 'offline_count' }
                if (keyMap[status]) {
                  this.cloudStats[keyMap[status]] = currentTotal
                  this.cloudStats.total = (this.cloudStats.pending_count || 0) + (this.cloudStats.success_count || 0) +
                    (this.cloudStats.fail_count || 0) + (this.cloudStats.duplicate_count || 0) + (this.cloudStats.offline_count || 0)
                }
              } else {
                this.cloudStats.total = currentTotal
              }
            }
          }
        }
      })
    },
    buildCloudListParams(page, pageSize, searchParams = {}) {
      const params = { page, page_size: pageSize, ...searchParams }
      if (params.status === '') delete params.status
      if (params.keyword === '') delete params.keyword
      if (params.batch_no === '') delete params.batch_no
      if (params.source_product_id === '') delete params.source_product_id
      if (params.platform_product_id === '') delete params.platform_product_id
      if (params.sku_status === '') delete params.sku_status
      if (params.sku_mark_status === '') delete params.sku_mark_status
      if (params.ai_title_status === '') delete params.ai_title_status
      if (params.distribution_free_postage === '') delete params.distribution_free_postage
      if (params.freight_province_code === '') delete params.freight_province_code
      if (params.min_price === '') delete params.min_price
      if (params.max_price === '') delete params.max_price
      if (params.appraisal_status === '') delete params.appraisal_status
      if (params.distribute_status === '') delete params.distribute_status
      if (params.exclude_distributed && params.exclude_distributed.length > 0) {
        params.exclude_distributed = Array.isArray(params.exclude_distributed)
          ? params.exclude_distributed.join(',')
          : params.exclude_distributed
      } else {
        delete params.exclude_distributed
      }
      if (params.group_id === '') delete params.group_id
      if (params.child_group_id === '') delete params.child_group_id
      if (params.is_sku_miss === '') delete params.is_sku_miss
      if (params.has_distribute_success === '') delete params.has_distribute_success
      if (params.has_distribute_fail === '') delete params.has_distribute_fail
      if (params.has_distribute_ban === '') delete params.has_distribute_ban
      if (params.has_distribute_review_fail === '') delete params.has_distribute_review_fail
      if (Array.isArray(params.month_tags) && params.month_tags.length > 0) {
        params.month_tags = params.month_tags.join(',')
      } else {
        delete params.month_tags
      }
      if (Array.isArray(params.season_tags) && params.season_tags.length > 0) {
        params.season_tags = params.season_tags.join(',')
      } else {
        delete params.season_tags
      }
      return params
    },
    hasCloudSearchFilter() {
      return !!(this.cloudSearch.keyword || this.cloudSearch.batch_no || this.cloudSearch.source_product_id || this.cloudSearch.platform_product_id ||
        this.cloudSearch.has_distribute_success || this.cloudSearch.has_distribute_fail || this.cloudSearch.has_distribute_ban || this.cloudSearch.has_distribute_review_fail ||
        this.cloudSearch.month_tags.length || this.cloudSearch.season_tags.length)
    },
    handleCloudSearch() {
      this.cloudPage.page = 1
      this.getClouds(1)
    },
    toggleCloudTimeTag(field, value) {
      const tags = this.cloudSearch[field]
      const index = tags.indexOf(value)
      if (index === -1) tags.push(value)
      else tags.splice(index, 1)
    },
    handleGroupFilterChange() {
      this.$set(this.cloudSearch, 'child_group_id', '')
      this.child_groupList = this.groupList.find(i => i.id === this.cloudSearch.group_id)?.child_groups || []
      this.handleFilterChange()
    },
    handleFilterChange() {
      const minPrice = String(this.cloudSearch.min_price || '').trim()
      const maxPrice = String(this.cloudSearch.max_price || '').trim()
      if (minPrice !== '' && (!Number.isFinite(Number(minPrice)) || Number(minPrice) < 0)) {
        this.$message.warning('最低价格必须是大于等于0的数字')
        return
      }
      if (maxPrice !== '' && (!Number.isFinite(Number(maxPrice)) || Number(maxPrice) < 0)) {
        this.$message.warning('最高价格必须是大于等于0的数字')
        return
      }
      if (minPrice !== '' && maxPrice !== '' && Number(minPrice) > Number(maxPrice)) {
        this.$message.warning('最低价格不能大于最高价格')
        return
      }
      this.cloudSearch.status = ''
      this.handleCloudSearch()
    },
    handleExcludeFilterChange(val) {
      const value = val || ''
      if (value === 'all') {
        this.cloudSearch.exclude_distributed = ['all']
      } else if (value === '') {
        this.cloudSearch.exclude_distributed = []
        this.cloudSearch.distribute_status = ''
      } else {
        this.cloudSearch.exclude_distributed = [value]
      }
      this.cloudSearch.status = ''
      this.handleCloudSearch()
    },
    handleCloudStatusTabClick(status) {
      if (this.cloudSearch.status === status) return
      this.cloudSearch.status = status
      this.handleCloudSearch()
    },
    handleCloudRefresh() {
      this.cloudPage.page = 1
      this.getClouds(1)
    },
    handleCloudReset() {
      this.cloudSearch = {
        status: '', keyword: '', batch_no: '', source_product_id: '', platform_product_id: '',
        source_web: '', distribution_free_postage: '', freight_province_code: '',
        min_price: '', max_price: '', sku_status: '', ai_title_status: '',
        exclude_distributed: [], distribute_status: '', group_id: '', child_group_id: '', is_sku_miss: '', sku_mark_status: '',
        has_distribute_success: '', has_distribute_fail: '', has_distribute_ban: '', has_distribute_review_fail: '',
        month_tags: [], season_tags: []
      }
      this.excludeSelect = ''
      this.child_groupList = []
      this.cloudPage.page = 1
      this.getClouds(1)
    },
    normalizeMonthTags(tags) {
      return Array.from(new Set((Array.isArray(tags) ? tags : []).map(Number).filter(month => Number.isInteger(month) && month >= 1 && month <= 12))).sort((a, b) => a - b)
    },
    normalizeSeasonTags(tags) {
      const selected = Array.isArray(tags) ? tags : []
      return this.seasonTagOptions.filter(season => selected.includes(season))
    },
    formatMonthTags(tags) {
      const months = this.normalizeMonthTags(tags)
      if (!months.length) return ''
      const ranges = []
      let start = months[0]
      let end = start
      months.slice(1).forEach(month => {
        if (month === end + 1) {
          end = month
          return
        }
        ranges.push(start === end ? `${start}月` : `${start}-${end}月`)
        start = month
        end = month
      })
      ranges.push(start === end ? `${start}月` : `${start}-${end}月`)
      return ranges.join('、')
    },
    openBatchTimeTags() {
      if (!this.cloudSelectedList.length) {
        this.$message.warning('请先选择云商品')
        return
      }
      this.batchMonthTags = []
      this.batchSeasonTags = []
      this.timeTagTargetIds = this.cloudSelectedList.map(item => item.id)
      this.timeTagMode = 'batch'
      this.batchTimeTagShow = true
    },
    openOneTimeTags(row) {
      this.batchMonthTags = this.normalizeMonthTags(row.month_tags)
      this.batchSeasonTags = this.normalizeSeasonTags(row.season_tags)
      this.timeTagTargetIds = [row.id]
      this.timeTagMode = 'single'
      this.batchTimeTagShow = true
    },
    toggleBatchTimeTag(type, value) {
      const tags = type === 'month' ? this.batchMonthTags : this.batchSeasonTags
      const index = tags.indexOf(value)
      if (index === -1) tags.push(value)
      else tags.splice(index, 1)
    },
    submitBatchTimeTags() {
      const submit = () => {
        this.batchTimeTagLoading = true
        this.batchUpdateCloudProductTimeTags({
          data: {
            ids: this.timeTagTargetIds,
            month_tags: this.normalizeMonthTags(this.batchMonthTags),
            season_tags: this.normalizeSeasonTags(this.batchSeasonTags)
          },
          success: (res) => {
            this.batchTimeTagLoading = false
            if (res.code === 200) {
              this.$message.success(`已更新${res.data.updated_count || 0}个商品`)
              this.batchTimeTagShow = false
              if (this.timeTagMode === 'batch') this.cloudSelectedList = []
              this.timeTagTargetIds = []
              this.getClouds(this.cloudPage.page)
              return
            }
            this.$message.error(res.message)
          }
        })
      }
      if (!this.batchMonthTags.length && !this.batchSeasonTags.length) {
        this.$confirm('未选择任何标签，提交后将清空所选商品的月份和季节标签，是否继续？', '确认清空', { type: 'warning' }).then(submit).catch(() => {})
        return
      }
      submit()
    },
    /* ── 选择 ── */
    toggleOne(row) {
      const idx = this.cloudSelectedList.indexOf(row)
      if (idx > -1) this.cloudSelectedList.splice(idx, 1)
      else this.cloudSelectedList.push(row)
    },
    toggleAll() {
      if (this.allChecked) this.cloudSelectedList = []
      else this.cloudSelectedList = this.cloudList.slice()
    },
    /* ── 铺货 ── */
    openDistribute() {
      if (!this.cloudSelectedList.length) return
      const successProducts = this.cloudSelectedList.filter(item => item.status === 1)
      if (!successProducts.length) {
        this.$message.warning('请选择成功状态的商品进行铺货')
        return
      }
      if (successProducts.length < this.cloudSelectedList.length) {
        this.$message.warning(`已过滤非成功状态的商品，将对 ${successProducts.length} 个商品进行铺货`)
        this.cloudSelectedList = successProducts
      }
      this.distributeShow = true
      this.cloudShopTab = 'douyin'
      this.cloudSelectedShopIds = []
      this.cloudShopSelect = ''
      this.shareDistributeMode = false
      this.cloudShopLoading = true
      this.getDistributeShopSel({
        data: { status: 1 },
        success: (res) => {
          this.cloudShopLoading = false
          if (res.code === 200) {
            this.cloudShopList = (res.data || []).map(item => ({ ...item, is_selected: 0 }))
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    openShareDistribute() {
      if (!this.shareSelectedList.length) return
      const successProducts = this.shareSelectedList.filter(item => item.status === 1)
      if (!successProducts.length) {
        this.$message.warning('请选择成功状态的商品进行铺货')
        return
      }
      if (successProducts.length < this.shareSelectedList.length) {
        this.$message.warning(`已过滤非成功状态的商品，将对 ${successProducts.length} 个商品进行铺货`)
        this.shareSelectedList = successProducts
      }
      this.distributeShow = true
      this.cloudShopTab = 'douyin'
      this.cloudSelectedShopIds = []
      this.cloudShopSelect = ''
      this.shareDistributeMode = true
      this.cloudShopLoading = true
      this.getDistributeShopSel({
        data: { status: 1 },
        success: (res) => {
          this.cloudShopLoading = false
          if (res.code === 200) {
            this.cloudShopList = (res.data || []).map(item => ({ ...item, is_selected: 0 }))
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    cloudCheckAll(type) {
      const ids = this.cloudShopListByType[type].map(s => s.shop_id)
      return ids.length > 0 && ids.every(id => this.cloudSelectedShopIds.includes(id))
    },
    handleShopCheckAll(type, checked) {
      const ids = this.cloudShopListByType[type].map(s => s.shop_id)
      if (checked) {
        ids.forEach(id => {
          if (!this.cloudSelectedShopIds.includes(id)) this.cloudSelectedShopIds.push(id)
        })
      } else {
        this.cloudSelectedShopIds = this.cloudSelectedShopIds.filter(id => !ids.includes(id))
      }
      this.cloudShopSelect = ''
    },
    handleShopSelectChange() {
      const val = this.cloudShopSelect
      if (val !== '' && !this.cloudSelectedShopIds.includes(val)) {
        this.cloudSelectedShopIds.push(val)
      }
      this.cloudShopSelect = ''
    },
    toggleCloudShop(shopId) {
      const idx = this.cloudSelectedShopIds.indexOf(shopId)
      if (idx === -1) this.cloudSelectedShopIds.push(shopId)
      else this.cloudSelectedShopIds.splice(idx, 1)
    },
    submitCloudDistribute() {
      if (!this.cloudSelectedShopIds.length) {
        this.$message.error('请选择要铺货的店铺')
        return
      }
      const wasShare = this.shareDistributeMode
      const selected = wasShare ? this.shareSelectedList : this.cloudSelectedList
      const product_ids = selected.map(item => item.id)
      this.cloudDistributeLoading = true
      this.createCloudProductDistribute({
        data: { product_ids, shop_ids: this.cloudSelectedShopIds },
        success: (res) => {
          this.cloudDistributeLoading = false
          if (res.code === 200) {
            this.$message.success(res.message)
            this.distributeShow = false
            this.cloudSelectedShopIds = []
            this.cloudSelectedList = []
            this.shareSelectedList = []
            if (wasShare) this.getShares(this.sharePage.page)
            else this.getClouds(this.cloudPage.page)
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    /* ── 批量编辑 ── */
    handleCloudBatchEdit() {
      if (this.$refs.cloudProductBatchEdit) this.$refs.cloudProductBatchEdit.resetSkuBatchForm()
      if (this.cloudSelectedList.length === 0) {
        this.cloudEditShow = true
        this.cloudEditMode = 'batch'
        this.cloudEditUseRemoteList = true
        this.cloudEditSourceList = []
        this.cloudEditList = []
        this.cloudEditCurrent = null
        this.cloudEditDirty = false
        this.cloudEditGroupId = this.cloudSearch.group_id || ''
        this.cloudEditChildGroupId = this.cloudSearch.child_group_id || ''
        this.cloudEditChildGroupList = this.child_groupList || []
        this.cloudEditSkuStatus = this.cloudSearch.sku_status || ''
        this.cloudEditAppraisalStatus = ''
        this.cloudEditDistributeStatus = ''
        this.cloudEditPage = { page: 1, limit: 10, total: 0 }
        this.loadCloudEditRemoteList(true)
        return
      }
      const sourceList = this.cloudSelectedList
      const successProducts = sourceList.filter(item => item.status === 1)
      if (!successProducts.length) {
        this.$message.warning('当前没有可编辑的成功商品')
        return
      }
      if (successProducts.length < sourceList.length) {
        this.$message.warning(`已过滤非成功状态商品，将编辑 ${successProducts.length} 个商品`)
      }
      this.cloudEditShow = true
      this.cloudEditMode = 'batch'
      this.cloudEditUseRemoteList = false
      this.cloudEditSourceList = successProducts
      this.cloudEditGroupId = ''
      this.cloudEditChildGroupId = ''
      this.cloudEditChildGroupList = []
      this.cloudEditSkuStatus = ''
      this.cloudEditAppraisalStatus = ''
      this.cloudEditDistributeStatus = ''
      this.cloudEditList = successProducts
      this.cloudEditCurrent = successProducts[0]
      this.cloudEditDirty = false
      if (successProducts[0]) {
        this.loadCloudEditDetail(successProducts[0])
      } else {
        this.cloudEditForm = { id: null, title: '', main_images: [], three_four_images: [], white_images: [], detail_images: [], albb_attributes: '', skuSpecs: [], skus: [], skuValueImages: {} }
      }
    },
    loadCloudEditRemoteList(autoSelectFirst = false) {
      if (!this.cloudEditUseRemoteList) return
      this.cloudEditLoading = true
      const searchParams = {
        ...this.cloudSearch,
        status: 1,
        group_id: this.cloudEditGroupId,
        child_group_id: this.cloudEditChildGroupId,
        sku_status: this.cloudEditSkuStatus,
        appraisal_status: this.cloudEditAppraisalStatus
      }
      if (this.cloudEditDistributeStatus) {
        searchParams.has_distribute_success = this.cloudEditDistributeStatus === 'success' ? 1 : ''
        searchParams.has_distribute_fail = this.cloudEditDistributeStatus === 'fail' ? 1 : ''
        searchParams.has_distribute_ban = this.cloudEditDistributeStatus === 'ban' ? 1 : ''
        searchParams.has_distribute_review_fail = this.cloudEditDistributeStatus === 'review_fail' ? 1 : ''
      }
      const params = this.buildCloudListParams(this.cloudEditPage.page, this.cloudEditPage.limit, searchParams)
      this.getCloudProductList({
        data: params,
        success: (res) => {
          this.cloudEditLoading = false
          if (res.code === 200) {
            const list = res.data.list || []
            const total = res.data.total || 0
            if (list.length === 0 && total > 0 && this.cloudEditPage.page > 1) {
              this.cloudEditPage.page = 1
              this.loadCloudEditRemoteList(autoSelectFirst)
              return
            }
            this.cloudEditList = list
            this.cloudEditSourceList = list
            this.cloudEditPage.total = total
            const currentInList = this.cloudEditCurrent && list.some(item => item.id === this.cloudEditCurrent.id)
            if (autoSelectFirst || !currentInList) {
              const nextProduct = list[0] || null
              this.cloudEditCurrent = nextProduct
              this.cloudEditDirty = false
              if (nextProduct) {
                this.loadCloudEditDetail(nextProduct)
              } else {
                this.cloudEditForm = { id: null, title: '', main_images: [], three_four_images: [], white_images: [], detail_images: [], albb_attributes: '', skuSpecs: [], skus: [], skuValueImages: {} }
              }
            }
          }
        }
      })
    },
    loadCloudEditRemoteListPage(page) {
      if (this.cloudEditDirty) {
        this.$confirm('当前商品有未保存修改，确认切换分页吗？', '提示', { type: 'warning' }).then(() => {
          this.cloudEditDirty = false
          this.cloudEditPage.page = page
          this.loadCloudEditRemoteList(true)
        }).catch(() => {})
        return
      }
      this.cloudEditPage.page = page
      this.loadCloudEditRemoteList(true)
    },
    handleCloudEditFilterGroupChange() {
      this.cloudEditChildGroupId = ''
      this.cloudEditChildGroupList = this.groupList.find(i => i.id === this.cloudEditGroupId)?.child_groups || []
      this.handleCloudEditFilterChange()
    },
    handleCloudEditFilterChange() {
      this.cloudEditChildGroupList = this.groupList.find(i => i.id === this.cloudEditGroupId)?.child_groups || []
      if (this.cloudEditUseRemoteList) {
        const applyRemoteFilters = () => {
          this.cloudEditDirty = false
          this.cloudEditPage.page = 1
          this.loadCloudEditRemoteList(true)
        }
        if (this.cloudEditDirty) {
          this.$confirm('当前商品有未保存修改，确认切换筛选结果吗？', '提示', { type: 'warning' }).then(applyRemoteFilters).catch(() => {})
        } else {
          applyRemoteFilters()
        }
        return
      }
      const groupId = this.cloudEditGroupId
      const skuStatus = this.cloudEditSkuStatus
      const appraisalStatus = this.cloudEditAppraisalStatus
      const distributeStatus = this.cloudEditDistributeStatus
      const hasGroupFilter = !(groupId === '' || groupId === null || typeof groupId === 'undefined')
      const targetGroupId = Number(groupId)
      const filteredList = this.cloudEditSourceList.filter(item => {
        const itemGroupId = Number(item.group_id || 0)
        if (hasGroupFilter) {
          if (targetGroupId === -1) {
            if (itemGroupId) return false
          } else if (itemGroupId !== targetGroupId) {
            return false
          }
        }
        if (skuStatus !== '' && skuStatus !== null && typeof skuStatus !== 'undefined' && Number(item.sku_status) !== Number(skuStatus)) return false
        if (appraisalStatus !== '' && appraisalStatus !== null && typeof appraisalStatus !== 'undefined' && Number(item.appraisal_status) !== Number(appraisalStatus)) return false
        if (distributeStatus) {
          const countField = {
            success: 'distribute_success_count',
            fail: 'distribute_fail_count',
            ban: 'distribute_ban_count',
            review_fail: 'distribute_review_fail_count'
          }[distributeStatus]
          if (countField && Number(item[countField] || 0) <= 0) return false
        }
        return true
      })
      const switchFilteredList = () => {
        this.cloudEditList = filteredList
        const currentInFiltered = this.cloudEditCurrent && filteredList.some(item => item.id === this.cloudEditCurrent.id)
        if (currentInFiltered) return
        const nextProduct = filteredList[0] || null
        this.cloudEditCurrent = nextProduct
        this.cloudEditDirty = false
        if (nextProduct) {
          this.loadCloudEditDetail(nextProduct)
        } else {
          this.cloudEditForm = { id: null, title: '', main_images: [], three_four_images: [], white_images: [], detail_images: [], albb_attributes: '', skuSpecs: [], skus: [], skuValueImages: {} }
        }
      }
      if (this.cloudEditDirty) {
        this.$confirm('当前商品有未保存修改，确认切换筛选结果吗？', '提示', { type: 'warning' }).then(switchFilteredList).catch(() => {})
      } else {
        switchFilteredList()
      }
    },
    handleCloudEditSelect(item) {
      if (this.cloudEditCurrent && this.cloudEditCurrent.id === item.id) return
      const switchProduct = () => {
        if (this.$refs.cloudProductBatchEdit) this.$refs.cloudProductBatchEdit.resetSkuBatchForm()
        this.cloudEditCurrent = item
        this.loadCloudEditDetail(item)
      }
      if (this.cloudEditDirty) {
        this.$confirm('当前商品有未保存修改，确认切换商品吗？', '提示', { type: 'warning' }).then(switchProduct).catch(() => {})
      } else {
        switchProduct()
      }
    },
    loadCloudEditDetail(row) {
      if (!row || !row.id) return
      this.cloudEditLoading = true
      this.getCloudProductEditDetail({
        id: row.id,
        success: (res) => {
          this.cloudEditLoading = false
          if (res.code === 200) {
            const data = res.data || {}
            const skus = Array.isArray(data.skus) ? data.skus.map(item => ({
              id: item.id,
              attributes: this.normalizeSkuAttributes(item.attributes),
              price: Number(item.price || 0),
              stock: Number(item.stock || 0),
              description: item.description || '',
              code: item.code || '',
              image_url: item.image_url || '',
              enabled: item.enabled !== false && Number(item.status || 1) === 1
            })) : []
            this.cloudEditForm = {
              id: data.id,
              product_id: data.product_id,
              title: data.title || '',
              price: data.price || '',
              main_images: Array.isArray(data.main_images) ? data.main_images : [],
              three_four_images: Array.isArray(data.three_four_images) ? data.three_four_images : [],
              white_images: Array.isArray(data.white_images) ? data.white_images : [],
              detail_images: Array.isArray(data.detail_images) ? data.detail_images : [],
              albb_attributes: this.normalizeCloudProductAttributes(data.albb_attributes),
              skuSpecs: this.buildSkuSpecsFromSkus(skus),
              skus,
              skuValueImages: this.buildSkuValueImagesFromSkus(skus)
            }
            this.cloudEditDirty = false
            this.$nextTick(() => {
              if (this.$refs.cloudProductBatchEdit) {
                this.$refs.cloudProductBatchEdit.loadDistributeRecords(data.id)
              }
            })
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    markCloudEditDirty() {
      this.cloudEditDirty = true
    },
    closeCloudEdit() {
      if (this.cloudEditDirty) {
        this.$confirm('当前商品有未保存修改，确认关闭吗？', '提示', { type: 'warning' }).then(() => {
          this.cloudEditShow = false
          this.cloudEditDistributeStatus = ''
        }).catch(() => {})
        return
      }
      this.cloudEditShow = false
      this.cloudEditDistributeStatus = ''
    },
    submitCloudEdit() {
      if (!this.cloudEditForm.title || !this.cloudEditForm.title.trim()) {
        this.$message.warning('请填写商品标题')
        return
      }
      if (this.cloudEditForm.main_images.length < 3) {
        this.$message.warning('请至少保留三张商品图片')
        return
      }
      if (this.hasDuplicateImageUrls(this.cloudEditForm.main_images)) {
        this.$message.warning('商品图片不能重复')
        return
      }
      if (this.cloudEditForm.detail_images.length < 2) {
        this.$message.warning('请至少保留两张详情图片')
        return
      }
      if (this.hasDuplicateImageUrls(this.cloudEditForm.detail_images)) {
        this.$message.warning('详情图片不能重复')
        return
      }
      const hasEmptySkuValue = (this.cloudEditForm.skuSpecs || []).some(spec =>
        (spec.values || []).some(value => !String(value == null ? '' : value).trim())
      )
      if (hasEmptySkuValue) {
        this.$message.warning('规格值不能为空')
        return
      }
      const enabledSkus = this.cloudEditForm.skus.filter(sku => sku.enabled)
      if (!enabledSkus.length) {
        this.$message.warning('请至少保留一个SKU')
        return
      }
      const skuCodeMap = {}
      for (let i = 0; i < this.cloudEditForm.skus.length; i++) {
        const sku = this.cloudEditForm.skus[i]
        const code = String(sku.code == null ? '' : sku.code).trim()
        const label = this.formatSkuAttributes(sku.attributes) || `第 ${i + 1} 个SKU`
        if (!code) {
          this.$message.warning(`第 ${i + 1} 个SKU“${label}”未填写SKU编码`)
          return
        }
        if (skuCodeMap[code]) {
          this.$message.warning(`SKU编码“${code}”重复：第 ${skuCodeMap[code]} 个SKU与第 ${i + 1} 个SKU编码相同`)
          return
        }
        skuCodeMap[code] = i + 1
      }
      const invalidSkuIndex = enabledSkus.findIndex(sku => {
        const priceText = String(sku.price === null || typeof sku.price === 'undefined' ? '' : sku.price).trim()
        return !/^\d+(\.\d{1,2})?$/.test(priceText) || Number(priceText) <= 0
      })
      if (invalidSkuIndex !== -1) {
        this.$message.warning(`请填写第 ${invalidSkuIndex + 1} 个SKU价格，价格必须大于0且最多两位小数`)
        return
      }
      this.syncSkuImagesFromFirstSpec()
      this.cloudEditSaving = true
      this.saveCloudProductEditV2({
        id: this.cloudEditForm.id,
        data: {
          title: this.cloudEditForm.title,
          main_images: this.cloudEditForm.main_images,
          detail_images: this.cloudEditForm.detail_images,
          three_four_images: this.cloudEditForm.three_four_images || [],
          white_images: this.cloudEditForm.white_images || [],
          albb_attributes: JSON.stringify((this.cloudEditForm.albb_attributes || []).filter(item => item.attributeName && item.value).map(item => ({ attributeID: item.attributeID, attributeName: item.attributeName, value: item.value, isCustom: item.isCustom === true }))),
          skus: this.cloudEditForm.skus.map(sku => ({
            id: sku.id,
            attributes: sku.attributes || [],
            price: sku.price,
            stock: sku.stock,
            description: sku.description || '',
            code: String(sku.code == null ? '' : sku.code).trim(),
            image_url: sku.image_url || '',
            enabled: sku.enabled !== false
          }))
        },
        success: (res) => {
          this.cloudEditSaving = false
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.cloudEditDirty = false
            const row = res.data || {}
            const updateLocalRow = (item) => {
              if (item && item.id === row.id) {
                item.title = row.title
                item.main_image = row.main_image
                item.price = row.price
                item.updated_at_text = this.formatDateTime(new Date())
              }
            }
            this.cloudList.forEach(updateLocalRow)
            this.cloudEditList.forEach(updateLocalRow)
            if (this.cloudEditMode === 'single') {
              this.cloudEditShow = false
            } else {
              this.loadCloudEditDetail({ id: this.cloudEditForm.id })
            }
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    openEdit(row) {
      if (row.status !== 1) {
        this.$message.warning('只能编辑导入成功的商品')
        return
      }
      this.cloudEditShow = true
      if (this.$refs.cloudProductBatchEdit) this.$refs.cloudProductBatchEdit.resetSkuBatchForm()
      this.cloudEditMode = 'single'
      this.cloudEditUseRemoteList = false
      this.cloudEditSourceList = [row]
      this.cloudEditList = [row]
      this.cloudEditCurrent = row
      this.cloudEditDirty = false
      this.loadCloudEditDetail(row)
    },
    /* ── 图片 ── */
    openImageSourceDialog(target, skuIndex = -1) {
      const titleMap = { main: '添加商品图片', detail: '添加详情图片', ratio: '添加3/4图', white: '添加白底图', skuValue: '选择规格图片' }
      const existingUrlsMap = { main: this.cloudEditForm.main_images, detail: this.cloudEditForm.detail_images, ratio: this.cloudEditForm.three_four_images, white: this.cloudEditForm.white_images }
      this.imageSourceDialog = {
        visible: true,
        target,
        skuIndex,
        title: titleMap[target] || '添加图片',
        multiple: target !== 'skuValue',
        existingUrls: existingUrlsMap[target] || []
      }
    },
    handleImageSourceSelect(urls) {
      if (!Array.isArray(urls) || urls.length === 0) return
      if (this.imageSourceDialog.target === 'skuValue') {
        this.setSkuValueImage(this.imageSourceDialog.skuIndex, urls[0])
        return
      }
      const key = ({ detail: 'detail_images', ratio: 'three_four_images', white: 'white_images' })[this.imageSourceDialog.target] || 'main_images'
      const currentUrls = this.cloudEditForm[key] || []
      const currentSet = new Set(currentUrls)
      const pendingSet = new Set()
      const duplicateUrls = []
      const nextUrls = []
      urls.forEach(url => {
        if (currentSet.has(url) || pendingSet.has(url)) {
          duplicateUrls.push(url)
          return
        }
        pendingSet.add(url)
        nextUrls.push(url)
      })
      if (duplicateUrls.length) this.$message.warning('不能上传重复的图片')
      if (!nextUrls.length) return
      this.cloudEditForm[key].push(...nextUrls)
      this.markCloudEditDirty()
    },
    hasDuplicateImageUrls(urls) {
      const seen = new Set()
      return (urls || []).some(url => {
        if (seen.has(url)) return true
        seen.add(url)
        return false
      })
    },
    removeCloudEditImage(type, index) {
      const key = ({ detail: 'detail_images', ratio: 'three_four_images', white: 'white_images' })[type] || 'main_images'
      this.cloudEditForm[key].splice(index, 1)
      this.markCloudEditDirty()
    },
    moveCloudEditImage(type, index, step) {
      const key = ({ detail: 'detail_images', ratio: 'three_four_images', white: 'white_images' })[type] || 'main_images'
      const targetIndex = index + step
      const list = this.cloudEditForm[key]
      if (targetIndex < 0 || targetIndex >= list.length) return
      const current = list.splice(index, 1)[0]
      list.splice(targetIndex, 0, current)
      this.markCloudEditDirty()
    },
    setSkuValueImage(value, url) {
      if (!value) return
      this.$set(this.cloudEditForm.skuValueImages, value, url || '')
      this.syncSkuImagesFromFirstSpec()
      this.markCloudEditDirty()
    },
    clearSkuValueImage(value) {
      if (!value) return
      this.$delete(this.cloudEditForm.skuValueImages, value)
      this.syncSkuImagesFromFirstSpec()
      this.markCloudEditDirty()
    },
    /* ── SKU 规格 ── */
    normalizeSkuAttributes(attributes) {
      if (typeof attributes === 'string') {
        try {
          attributes = JSON.parse(attributes)
        } catch (e) {
          attributes = []
        }
      }
      if (attributes && typeof attributes === 'object' && !Array.isArray(attributes)) {
        attributes = Array.isArray(attributes.specs) ? attributes.specs : []
      }
      if (!Array.isArray(attributes)) return []
      const specs = attributes.specs && Array.isArray(attributes.specs) ? attributes.specs : attributes
      return specs.map(item => {
        if (Array.isArray(item)) {
          return [String(item[0] || '').trim(), String(item[1] || '').trim()]
        }
        return [
          String(item.name || item.attributeName || '').trim(),
          String(item.value || item.attributeValue || '').trim()
        ]
      }).filter(item => item[0] && item[1])
    },
    normalizeCloudProductAttributes(value) {
      for (let i = 0; i < 3 && typeof value === 'string'; i++) {
        try { value = JSON.parse(value) } catch (e) { return [] }
      }
      if (Array.isArray(value)) return value.map(item => {
        if (!item || typeof item !== 'object') return null
        const attributeName = String(item.attributeName || item.name || item.key || '').trim()
        const attributeValue = String(item.value == null ? (item.attributeValue == null ? '' : item.attributeValue) : item.value).trim()
        return attributeName && attributeValue ? { ...item, attributeName, value: attributeValue, isCustom: item.isCustom === true } : null
      }).filter(Boolean)
      if (value && typeof value === 'object') return Object.keys(value).map(key => ({ attributeID: 0, attributeName: key, value: String(value[key] == null ? '' : value[key]).trim(), isCustom: false })).filter(item => item.value)
      return []
    },
    formatSkuAttributes(attributes) {
      const specs = this.normalizeSkuAttributes(attributes)
      return specs.length ? specs.map(item => `${item[0]}:${item[1]}`).join(', ') : '默认规格'
    },
    getSkuAttributesKey(attributes) {
      return JSON.stringify(this.normalizeSkuAttributes(attributes))
    },
    buildSkuSpecsFromSkus(skus) {
      const specMap = []
      skus.forEach(sku => {
        this.normalizeSkuAttributes(sku.attributes).forEach(attr => {
          let spec = specMap.find(item => item.name === attr[0])
          if (!spec) {
            spec = { name: attr[0], key: attr[0], values: [] }
            specMap.push(spec)
          }
          if (!spec.values.includes(attr[1])) spec.values.push(attr[1])
        })
      })
      if (specMap.length === 0) return [{ name: '默认规格', key: '默认规格', values: ['标准'] }]
      return specMap
    },
    buildSkuValueImagesFromSkus(skus) {
      const valueImages = {}
      skus.forEach(sku => {
        const attrs = this.normalizeSkuAttributes(sku.attributes)
        const firstValue = attrs[0] && attrs[0][1]
        if (firstValue && sku.image_url && !valueImages[firstValue]) {
          valueImages[firstValue] = sku.image_url
        }
      })
      return valueImages
    },
    syncSkuImagesFromFirstSpec() {
      const valueImages = this.cloudEditForm.skuValueImages || {}
      this.cloudEditForm.skus.forEach(sku => {
        const attrs = this.normalizeSkuAttributes(sku.attributes)
        const firstValue = attrs[0] && attrs[0][1]
        this.$set(sku, 'image_url', firstValue ? (valueImages[firstValue] || '') : '')
      })
    },
    removeSkuSpecValue(specIndex, valueIndex) {
      const spec = this.cloudEditForm.skuSpecs[specIndex]
      if (!spec) return
      const value = spec.values[valueIndex]
      const nextSpecs = this.cloudEditForm.skuSpecs.map((item, index) => ({
        ...item,
        values: index === specIndex ? item.values.filter((_, idx) => idx !== valueIndex) : [...item.values]
      }))
      const specValueMap = {}
      nextSpecs.forEach(s => {
        const name = (s.name || '').trim()
        const values = (s.values || []).map(v => String(v).trim()).filter(Boolean)
        if (name && values.length) specValueMap[name] = new Set(values)
      })
      const enabledCount = this.cloudEditForm.skus.filter(sku => {
        const attrs = this.normalizeSkuAttributes(sku.attributes)
        return attrs.length && attrs.every(attr => specValueMap[attr[0]] && specValueMap[attr[0]].has(attr[1]))
      }).length
      if (enabledCount === 0) {
        this.$message.warning('请至少保留一个SKU规格值')
        return
      }
      spec.values.splice(valueIndex, 1)
      if (specIndex === 0 && value) this.$delete(this.cloudEditForm.skuValueImages, value)
      this.cloudEditForm.skus.forEach(sku => {
        const attrs = this.normalizeSkuAttributes(sku.attributes)
        const enabled = attrs.length && attrs.every(attr => specValueMap[attr[0]] && specValueMap[attr[0]].has(attr[1]))
        this.$set(sku, 'enabled', enabled)
      })
      this.syncSkuImagesFromFirstSpec()
      this.markCloudEditDirty()
    },
    /* ── 运费 ── */
    provinceName(code) {
      return areaData.province_list[code] || ''
    },
    handleViewFreight(row, shared = 0) {
      this.freightDetailVisible = true
      this.freightDetails = []
      this.getCloudProductFreightDetails({
        id: row.id,
        data: { shared },
        success: (res) => {
          if (res.code === 200) {
            this.freightDetails = res.data.freights || []
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    /* ── 删除/恢复 ── */
    handleCloudBatchDelete() {
      if (!this.cloudSelectedList.length) return
      this.$confirm(`确定要删除选中的 ${this.cloudSelectedList.length} 个商品吗？此操作不可恢复。`, '提示', { type: 'warning' }).then(() => {
        this.doDeleteCloudProducts(this.cloudSelectedList.map(item => item.id))
      }).catch(() => {})
    },
    deleteCloud(row) {
      this.$confirm('确定要删除该商品吗？此操作不可恢复。', '提示', { type: 'warning' }).then(() => {
        this.doDeleteCloudProducts([row.id])
      }).catch(() => {})
    },
    doDeleteCloudProducts(product_ids) {
      this.deleteCloudProducts({
        data: { ids: product_ids },
        success: (res) => {
          if (res.code === 200) {
            const { success_count, fail_count, fail_reasons } = res.data || {}
            this.getClouds(this.cloudPage.page)
            if (fail_count > 0) {
              let message = `成功删除 ${success_count} 个，失败 ${fail_count} 个。`
              if (fail_reasons && fail_reasons.length > 0) {
                message += `\n失败原因：\n${fail_reasons.map(r => r.reason || r).join('\n')}`
              }
              this.$alert(message, '删除结果', { confirmButtonText: '确定' })
            } else {
              this.$message.success('删除成功')
            }
            this.cloudSelectedList = []
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    recoverOne(row) {
      this.$confirm(`确定恢复商品「${row.title || row.id}」吗？`, '提示', { type: 'warning' }).then(() => {
        this.opRecoverCloudProduct({
          data: { ids: [row.id] },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('恢复成功')
              this.getClouds(this.cloudPage.page)
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }).catch(() => {})
    },
    handleCloudBatchRecover() {
      if (!this.cloudSelectedList.length) return
      this.$confirm(`确定恢复选中的 ${this.cloudSelectedList.length} 个商品吗？`, '提示', { type: 'warning' }).then(() => {
        this.opRecoverCloudProduct({
          data: { ids: this.cloudSelectedList.map(item => item.id) },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('恢复成功')
              this.cloudSelectedList = []
              this.getClouds(this.cloudPage.page)
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }).catch(() => {})
    },
    /* ── 分组 ── */
    loadGroups() {
      this.getCloudProductGroups({
        data: {},
        success: (res) => {
          if (res.code === 200) this.groupList = res.data || []
        }
      })
    },
    getGroupList(page) {
      this.groupPage.page = page
      this.resetGroupChildren()
      this.groupLoading = true
      const requestId = ++this.groupParentRequestId
      const params = { page: this.groupPage.page, page_size: this.groupPage.limit, ...this.groupSearch }
      this.getCloudProductGroupParents({
        data: params,
        success: (res) => {
          if (requestId !== this.groupParentRequestId) return
          this.groupLoading = false
          if (res.code === 200) {
            this.groupTableData = res?.data?.list || []
            this.groupPage.total = res?.data?.total || 0
          } else {
            this.groupTableData = []
            this.groupPage.total = 0
            this.$message.error(res.message || res.msg || '获取主分组失败')
          }
        }
      })
    },
    handleGroupSearch() {
      this.groupPage.page = 1
      this.getGroupList(1)
    },
    refreshGroupList() {
      this.groupPage.page = 1
      this.groupSearch = { main_name: '', child_name: '' }
      this.getGroupList(1)
    },
    resetGroupChildren() {
      ++this.groupChildrenRequestId
      this.groupExpandedParentId = null
      this.groupChildrenData = []
      this.groupChildrenLoading = false
      this.groupChildrenPage = { limit: 50, page: 1, total: 0 }
    },
    handleGroupParentToggle(parent) {
      if (this.groupExpandedParentId === parent.id) {
        this.resetGroupChildren()
        return
      }
      this.groupExpandedParentId = parent.id
      this.groupChildrenData = []
      this.groupChildrenPage = { limit: 50, page: 1, total: 0 }
      this.loadGroupChildren(parent.id, true)
    },
    loadGroupChildren(parentId, reset = false) {
      if (parentId !== this.groupExpandedParentId) return
      if (reset) {
        this.groupChildrenData = []
        this.groupChildrenPage.page = 1
      }
      this.groupChildrenLoading = true
      const requestId = ++this.groupChildrenRequestId
      this.getCloudProductGroupChildren({
        parentId,
        data: {
          page: this.groupChildrenPage.page,
          page_size: this.groupChildrenPage.limit,
          name: this.groupSearch.child_name,
        },
        success: (res) => {
          if (requestId !== this.groupChildrenRequestId || parentId !== this.groupExpandedParentId) return
          this.groupChildrenLoading = false
          if (res.code === 200) {
            const list = res?.data?.list || []
            this.groupChildrenData = reset ? list : [...this.groupChildrenData, ...list]
            this.groupChildrenPage.total = res?.data?.total || 0
            this.groupChildrenPage.page = res?.data?.page || this.groupChildrenPage.page
          } else {
            this.$message.error(res.message || res.msg || '获取子分组失败')
          }
        }
      })
    },
    loadMoreGroupChildren(parentId) {
      if (this.groupChildrenLoading || parentId !== this.groupExpandedParentId || this.groupChildrenData.length >= this.groupChildrenPage.total) return
      ++this.groupChildrenPage.page
      this.loadGroupChildren(parentId)
    },
    isGroupMoveLoading(row) {
      return Boolean(this.groupMoveLoading[row.id])
    },
    moveGroup(row, direction) {
      if (!row.editable || this.isGroupMoveLoading(row)) return
      this.$set(this.groupMoveLoading, row.id, true)
      this.opCloudProductGroupMove({
        id: row.id,
        data: { direction },
        success: (res) => {
          this.$delete(this.groupMoveLoading, row.id)
          if (res.code !== 200) {
            this.$message.error(res.message || res.msg || '排序调整失败')
            return
          }
          if (!res?.data?.moved) return

          this.$message.success('排序已调整')
          this.loadGroups()
          if (row.parent_id === 0) {
            this.getGroupList(this.groupPage.page)
            return
          }
          if (this.groupExpandedParentId === row.parent_id) {
            this.groupChildrenData = []
            this.groupChildrenPage.total = 0
            this.loadGroupChildren(row.parent_id)
          }
        },
        fail: (error) => {
          this.$delete(this.groupMoveLoading, row.id)
          this.$message.error(error.message || '排序调整失败，请稍后重试')
        }
      })
    },
    handleAddGroup() {
      this.groupForm = { id: null, name: '', child_name: '', grade: 1, parent_id: '', sort: 0 }
      this.groupFormEdit = false
      this.groupFormShow = true
    },
    handleAddChildGroup(parent) {
      this.groupForm = { id: null, name: '', child_name: '', grade: 2, parent_id: parent.id, sort: 0 }
      this.groupFormEdit = false
      this.groupFormShow = true
    },
    handleEditGroup(row) {
      this.groupForm = { id: row.id, name: row.name, child_name: '', sort: row.sort || 0, grade: row.parent_id === 0 ? 1 : 2, parent_id: row.parent_id }
      this.groupFormEdit = true
      this.groupFormShow = true
    },
    submitGroupForm() {
      if (!this.groupForm.name || !this.groupForm.name.trim()) {
        this.$message.warning('请输入分组名称')
        return
      }
      if (this.groupForm.grade === 2 && !this.groupForm.parent_id) {
        this.$message.warning('请选择主分组')
        return
      }
      if (!this.groupFormEdit && this.groupForm.grade === 1 && (!this.groupForm.child_name || !this.groupForm.child_name.trim())) {
        this.$message.warning('请输入首个子分组名称')
        return
      }
      if (this.groupFormLoading) return
      this.groupFormLoading = true
      const data = { name: this.groupForm.name.trim(), sort: this.groupForm.sort || 0 }
      if (this.groupForm.grade === 2) data.parent_id = this.groupForm.parent_id
      else if (!this.groupFormEdit) data.child_name = this.groupForm.child_name.trim()
      const done = (res, msg) => {
        this.groupFormLoading = false
        if (res.code === 200) {
          this.$message.success(msg)
          this.groupFormShow = false
          this.getGroupList(this.groupPage.page)
          this.loadGroups()
        } else {
          this.$message.error(res.message || res.msg || '保存失败')
        }
      }
      if (this.groupFormEdit) {
        this.opCloudProductGroupUpdate({ id: this.groupForm.id, data, success: (res) => done(res, '修改成功') })
      } else {
        this.opCloudProductGroupCreate({ data, success: (res) => done(res, '添加成功') })
      }
    },
    handleDeleteGroup(row) {
      this.$confirm(`确定要删除分组「${row.name}」吗？`, '提示', { type: 'warning' }).then(() => {
        this.opCloudProductGroupDelete({
          id: row.id,
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('删除成功')
              this.getGroupList(this.groupPage.page)
              this.loadGroups()
            } else {
              this.$message.error(res.message)
            }
          }
        })
      }).catch(() => {})
    },
    formatGroupName(row) {
      let group_name = row.group_name
      const target = this.groupList.find(i => i.id === row.group_id)?.child_groups?.find(i => i.id === row.child_group_id)
      const child_group_name = target && target.name
      if (child_group_name) group_name += '|' + child_group_name
      return group_name
    },
    handleBatchSetGroup() {
      if (!this.cloudSelectedList.length) {
        this.$message.warning('请先选择商品')
        return
      }
      this.batchGroupId = 0
      this.batchChildGroupId = 0
      this.set_child_groupList = []
      this.batchGroupShow = true
    },
    changeSetGroupId() {
      this.batchChildGroupId = 0
      this.set_child_groupList = this.groupList.find(i => i.id === this.batchGroupId)?.child_groups || []
    },
    submitBatchSetGroup() {
      if (this.batchGroupLoading) return
      this.batchGroupLoading = true
      const group_id = this.batchGroupId == 0 ? null : this.batchGroupId
      const child_group_id = this.batchChildGroupId == 0 ? null : this.batchChildGroupId
      this.opCloudProductBatchSetGroup({
        data: { product_ids: this.cloudSelectedList.map(item => item.id), group_id, child_group_id },
        success: (res) => {
          this.batchGroupLoading = false
          if (res.code === 200) {
            this.$message.success('设置成功')
            this.batchGroupShow = false
            this.cloudSelectedList = []
            this.loadGroups()
            this.getClouds(this.cloudPage.page)
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    /* ── 替换记录 ── */
    openDistributeRecord(row) {
      this.distributeRecordProduct = row
      this.distributeRecordShow = true
    },
    openReplaceLog(row) {
      this.replaceLogShow = true
      this.replaceLogItemId = row.id
      this.replaceLogPage.page = 1
      this.replaceLogList = []
      this.getReplaceLogPage(1)
    },
    getReplaceLogPage(page) {
      if (!this.replaceLogItemId) return
      this.replaceLogPage.page = page
      this.getReplaceLogList({
        data: { import_item_id: this.replaceLogItemId, page: this.replaceLogPage.page, page_size: this.replaceLogPage.limit },
        success: (res) => {
          if (res.code === 200) {
            this.replaceLogList = res.data.list || []
            this.replaceLogPage.total = res.data.total || 0
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleViewReplaceTitleLogs(row) {
      if (!row.product_id) {
        this.$message.error('商品ID异常')
        return
      }
      this.opGetFindByProductid({
        data: row.product_id,
        success: (res) => {
          if (res.code === 200) {
            this.replaceTitleLogList = res.data || []
            this.replaceTitleLogShow = true
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    /**
     *  ── SKU替换（以图搜款） ── */
    handleCloudImageSearch() {
      this.replace_title = 'SKU替换'
      this.aiReplace = false
      this.aiMarkMode = false
      this.openImageSearchFlow()
    },
    // 单个搜款
    openSkuReplace(row) {
      if (row.status !== 1) {
        this.$message.warning('只能对导入成功的商品进行SKU替换')
        return
      }
      this.replace_title = 'SKU替换'
      this.aiReplace = false
      this.aiMarkMode = false
      this.imageSearchCache = {}
      this.selectedReplaceMap = {}
      this.imageSearchList = [row]
      this.imageSearchShow = true
      this.replacedProductIds = []
      this.replacedTargetMap = {}
      this.skuPage = { limit: 20, page: 1, total: 1 }
      this.handleSelectSearchProduct(row)
    },
    handleAICloudBatchImageSearch() {
      this.$confirm('使用AI-SKU替换需要配合插件使用，请勿自行替换，避免损失算力?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.replace_title = 'AI-SKU替换'
        this.aiReplace = true
        this.aiMarkMode = false
        this.openImageSearchFlow()
      }).catch(() => {})
    },
    openImageSearchFlow() {
      this.syncSkuReplaceFiltersFromCloudSearch()
      this.imageSearchShow = true
      this.replacedProductIds = []
      this.replacedTargetMap = {}
      this.getSkuReplaceList(true)
    },
    syncSkuReplaceFiltersFromCloudSearch() {
      this.skuGroupId = this.cloudSearch.group_id || ''
      this.skuChildGroupId = this.cloudSearch.child_group_id || ''
      this.skuMarkStatusValue = this.cloudSearch.sku_mark_status || ''
      this.sku_child_groupList = this.skuGroupId ? (this.groupList.find(i => i.id === this.skuGroupId)?.child_groups || []) : []
    },
    getSkuReplaceList(isClick) {
      this.skuLoading = true
      const params = {
        page: this.skuPage.page,
        page_size: this.skuPage.limit,
        status: 1,
        sku_status: this.skuStatusValue,
        sku_mark_status: this.skuMarkStatusValue,
        group_id: this.skuGroupId,
        child_group_id: this.skuChildGroupId,
        appraisal_status: this.appraisalStatusValue,
        is_sku_miss: this.skuIsSkuMiss
      }
      if (params.sku_status === '') delete params.sku_status
      if (params.sku_mark_status=='') delete params.sku_mark_status
      if (params.group_id === '') delete params.group_id
      if (params.child_group_id === '') delete params.child_group_id
      if (params.appraisal_status === '') delete params.appraisal_status
      if (params.is_sku_miss === '') delete params.is_sku_miss
      this.getCloudProductList({
        data: params,
        success: (res) => {
          this.skuLoading = false
          if (res.code === 200) {
            this.imageSearchList = res.data.list || []
            this.skuPage.total = res.data.total || 0
            if (!this.imageSearchList.length) return
            let index = 0
            if (this.batchLinkVisible && this.currentSearchProductIndex >= 0) {
              index = this.currentSearchProductIndex
            }
            if (isClick && !this.batchLinkVisible) {
              this.handleSelectSearchProduct(this.imageSearchList[index])
            }
            if (this.batchLinkVisible) {
              this.handleSelectLinkProduct(this.imageSearchList[index], index)
            }
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleSkuPagination({ page, limit }) {
      this.skuPage.page = page
      this.skuPage.limit = limit
      this.getSkuReplaceList(true)
    },
    searchSkuReplaceList() {
      this.skuPage.page = 1
      this.getSkuReplaceList(true)
    },
    searchSkuGroupReplaceList() {
      this.skuChildGroupId = ''
      this.sku_child_groupList = this.groupList.find(i => i.id === this.skuGroupId)?.child_groups || []
      this.searchSkuReplaceList()
    },
    handleMarkNotFound(item, index) {
      this.opSkuMarkNotFound({
        data: { ids: [item.id], aiReplace: this.aiReplace },
        success: (res) => {
          if (res.code === 200) {
            this.$message.success('标记成功')
            this.updateSkuReplaceList(index, 3)
          } else {
            this.$message.error(res.message)
          }
          this.power_num = (res.data && res.data.power_num) || 0
        }
      })
    },
    handleCancelNotFound(item, index) {
      this.opSkuCancelNotFound({
        data: { ids: [item.id] },
        success: (res) => {
          if (res.code === 200) {
            this.$message.success('操作成功')
            this.updateSkuReplaceList(index, 1)
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    updateSkuReplaceList(index, status) {
      this.imageSearchList[index].sku_status = status
      if (index < this.imageSearchList.length - 1) {
        const nextProduct = this.imageSearchList.find((item, i) => !this.replacedProductIds.includes(item.id) && i > index && item.sku_status == 1)
        if (nextProduct) {
          if (!this.aiReplace) this.handleSelectSearchProduct(nextProduct)
        } else {
          index = this.imageSearchList.length - 1
        }
      }
      if (index === this.imageSearchList.length - 1 && this.skuPage.page < Math.ceil(this.skuPage.total / this.skuPage.limit)) {
        this.skuPage.page++
        this.getSkuReplaceList(true)
      }
    },
    handleSelectSearchProduct(item) {
      if (this.currentSearchProduct && this.currentSearchProduct.id === item.id) return
      this.imageSearchResult = []
      this.imageSearchResultCopy = []
      this.currentSearchProduct = item
      const cacheKey = this.getCacheKey(item.id)
      if (this.imageSearchCache[cacheKey]) {
        const cached = this.imageSearchCache[cacheKey]
        this.imageSearchResult = cached.results
        this.imageSearchResultCopy = [...this.imageSearchResult]
        this.changePriceSort()
        this.currentProductDetail = cached.productDetail
        return
      }
      this.currentProductDetail = null
      this.doImageSearch(item.id)
    },
    changePriceSort() {
      if (this.priceSort === 'price_asc') {
        this.imageSearchResult.sort((a, b) => a.price - b.price)
      } else if (this.priceSort === 'price_desc') {
        this.imageSearchResult.sort((a, b) => b.price - a.price)
      } else {
        this.imageSearchResult = [...this.imageSearchResultCopy]
      }
    },
    doImageSearch(id) {
      this.imageSearchLoading = true
      const requestData = { id }
      if (this.searchFilters.length > 0) {
        requestData.filter = this.searchFilters.join(',')
      }
      this.getImageSearchList({
        data: requestData,
        success: (res) => {
          this.imageSearchLoading = false
          if (res.code === 200) {
            const results = (res.data && res.data.search_results) || []
            this.imageSearchResult = results
            this.imageSearchResultCopy = [...this.imageSearchResult]
            this.changePriceSort()
            const productDetail = (res.data && res.data.current_product) || null
            this.currentProductDetail = productDetail
            if (results.length > 0) {
              const cacheKey = this.getCacheKey(id)
              this.$set(this.imageSearchCache, cacheKey, { results, productDetail })
            }
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleUseResult(result) {
      if (!this.currentSearchProduct) return
      const productId = this.currentSearchProduct.id
      this.$confirm(
          `确认将「${String(this.currentSearchProduct.title).substring(0, 30)}${this.currentSearchProduct.title.length > 30 ? '...' : ''}」${ this.aiMarkMode ?'标记为: ': '替换为: '}「${String(result.title).substring(0, 30)}${result.title.length > 30 ? '...' : ''}」（¥${result.price}）吗？`,
          this.aiMarkMode ? '确认标记商品' : '确认替换SKU',
          {
        confirmButtonText: this.aiMarkMode ? '确认标记' : '确认替换',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.aiMarkMode) {
          this.doSingleProductMark(productId, result)
          return
        }
        this.doSingleReplace(productId, result.offer_id)
      }).catch(() => {})
    },
    doSingleReplace(productId, offerId) {
      this.lrLoading = true
      this.doReplaceCloudProducts({
        data: {
          id: parseInt(productId),
          new_product_id: offerId,
          aiReplace: this.aiReplace
        },
        success: (res) => {
          this.lrLoading = false
          if (res.code === 200) {
            if (!this.replacedProductIds.includes(productId)) this.replacedProductIds.push(productId)
            this.$set(this.replacedTargetMap, productId, offerId)
            this.$delete(this.selectedReplaceMap, productId)
            const item = this.imageSearchList.find(p => p.id === productId)
            if (item) {
              item.updated_at_text = this.formatDateTime(new Date())
              if (res.data && res.data.min_price !== undefined) item.price = res.data.min_price
              item.sku_status = 2
            }
            if (res.data && res.data.skus) {
              const newSkus = res.data.skus
              const cacheKey = this.getCacheKey(productId)
              if (this.imageSearchCache[cacheKey]) {
                const newProductDetail = {
                  ...(this.imageSearchCache[cacheKey].productDetail || {}),
                  skus: newSkus
                }
                this.imageSearchCache[cacheKey].productDetail = newProductDetail
                if (this.currentSearchProduct && this.currentSearchProduct.id === productId) {
                  this.currentProductDetail = newProductDetail
                }
              } else if (this.currentSearchProduct && this.currentSearchProduct.id === productId) {
                this.currentProductDetail = {
                  ...(this.currentProductDetail || {}),
                  skus: newSkus
                }
              }
            }
            const imageSearchListIndex = this.imageSearchList.findIndex(item => item.id === productId)
            const nextProduct = this.imageSearchList.find((item, index) => (!this.replacedProductIds.includes(item.id) && index > imageSearchListIndex && item.sku_status == 1))
            if (nextProduct) {
              if (!this.aiReplace) {
                setTimeout(() => this.handleSelectSearchProduct(nextProduct), 800)
              }
            } else {
              this.$message.success('替换提交成功，所有商品已处理完成')
            }
          } else {
            this.$message.error(res.message || '替换失败')
            if (this.aiReplace) {
              const index = this.imageSearchList.findIndex(p => p.id === productId)
              if (index > -1) this.handleMarkNotFound(this.imageSearchList[index], index)
              return
            }
          }
          this.power_num = (res.data && res.data.power_num) || 0
        }
      })
    },
    handleViewProduct(result) {
      let url = ''
      if (result.detail_url) {
        url = result.detail_url
      } else if (result.offer_id) {
        url = `https://detail.1688.com/offer/${result.offer_id}.html`
      }
      if (url) {
        const a = document.createElement('a')
        a.href = url
        a.target = '_blank'
        a.rel = 'noopener noreferrer'
        a.click()
      }
    },
    handleCancelImageSearch() {
      const hasReplaced = this.replacedProductIds.length > 0
      this.imageSearchShow = false
      this.batchLinkVisible = false
      this.imageSearchCache = {}
      this.selectedReplaceMap = {}
      this.currentSearchProduct = null
      this.currentProductDetail = null
      this.imageSearchResult = []
      this.searchFilters = []
      this.pendingFilters = []
      this.strategyType = ''
      this.filterVisible = false
      this.replacedProductIds = []
      this.replacedTargetMap = {}
      this.aiReplace = false
      this.aiMarkMode = false
      this.replaceLink = ''
      this.alternativeLinks = []
      if (hasReplaced) {
        this.getClouds(this.cloudPage.page)
      }
    },
    getCacheKey(productId) {
      const filterKey = this.searchFilters.length > 0 ? this.searchFilters.sort().join(',') : 'none'
      return `${productId}-${filterKey}`
    },
    getReplacedCount() {
      return this.replacedProductIds.length
    },
    changeFilter(val) {
      let index = this.pendingFilters.findIndex(i => i.value == val.value)
      if (index === -1) this.pendingFilters.push(val)
      else this.pendingFilters.splice(index, 1)
    },
    handleApplyFilters() {
      if (!this.pendingFilters.length) {
        this.handleClearAllFilters()
        return
      }
      this.searchFilters = this.pendingFilters.map(filter => filter.value)
      if(this.strategyType){
        this.strategyCache.value[this.strategyType] = [...this.pendingFilters]
        this.strategyCache.ex_time =new Date().getTime()+24*60*60*1000
        localStorage.setItem('strategyCache', JSON.stringify(this.strategyCache))
      }
      if (this.currentSearchProduct) {
        this.imageSearchResult = []
        this.doImageSearch(this.currentSearchProduct.id)
      }
    },
    handleClearAllFilters() {
      this.searchFilters = []
      this.pendingFilters = []
      this.strategyType = ''
      if (this.currentSearchProduct) {
        this.imageSearchResult = []
        this.doImageSearch(this.currentSearchProduct.id)
      }
    },
    changeStrategy(type) {
      this.pendingFilters = []
      this.strategyType = this.strategyType === type ? '' : type
      if (!this.strategyType) {
        this.handleApplyFilters()
        return
      }
      if(this.strategyCache.value?.[this.strategyType]?.length){
        this.pendingFilters = this.strategyCache.value[this.strategyType]
        this.handleApplyFilters()
        return
      }
      this.pendingFilters = [
        { label: '48小时发货', value: 'shipIn48Hours' },
        { label: '支持一件代发', value: 'isOnePsale' },
        { label: '支持抖音密文打单', value: 'dyCiphertext' }
      ]
      if (type === 1) {
        this.pendingFilters.push({ label: '一件代发包邮', value: 'isOnePsaleFreePost' })
      }
      this.handleApplyFilters()
    },
    formatPrice(price, index) {
      const arr = price ? String(price).split('.') : ['0', '00']
      return arr[index]
    },
    formatDateTime(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    /**
     *  ── 指定链接替换 ── */
    handleLinkReplace(row) {
      this.linkReplaceForm = {
        title: row.title,
        productId: row.id,
        replaceable: row.replaceable || [],
        produceLink: ''
      }
      this.linkReplaceVisible = true
    },
    submitLinkReplace() {
      if (!this.linkReplaceForm.produceLink) {
        this.$message.error('请输入1688商品链接')
        return
      }
      this.$confirm('确认将商品SKU替换成您提供的商品SKU吗？', '提示', { type: 'warning' }).then(async () => {
        const flag = await this.doReplaceCloudProductsFun(this.linkReplaceForm.productId, this.linkReplaceForm.produceLink)
        if (flag) {
          this.linkReplaceVisible = false
          this.getClouds(this.cloudPage.page)
        }
      }).catch(() => {})
    },
    handleCloudBatchLinkReplace() {
      this.batchLinkVisible = true
      this.aiReplace = false
      this.aiMarkMode = false
      this.syncSkuReplaceFiltersFromCloudSearch()
      this.replacedProductIds = []
      this.replaceLink = ''
      this.alternativeLinks = []
      this.getSkuReplaceList(true)
    },
    handleSelectLinkProduct(item, index) {
      this.currentSearchProductIndex = index
      this.alternativeLinks = item.replaceable || []
      this.replaceLink = ''
      this.handleSelectSearchProduct(item)
    },
    async submitBatchLinkReplace() {
      if (!this.replaceLink) {
        this.$message.error('请输入1688商品链接')
        return
      }
      if (!this.currentSearchProduct) return
      const flag = await this.doReplaceCloudProductsFun(this.currentSearchProduct.id, this.replaceLink)
      if (flag) {
        this.getSkuReplaceList(false)
      }
    },
    doReplaceCloudProductsFun(productId, link) {
      return new Promise((resolve) => {
        const newLink = link.substring(0, link.indexOf('.html'))
        const arr = newLink.split('/')
        const goodsId = arr[arr.length - 1]
        if (!goodsId) {
          this.$message.error('链接格式不正确')
          resolve(false)
          return
        }
        this.lrLoading = true
        this.doReplaceCloudProducts({
          data: {
            id: parseInt(productId),
            new_product_id: goodsId,
            aiReplace: false
          },
          success: (res) => {
            this.lrLoading = false
            if (res.code === 200) {
              this.$message.success(res.message)
              if (!this.replacedProductIds.includes(productId)) this.replacedProductIds.push(productId)
              resolve(true)
            } else {
              this.$message.error(res.message)
              resolve(false)
            }
          }
        })
      })
    },
    /**
     *  ── 共享商品库 ── */
    getShares(page) {
      this.sharePage.page = page
      const params = { page: this.sharePage.page, page_size: this.sharePage.limit, ...this.shareSearch }
      if (params.batch_no === '') delete params.batch_no
      if (params.keyword === '') delete params.keyword
      if (params.sku_status === '') delete params.sku_status
      if (params.distribution_free_postage === '') delete params.distribution_free_postage
      if (params.freight_province_code === '') delete params.freight_province_code
      if (params.min_price === '') delete params.min_price
      if (params.max_price === '') delete params.max_price
      if (params.distribute_status === '') delete params.distribute_status
      if (params.group_id === '') delete params.group_id
      if (params.child_group_id === '') delete params.child_group_id
      if (params.exclude_distributed && params.exclude_distributed.length > 0) {
        params.exclude_distributed = params.exclude_distributed.join(',')
      } else {
        delete params.exclude_distributed
      }
      this.getShareCloudProductList({
        data: params,
        success: (res) => {
          if (res.code === 200) {
            const list = res.data.list || res.data || []
            this.shareList = Array.isArray(list) ? list : []
            this.sharePage.total = res.data.total || 0
          }
        }
      })
    },
    handleShareSearch() {
      this.sharePage.page = 1
      this.getShares(1)
    },
    handleShareReset() {
      this.shareSearch = {
        batch_no: '', keyword: '', sku_status: '', distribution_free_postage: '',
        freight_province_code: '', min_price: '', max_price: '',
        exclude_distributed: [], distribute_status: '', group_id: '', child_group_id: ''
      }
      this.shareExcludeSelect = ''
      this.shareChildGroupList = []
      this.sharePage.page = 1
      this.getShares(1)
    },
    handleShareExcludeFilterChange() {
      const value = this.shareExcludeSelect || ''
      if (value === 'all') {
        this.shareSearch.exclude_distributed = ['all']
      } else if (value === '') {
        this.shareSearch.exclude_distributed = []
        this.shareSearch.distribute_status = ''
      } else {
        this.shareSearch.exclude_distributed = [value]
      }
      this.handleShareSearch()
    },
    handleShareGroupChange() {
      this.$set(this.shareSearch, 'child_group_id', '')
      this.shareChildGroupList = this.groupList.find(i => i.id === this.shareSearch.group_id)?.child_groups || []
      this.handleShareSearch()
    },
    toggleShareOne(row) {
      const idx = this.shareSelectedList.indexOf(row)
      if (idx > -1) this.shareSelectedList.splice(idx, 1)
      else this.shareSelectedList.push(row)
    },
    toggleShareAll() {
      if (this.shareAllChecked) this.shareSelectedList = []
      else this.shareSelectedList = this.shareList.slice()
    },
    /**
     *  ── 铺货列表 ──
     *  */
    getDistributeList(page) {
      this.distributePage.page = page
      const params = {
        page: this.distributePage.page,
        page_size: this.distributePage.limit,
        status: this.distributeSearch.status,
        shop_id: this.distributeSearch.shop_id,
        shop_type: this.distributeSearch.shop_type,
        keyword: this.distributeSearch.keyword
      }
      if (this.distributeSearch.start_at && this.distributeSearch.start_at.length > 1) {
        params.start_date = this.distributeSearch.start_at[0]
        params.end_date = this.distributeSearch.start_at[1]
      }
      // if (this.distributeSearch.start_date) params.start_date = this.distributeSearch.start_date
      // if (this.distributeSearch.end_date) params.end_date = this.distributeSearch.end_date
      if (params.status === '') delete params.status
      if (params.shop_id === '') delete params.shop_id
      if (params.keyword === '') delete params.keyword
      if (params.shop_type === '') delete params.shop_type
      this.getDistributeItems({
        data: params,
        success: (res) => {
          if (res.code === 200) {
            this.distributeList = res.data.list || []
            this.distributePage.total = res.data.total || 0
            if (this.distributePage.page === 1 && this.distributeSearch.status === '' && res.data.stats) {
              this.distributeStats = res.data.stats
            }
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleDistributeSearch() {
      this.distributePage.page = 1
      this.getDistributeList(1)
    },
    handleDistributeReset() {
      this.distributeSearch = { status: '', shop_id: '', keyword: '', shop_type: '', start_date: '', end_date: '' }
      this.distributePage.page = 1
      this.getDistributeList(1)
    },
    handleStatusTabClick(status) {
      if (this.distributeSearch.status === status) return
      this.distributeSearch.status = status
      this.handleDistributeSearch()
    },
    getFilterShopList() {
      this.getDdShopList({
        data: {},
        success: (res) => {
          if (res.code === 200) {
            const list = res.data.list ? (res.data.list.list || []) : (res.data || [])
            this.filterShopList = list
          }
        }
      })
    },
    handleViewGoods(row) {
      const menu = row.shop_type == 7 ? 'wx-mg' : 'dou-mg'
      const route = this.$router.resolve({
        path: '/new_goods_workbench',
        query: {
          menu,
          cloud_source_product_id: row.source_product_id,
          shop_id: row.shop_id,
          shop_type: row.shop_type
        }
      })
      window.open(route.href, '_blank')
    },
    // 铺货记录所属平台：优先用行内 shop_type，缺失时按 shop_id 从店铺列表兜底
    distributePlatform(row) {
      let type = (row.shop_type !== null && row.shop_type !== undefined && row.shop_type !== '') ? row.shop_type : null
      if (type === null) {
        const shop = this.filterShopList.find(s => s.shop_id == row.shop_id) ||
          this.cloudShopList.find(s => s.shop_id == row.shop_id)
        if (shop) type = shop.shop_type
      }
      if (type == 1) return { label: '抖音', cls: 'gx-cloud__plat--dy' }
      if (type == 7) return { label: '微信小店', cls: 'gx-cloud__plat--wx' }
      return { label: row.shop_type_text || '其他平台', cls: 'gx-cloud__plat--other' }
    },
    distributeStatusStyle(row) {
      const map = {
        1: ['#E6A23C', 'rgba(230,162,60,.1)', 'rgba(230,162,60,.3)'],
        2: ['#409EFF', 'rgba(64,158,255,.1)', 'rgba(64,158,255,.3)'],
        3: ['#F56C6C', 'rgba(245,108,108,.1)', 'rgba(245,108,108,.3)'],
        4: ['#67C23A', 'rgba(103,194,58,.1)', 'rgba(103,194,58,.3)']
      }
      const [color, bg, border] = map[row.status] || ['#909399', 'rgba(144,147,153,.1)', 'rgba(144,147,153,.3)']
      return { color, background: bg, border: `1px solid ${border}` }
    },
    /**
     *  ── 展示辅助 ── */
    skuStatusLabel(s) {
      const item = this.skuStatus[s]
      return item ? item.label : (s || '')
    },
    skuStatusCls(s) {
      const item = this.skuStatus[s]
      return item ? 'gx-cloud__status-txt gx-cloud__status-txt--' + item.type : ''
    },
    skuMarkStatusLabel(s) {
      const item = this.skuMarkStatus[s]
      return item ? item.label : (s || '')
    },
    skuMarkStatusCls(s) {
      const item = this.skuMarkStatus[s]
      return item ? 'gx-cloud__status-txt gx-cloud__status-txt--' + item.type : 'gx-cloud__status-txt gx-cloud__status-txt--selected-tag'
    },
    aiTitleStatusLabel(s) {
      const item = this.aiTitleStatus[s]
      return item ? item.label : this.aiTitleStatus[1].label
    },
    aiTitleStatusCls(s) {
      const item = this.aiTitleStatus[s]
      return item ? 'gx-cloud__status-txt gx-cloud__status-txt--' + item.type : 'gx-cloud__status-txt gx-cloud__status-txt--selected-tag'
    },
    getStatusLabel(obj,s){
      const item = obj[s]
      return item ? item.label : obj[1].label
    },
    getStatusCls(obj,s){
      const item = obj[s]
      return item ? 'gx-cloud__status-txt gx-cloud__status-txt--' + item.type : 'gx-cloud__status-txt gx-cloud__status-txt--selected-tag'
    },
    failureReason(row) {
      const failure = row.last_distribute_failure || null
      return failure ? String(failure.error_msg || '').trim() : ''
    },
    failureTagText(row) {
      return this.failureReason(row) ? '上货失败' : '无失败'
    },
    failureTagCls(row) {
      return this.failureReason(row) ? 'gx-cloud__tag--fail' : 'gx-cloud__tag--ok'
    },
    distributeShopCount(row, key) {
      const counts = row.distribute_shop_counts || {}
      return Number.isFinite(Number(counts[key])) ? Number(counts[key]) : 0
    },
    salesSnapshotValue(row, key) {
      const snapshot = row.sales_snapshot || {}
      const value = snapshot[key]
      return value === null || value === undefined || value === '' ? '--' : value
    },
    // 云商品「上新状态」标签：1 成功 / 2 失败，其余沿用状态文案
    publishTagText(row) {
      if (row.status === 1) return '成功'
      if (row.status === 2) return '失败'
      return row.status_text || '--'
    },
    publishTagCls(row) {
      if (row.status === 1) return 'gx-cloud__tag--ok'
      if (row.status === 2) return 'gx-cloud__tag--fail'
      return 'gx-cloud__tag--muted'
    },
    cloudStatusStyle(row) {
      const s = row.status
      const map = {
        0: ['#E6A23C', 'rgba(230,162,60,.1)', 'rgba(230,162,60,.3)'],
        1: ['#67C23A', 'rgba(103,194,58,.1)', 'rgba(103,194,58,.3)'],
        2: ['#F56C6C', 'rgba(245,108,108,.1)', 'rgba(245,108,108,.3)'],
        3: ['#909399', 'rgba(144,147,153,.1)', 'rgba(144,147,153,.3)'],
        4: ['#409EFF', 'rgba(64,158,255,.1)', 'rgba(64,158,255,.3)']
      }
      const [color, bg, border] = map[s] || ['#909399', 'rgba(144,147,153,.1)', 'rgba(144,147,153,.3)']
      return { color, background: bg, border: `1px solid ${border}` }
    },

    /**
     * ── 查看标记货源 ── */
    handleViewProductMarks(row) {
      this.productMarkViewShow = true
      this.productMarkViewLoading = true
      this.productMarkViewItems = []
      this.getProductMarkable({
        data: { id: row.id },
        success: (res) => {
          this.productMarkViewLoading = false
          if (res.code === 200) {
            this.productMarkViewItems = Array.isArray(res.data) ? res.data : []
          } else {
            this.$message.error(res.message || '获取标记货源失败')
          }
        }
      })
    },
    handleAICloudBatchProductMark() {
      this.$confirm('使用AI货源商品标记需要配合插件使用，请勿自行标记，避免损失算力', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.replace_title = 'AI-商品货源标记'
        this.aiReplace = false
        this.aiMarkMode = true
        this.imageSearchShow = true
        this.syncSkuReplaceFiltersFromCloudSearch()
        this.getSkuReplaceList(true)
      }).catch(() => {})
    },
    handleProductMarkNotFound(item,index) {
      this.opProductMarkNotFound({
        data: { ids: [item.id], operation_no: `product-mark-not-found:${item.id}` },
        success: (res) => {
          if (res.code === 200) {
            this.$message.success('标记成功')
            this.$set(this.imageSearchList[index], 'sku_mark_status', 3)
            this.power_num = res.data && res.data.power_num !== undefined ? res.data.power_num : this.power_num
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleProductMarkNotFoundCancel(item,index) {
      this.opProductMarkNotFoundCancel({
        data: { ids: [item.id] },
        success: (res) => {
          if (res.code === 200) {
            this.$message.success('操作成功')
            this.$set(this.imageSearchList[index], 'sku_mark_status', 1)
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    doSingleProductMark(productId, result) {
      this.replaceLoading = true
      this.doMarkCloudProduct({
        data: {
          id: parseInt(productId),
          new_product_id: result.offer_id
        },
        success: (res) => {
          this.replaceLoading = false
          if (res.code === 200) {
            if (!this.replacedProductIds.includes(productId)) {
              this.replacedProductIds.push(productId)
            }
            const item = this.imageSearchList.find(p => p.id === productId)
            if (item) {
              item.updated_at_text = this.formatDateTime(new Date())
              this.$set(item, 'sku_mark_status', 2)
            }
            this.power_num = res.data && res.data.power_num !== undefined ? res.data.power_num : this.power_num
            this.$message.success('标记商品成功')
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
  }
}
</script>

<style scoped>
.gx-cloud__tabs {
  display: flex;
  margin-bottom: 16px;
  flex-wrap: wrap;
  background: #FFFFFF;
  border: 1px solid #EBEEF5;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  width: fit-content;
}
.gx-cloud__tab {
  padding: 13px 18px 11px;
  border: none;
  cursor: pointer;
  background: transparent;
  font-size: 13px;
  color: #4A4A6A;
  position: relative;
  transition: color .15s;
  font-weight: 500;
}
.gx-cloud__tab:hover {
  color: #C8443C;
}
.gx-cloud__tab--on {
  color: #C8443C;
  font-weight: 600;
}
.gx-cloud__tab-beam {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  border-radius: 2px 2px 0 0;
  background: #C8443C;
}
.gx-cloud__import-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 0 20px;
  flex-wrap: wrap;
}
.gx-cloud__import-tip {
  font-size: 12px;
  color: #909399;
}
.gx-cloud__btn {
  height: 32px;
  padding: 0 13px;
  border-radius: 6px;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid #DCDFE6;
  font-size: 12px;
  color: #606266;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-weight: 500;
  transition: all .15s ease;
}
.gx-cloud__btn:hover:not(:disabled) {
  color: #C8443C;
  border-color: #FFCCC7;
  background: #FFF5F4;
}
.gx-cloud__btn--primary {
  color: #FFFFFF;
  box-shadow: 0 2px 4px rgba(232, 93, 78, .25);

  font-size: 13px;
  font-weight: 600;
  background: linear-gradient(135deg, rgb(255, 77, 79), rgb(255, 120, 117));
  border: none;
  color: rgb(255, 255, 255);
  opacity: 1;
  transition: all 0.15s ease 0s;
  white-space: nowrap;

}
.gx-cloud__btn--primary:hover:not(:disabled) {
  background: linear-gradient(135deg, #D44A3C, #E8694A);
  color: #FFFFFF;
  box-shadow: 0 3px 8px rgba(232, 93, 78, .35);
}
.gx-cloud__btn--danger {
  background: #FFF1F0;
  color: #C8443C;
  border-color: #FFCCC7;
}
.gx-cloud__btn--danger:hover:not(:disabled) {
  background: #FFE5E3;
  border-color: #F5B5B0;
  color: #C8443C;
}
.gx-cloud__btn--recover {
  color: #67C23A;
  border-color: #B3E19D;
  background: #F0F9EB;
}
.gx-cloud__btn--ai {
  color: #8B5CF6;
  border-color: #D3C2F9;
  background: #F6F2FE;
}
.gx-cloud__btn--mark {
  color: #1677FF;
  border-color: #91CAFF;
  background: #E6F4FF;
}
.gx-cloud__btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-cloud__filter {
  background: #FFFFFF;
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  padding: 10px 14px;
  margin-bottom: 12px;
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  align-items: center;
}
.gx-cloud__fitem {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.gx-cloud__flabel {
  font-size: 12px;
  color: #4A4A6A;
  white-space: nowrap;
}
.gx-cloud__fitem--btns {
  margin-left: auto;
}
.gx-cloud__input {
  width: 140px;
  height: 30px;
  padding: 0 10px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  font-size: 12px;
  color: #1A1A2E;
  outline: none;
  box-sizing: border-box;
  transition: border-color .15s ease;
}
.gx-cloud__input:focus {
  border-color: #C8443C;
}
.gx-cloud__input--full {
  width: 100%;
}
.gx-cloud__input--num {
  width: 90px;
}
.gx-cloud__input--date {
  width: 130px;
}
.gx-cloud__range-sep {
  color: #6A6A8A;
  font-size: 12px;
}
.gx-cloud__select {
  height: 30px;
  padding: 0 8px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  background: #FFFFFF;
  font-size: 12px;
  color: #1A1A2E;
  outline: none;
  min-width: 120px;
  transition: border-color .15s ease;
}
.gx-cloud__select:focus {
  border-color: #C8443C;
}
.gx-cloud__select--full {
  width: 100%;
  min-width: 0;
}
.gx-cloud__card {
  border-radius: 10px;
  border: 2px solid rgb(224, 224, 236);
  background: #FFFFFF;
  overflow: visible;
  margin-bottom: 16px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  position: relative;
}
.gx-cloud__actionrow {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 0;
  border: none;
  border-radius: 0;
  margin-bottom: 0;
  flex-wrap: wrap;
}
.gx-cloud__actionrow__list {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  background: rgb(245, 240, 232);
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  padding: 9px 14px;
  margin-bottom: 12px;
}
.gx-cloud__status-tabs {
  display: flex;
  margin-bottom: 0;
  border-bottom: 1px solid #EFE6D2;
  background: #FAF6EE;
  flex-wrap: nowrap;
  overflow-x: auto;
}
.gx-cloud__status-tab {
  padding: 12px 16px 11px;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  background: transparent;
  font-size: 13px;
  color: #4A4A6A;
  position: relative;
  white-space: nowrap;
  flex-shrink: 0;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: color .15s ease, border-color .15s ease, background-color .15s ease;
}
.gx-cloud__status-tab:hover {
  color: #C8443C;
}
.gx-cloud__status-tab--on {
  color: #C8443C;
  font-weight: 600;
  border-bottom-color: #C8443C;
  background: #FFF5F5;
}
.gx-cloud__status-num {
  margin-left: 5px;
  padding: 0 6px;
  border-radius: 8px;
  background: #F0F1F5;
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  line-height: 16px;
  color: #6A6A8A;
}
.gx-cloud__status-tab--on .gx-cloud__status-num {
  background: #FDECEB;
  color: #C8443C;
}
.gx-cloud__table {
  border-radius: 0;
  overflow: visible;
  border: none;
  margin-bottom: 0;
  background: #FFFFFF;
}
.gx-cloud__table--plain {
  border: 1px solid #EBEEF5;
  border-radius: 10px;
  overflow: hidden;
}
.gx-cloud__table table {
  width: 100%;
  border-collapse: collapse;
}
.gx-cloud__table th {
  padding: 11px 14px;
  text-align: left;
  background: #FAF6EE;
  font-size: 12px;
  font-weight: 500;
  color: #4A4A6A;
  letter-spacing: .02em;
  white-space: nowrap;
  border-bottom: 1px solid #EFE6D2;
}
.gx-cloud__table td {
  padding: 12px 14px;
  font-size: 12px;
  color: #1A1A2E;
  border-top: 1px solid #EBEEF5;
  vertical-align: center;
}
.gx-cloud__check {
  width: 15px;
  height: 15px;
  border-radius: 4px;
  border: 1.5px solid #D0D0DD;
  background: #FFFFFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all .15s ease;
}
.gx-cloud__check:hover {
  border-color: #C8443C;
}
.gx-cloud__check--on {
  background: #C8443C;
  border-color: #C8443C;
  box-shadow: 0 1px 3px rgba(200, 68, 60, 0.18);
}
.gx-cloud__mono {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
}
.gx-cloud__dim {
  color: #6A6A8A;
}
.gx-cloud__gold {
  color: #C8443C;
  font-weight: 600;
}
.gx-cloud__link {
  color: #1677FF;
}
.gx-cloud__view-link {
  color: #1677FF;
  cursor: pointer;
  text-decoration: none;
}
.gx-cloud__view-link:hover {
  text-decoration: underline;
}
.gx-cloud__batch-link {
  color: #1677FF;
  cursor: pointer;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  text-decoration: none;
}
.gx-cloud__batch-link:hover {
  text-decoration: underline;
}
.gx-cloud__file {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-cloud__counts {
  white-space: nowrap;
  line-height: 1.6;
  font-size: 11px;
}
.gx-cloud__counts b {
  color: #1A1A2E;
}
.gx-cloud__ok b {
  color: #67C23A;
}
.gx-cloud__fail b {
  color: #F56C6C;
}
.gx-cloud__dup b {
  color: #E6A23C;
}
.gx-cloud__src {
  /* display: inline-block;
  min-width: 38px;
  text-align: center;
  padding: 2px 8px;
  border-radius: 6px;
  border: 1px solid #E4E7ED;
  background: #F4F5F7;
  font-size: 11px;
  font-weight: 600;
  color: #909399; */

    padding: 4px 8px;
    border-radius: 4px;
    background: rgba(251, 146, 60, 0.1);
    border: 1px solid rgba(251, 146, 60, 0.3);
    font-size: 11px;
    font-weight: 500;
    color: rgb(251, 146, 60);
    white-space: nowrap;
}
.gx-cloud__src--ali {
  background: #FBF3DF;
  border-color: #EFD49A;
  color: #C9962B;
}
.gx-cloud__src--tb {
  background: #FFF1F0;
  border-color: #FFCCC7;
  color: #C8443C;
}
.gx-cloud__src--pdd {
  background: #FFF3E8;
  border-color: #FFC9A8;
  color: #E8742C;
}
.gx-cloud__src--dy {
  background: #F0F1F5;
  border-color: #D0D4E0;
  color: #3A3A52;
}
.gx-cloud__src--wx {
  background: #F0F9EB;
  border-color: #B3E19D;
  color: #67C23A;
}
.gx-cloud__progress {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gx-cloud__progress-bar {
  width: 80px;
  height: 6px;
  border-radius: 3px;
  background: #F2F3F7;
  overflow: hidden;
}
.gx-cloud__progress-fill {
  display: block;
  height: 100%;
  background: linear-gradient(90deg, #E85D4E, #F47B5A);
  border-radius: 3px;
  transition: width .3s ease;
}
.gx-cloud__progress-val {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  color: #C8443C;
}
.gx-cloud__status {
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 11px;
  background: #F4F5F7;
  border: 1px solid #E4E7ED;
  color: #909399;
  white-space: nowrap;
  display: inline-block;
  width: fit-content;
  font-weight: 600;
}
.gx-cloud__status--ok {
  background: #F0F9EB;
  border-color: #B3E19D;
  color: #67C23A;
}
.gx-cloud__status--run {
  background: #ECF5FF;
  border-color: #A9CBFF;
  color: #409EFF;
}
.gx-cloud__status--wait {
  background: #FDF6EC;
  border-color: #F5DAB1;
  color: #E6A23C;
}
.gx-cloud__status--cancel {
  background: #F4F5F7;
  border-color: #E4E7ED;
  color: #909399;
}
.gx-cloud__statuscell {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 70px;
}
.gx-cloud__err {
  font-size: 11px;
  color: #F56C6C;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-cloud__err--multiline {
  display: -webkit-box;
  white-space: normal;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-word;
}
.gx-cloud__status-txt {
  font-size: 11px;
}
.gx-cloud__status-txt--selected-tag {
  color: #E6A23C;
}
.gx-cloud__status-txt--replaced-tag {
  color: #67C23A;
}
.gx-cloud__status-txt--notFond-tag {
  color: #F56C6C;
}
.gx-cloud__goods {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  min-width: 240px;
}
.gx-cloud__thumb {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  background: linear-gradient(135deg, #F2F3F7, #FFFFFF);
  border: 1px solid #EBEEF5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
  overflow: hidden;
}
.gx-cloud__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-cloud__thumb--preview {
  cursor: zoom-in;
}
.gx-cloud__thumb-image {
  width: 100%;
  height: 100%;
}
.gx-cloud__thumb-image ::v-deep .el-image__inner {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-cloud__thumb-image ::v-deep .el-image__error {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #909399;
  font-size: 20px;
}
.gx-cloud__goods-body {
  min-width: 0;
}
.gx-cloud__goods-name {
  font-size: 13px;
  color: #1A1A2E;
  line-height: 1.4;
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 240px;
}
.gx-cloud__goods-meta {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  color: #6A6A8A;
  line-height: 1.6;
}
.gx-cloud__freight {
  font-size: 11px;
  color: #4A4A6A;
  line-height: 1.7;
  white-space: nowrap;
}
.gx-cloud__group {
  font-size: 12px;
  color: #1A1A2E;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: bottom;
}
.gx-cloud__time {
  font-size: 11px;
  color: #6A6A8A;
  line-height: 1.7;
  white-space: nowrap;
}
.gx-cloud__shop {
  font-size: 12px;
  color: #1A1A2E;
}
.gx-cloud__tag {
  padding: 2px 8px;
  border-radius: 6px;
  border: 1px solid transparent;
  font-size: 11px;
  white-space: nowrap;
  display: inline-block;
}
.gx-cloud__tag--ok {
  background: #F0F9EB;
  border-color: #B3E19D;
  color: #67C23A;
}
.gx-cloud__tag--fail {
  background: #FFF1F0;
  border-color: #FFCCC7;
  color: #F56C6C;
}
.gx-cloud__ops {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  max-width: 260px;
}
.gx-cloud__op {
  height: 24px;
  padding: 0 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 11px;
  border: 1px solid #E4E7ED;
  background: #FFFFFF;
  color: #606266;
  white-space: nowrap;
  transition: all .15s;
}
.gx-cloud__op:hover:not(:disabled) {
  color: #C8443C;
  border-color: #FFCCC7;
  background: #FFF5F4;
}
.gx-cloud__op:disabled {
  color: #C0C4CC;
  cursor: not-allowed;
}
.gx-cloud__op--edit {
  background: #E6F4FF;
  border-color: #91CAFF;
  color: #1677FF;
}
.gx-cloud__op--edit:hover {
  background: #D6EFFF;
  border-color: #69B1FF;
  color: #1677FF;
}
.gx-cloud__op--primary {
  background: #FFF1F0;
  border-color: #FFCCC7;
  color: #C8443C;
}
.gx-cloud__op--primary:hover {
  background: #FFE5E3;
  border-color: #F5B5B0;
  color: #C8443C;
}
.gx-cloud__op--recover {
  background: #F0F9EB;
  border-color: #B3E19D;
  color: #67C23A;
}
.gx-cloud__op--recover:hover {
  background: #E1F3D8;
  color: #67C23A;
}
.gx-cloud__op--danger {
  background: #FFF1F0;
  border-color: #FFCCC7;
  color: #F56C6C;
}
.gx-cloud__op--danger:hover {
  background: #FFE5E3;
  border-color: #F5B5B0;
  color: #F56C6C;
}
.gx-cloud__empty {
  text-align: center;
  padding: 40px 0 !important;
  color: #6A6A8A;
}
.gx-cloud__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 10px 14px;
}
.gx-cloud__card .gx-cloud__pager {
  padding: 12px 16px;
  background: #FAF6EE;
  border-top: 1px solid #EFE6D2;
}
.gx-cloud__pager--sm {
  margin-top: 10px;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  background: transparent;
  border-top: none;
}
.gx-cloud__pager--sm .gx-cloud__pager-btns {
  flex-wrap: wrap;
  max-width: 100%;
}
.gx-cloud__pager--sm .gx-cloud__page {
  min-width: 26px;
  height: 26px;
  padding: 0 6px;
  font-size: 11px;
  border-radius: 5px;
}
.gx-cloud__pager-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.gx-cloud__pager-total {
  font-size: 12px;
  color: #606266;
}
.gx-cloud__pager-btns {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}
.gx-cloud__page {
  min-width: 30px;
  height: 30px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid #E4E7ED;
  background: #FFFFFF;
  cursor: pointer;
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: #606266;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all .15s ease;
}
.gx-cloud__page:hover:not(:disabled) {
  border-color: #C8443C;
  color: #C8443C;
}
.gx-cloud__page:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-cloud__page--on {
  background: #C8443C;
  border-color: #C8443C;
  color: #FFFFFF;
  font-weight: 700;
  box-shadow: 0 1px 4px rgba(200, 68, 60, 0.18);
}
.gx-cloud__page--arrow {
  padding: 0;
  min-width: 30px;
}
.gx-cloud__modal {
  position: fixed;
  inset: 0;
  z-index: 700;
  background: rgba(0, 0, 0, .48);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.gx-cloud__modal--wide {
  z-index: 720;
}
.gx-cloud__modal-box {
  width: 100%;
  max-width: 680px;
  border-radius: 16px;
  background: #FFFFFF;
  border: 1px solid #EBEEF5;
  box-shadow: 0 20px 56px rgba(15, 23, 42, .18);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}
.gx-cloud__modal-box--sm {
  max-width: 420px;
}
.gx-cloud__modal-box--lg {
  max-width: 640px;
}
.gx-cloud__modal-box--xl {
  max-width: 90%;
}
.gx-cloud__modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid #E1E5EE;
  flex-shrink: 0;
  background: rgb(245, 240, 232);
}
.gx-cloud__modal-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 15px;
  font-weight: 600;
  color: #1A1A2E;
  padding-left: 10px;
  position: relative; /* 必须加，让伪元素相对父元素定位 */
}
.gx-cloud__modal-title::before{
    width: 3px;
    height: 15px;
    border-radius: 2px;
    background: rgb(200, 68, 60);
    position: absolute;
    left: 0;
    top: 60%;
    transform: translateY(-50%);
    content: '';
}
.gx-cloud__modal-close {
      width: 26px;
    height: 26px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgb(255, 255, 255);
    border: 2px solid rgb(224, 224, 236);
    cursor: pointer;
}
.gx-cloud__modal-body {
  padding: 18px 20px;
  overflow-y: auto;
}
.gx-cloud__modal-body.over-hide {
  overflow-y: hidden;
}
.gx-cloud__modal-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid #E1E5EE;
  flex-shrink: 0;
  align-items: center;
  background: #FFFFFF;
}
.gx-cloud__field {
  margin-bottom: 14px;
}
.gx-cloud__label {
  display: block;
  font-size: 12px;
  color: #4A4A6A;
  margin-bottom: 6px;
}
.gx-cloud__label--checkbox {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}
.gx-cloud__req {
  color: #F56C6C;
  font-style: normal;
}
.gx-cloud__textarea {
  width: 100%;
  padding: 10px 12px;
  border-radius: 7px;
  border: 1px solid #DCDFE6;
  font-size: 13px;
  color: #1A1A2E;
  outline: none;
  box-sizing: border-box;
  resize: vertical;
  font-family: inherit;
  transition: border-color .15s ease;
}
.gx-cloud__textarea:focus {
  border-color: #C8443C;
}
.gx-cloud__source-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.gx-cloud__source-btn {
  height: 34px;
  padding: 0 18px;
  border-radius: 8px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  cursor: pointer;
  font-size: 13px;
  color: #4A4A6A;
  transition: all .16s;
}
.gx-cloud__source-btn--on {
  background: linear-gradient(135deg, #E85D4E, #F47B5A);
  border-color: transparent;
  color: #FFFFFF;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(232, 93, 78, .28);
}
.gx-cloud__upload-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.gx-cloud__upload-info {
  margin-top: 10px;
  font-size: 12px;
  color: #4A4A6A;
  line-height: 1.8;
}
.gx-cloud__tips {
  margin-top: 4px;
  color: #F56C6C;
  font-size: 11px;
  line-height: 1.7;
}
.gx-cloud__dirty {
  margin-right: auto;
  font-size: 12px;
  color: #E6A23C;
}
.gx-cloud__invalid {
  color: #F56C6C !important;
}
.gx-cloud__imgs {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.gx-cloud__img {
  position: relative;
  width: 72px;
  height: 72px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #E1E5EE;
}
.gx-cloud__img--lg {
  width: 84px;
  height: 84px;
}
.gx-cloud__img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-cloud__img-del {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, .5);
  color: #fff;
  font-size: 10px;
  cursor: pointer;
  line-height: 1;
}
.gx-cloud__img-tools {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  background: rgba(0, 0, 0, .55);
}
.gx-cloud__img-tool {
  flex: 1;
  border: none;
  background: transparent;
  color: #fff;
  font-size: 11px;
  cursor: pointer;
  padding: 3px 0;
}
.gx-cloud__img-tool--del {
  color: #FCA5A5;
}
.gx-cloud__edit-imgbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  flex-wrap: wrap;
  font-size: 12px;
}
.gx-cloud__sku-specs {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.gx-cloud__sku-spec-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.gx-cloud__sku-spec-name {
  font-size: 12px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-cloud__sku-spec-tag {
  padding: 3px 10px;
  border-radius: 12px;
  background: #FFF1F0;
  border: 1px solid #FFCCC7;
  font-size: 11px;
  color: #C8443C;
  cursor: pointer;
}
.gx-cloud__sku-val-imgs {
  margin-bottom: 10px;
}
.gx-cloud__sku-val-list {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 6px;
}
.gx-cloud__sku-val-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  border: 1px solid #E1E5EE;
  border-radius: 8px;
  font-size: 11px;
}
.gx-cloud__sku-val-name {
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-cloud__sku-val-thumb {
  width: 28px;
  height: 28px;
  border-radius: 5px;
  object-fit: cover;
}
.gx-cloud__batch-count {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 8px;
  background: #ECF5FF;
  border: 1px solid #A9CBFF;
  font-size: 12px;
  color: #409EFF;
  margin-bottom: 14px;
}
.gx-cloud__gm-name {
  font-weight: 500;
  vertical-align: middle;
}
.gx-cloud__gm-name--child {
  padding-left: 28px;
}
.gx-cloud__gm-tag {
  box-sizing: border-box;
  max-width: 100%;
  color: #C8443C;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  text-align: center;
  white-space: normal;
  word-break: break-word;
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 4px;
  background: rgba(200, 68, 60, 0.07);
  border: 1px solid rgba(200, 68, 60, 0.2);
}
.gx-cloud__sort-actions {
  display: inline-flex;
  gap: 4px;
  margin-left: 7px;
  vertical-align: middle;
}
.gx-cloud__sort-move {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: 1px solid #D8DDE6;
  border-radius: 3px;
  background: #FFF;
  color: #6A6A8A;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
}
.gx-cloud__sort-move:hover:not(:disabled) {
  border-color: #C8443C;
  background: #FFF5F5;
  color: #C8443C;
}
.gx-cloud__sort-move:disabled {
  cursor: not-allowed;
  opacity: .45;
}
/* 分组管理表：固定列布局，列宽只由表头决定，超长分组名在标签内折行完整显示，不再撑动整表 */
.gx-cloud__table--group table {
  table-layout: fixed;
}
.gx-cloud__table--group td {
  vertical-align: middle;
  word-break: break-word;
}
.gx-cloud__group-expand-col {
  width: 42px;
  text-align: center;
}
.gx-cloud__group-expand {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #6A6A8A;
  cursor: pointer;
}
.gx-cloud__group-expand:hover {
  background: #F4F5F7;
  color: #C8443C;
}
.gx-cloud__group-expand svg {
  transition: transform .16s ease;
}
.gx-cloud__group-expand--on svg {
  transform: rotate(90deg);
}
.gx-cloud__group-shared {
  display: inline-flex;
  margin-left: 6px;
  padding: 2px 6px;
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  color: #909399;
  font-size: 11px;
  line-height: 1.2;
  vertical-align: middle;
}
.gx-cloud__group-children-row > td {
  padding: 0 !important;
  background: #FAFBFC;
}
.gx-cloud__group-children {
  padding: 10px 20px 12px 42px;
}
.gx-cloud__group-children-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  background: #FFF;
  border: 1px solid #E8EBF0;
}
.gx-cloud__group-children-table th,
.gx-cloud__group-children-table td {
  padding: 9px 12px;
  border-bottom: 1px solid #EEF0F4;
  text-align: left;
}
.gx-cloud__group-children-table th {
  background: #F5F7FA;
  color: #6A6A8A;
  font-size: 12px;
  font-weight: 600;
}
.gx-cloud__group-children-table th:nth-child(2),
.gx-cloud__group-children-table th:nth-child(3) {
  width: 90px;
}
.gx-cloud__group-children-table th:nth-child(4) {
  width: 160px;
}
.gx-cloud__group-children-table th:nth-child(5) {
  width: 130px;
}
.gx-cloud__group-children-table tr:last-child td {
  border-bottom: none;
}
.gx-cloud__group-more {
  display: block;
  margin: 10px auto 0;
}
/* ── 铺货列表 tab ── */
/* 顶部提示条：米色底卡片 */
.gx-cloud__dist-alert {
  margin-bottom: 14px;
  border-radius: 10px;
  border: 1px solid #F7D9C4;
  background: #FDF3EC;
  padding: 9px 16px;

}
.gx-cloud__dist-alert ::v-deep .el-alert__icon {
  color: #F08C3D;
}
.gx-cloud__dist-alert ::v-deep .el-alert__title {
  color: rgb(102, 102, 102);
  font-size: 12px;
  line-height: 1.6;
}
/* 筛选区：查询/重置靠右 */
.gx-cloud__filter--dist .gx-cloud__fitem--btns {
  margin-left: auto;
}
/* 状态 pill tabs（卡片外，灰底上） */
.gx-cloud__dist-tabs {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin: 0 0 14px;
}
.gx-cloud__dist-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 8px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  color: #4A4A6A;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: color .15s ease, border-color .15s ease;
  line-height: 16px;
}
.gx-cloud__dist-tab:hover {
  color: #C8443C;
  border-color: #F2C2BB;
}
.gx-cloud__dist-tab--on,
.gx-cloud__dist-tab--on:hover {
  color: #C8443C;
  border-color: #C8443C;
  font-weight: 600;
  background: rgb(255,245,245);
}
.gx-cloud__dist-num {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: #909399;
  font-weight: 500;
}
.gx-cloud__dist-tab--on .gx-cloud__dist-num {
  color: #C8443C;
}
/* 铺货表固定列布局：铺货时间 | 店铺 | 商品信息(弹性) | 上架状态 */
.gx-cloud__table--dist table {
  table-layout: fixed;
}
.gx-cloud__table--dist td {
  vertical-align: middle;
}
/* .gx-cloud__table--dist th:nth-child(1) { width: 168px; }
.gx-cloud__table--dist th:nth-child(2) { width: 200px; } */
.gx-cloud__table--dist th:nth-child(4) { width: 120px; }
.gx-cloud__dist-time {
  font-size: 12px;
  white-space: nowrap;
}
/* 店铺：蓝色店名 + 平台 pill */
.gx-cloud__dist-shopname {
  font-size: 13px;
  /* color: #3B6FD4; */
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 6px;
}
.gx-cloud__plat {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 5px;
  border: 1px solid transparent;
  font-size: 11px;
  line-height: 18px;
  white-space: nowrap;
  font-weight: 600;
}
.gx-cloud__plat--dy {
  background: #FFF1F0;
  border-color: #FFCCC7;
  color: #F56C6C;
}
.gx-cloud__plat--wx {
  background: #F0F9EB;
  border-color: #B3E19D;
  color: #67C23A;
}
.gx-cloud__plat--other {
  background: #F4F5F7;
  border-color: #E4E7ED;
  color: #909399;
}
/* 商品信息：小图 + 单行标题（标题可点击查看商品） */
.gx-cloud__dist-goods {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.gx-cloud__dist-thumb {
  width: 34px;
  height: 34px;
  border-radius: 7px;
  border: 1px solid #EBEEF5;
  background: #F7F8FA;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
  overflow: hidden;
}
.gx-cloud__dist-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-cloud__dist-title {
  min-width: 0;
  font-size: 13px;
  color: #1A1A2E;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.gx-cloud__dist-title:hover {
  color: #C8443C;
}
.gx-cloud__table--dist .gx-cloud__err {
  max-width: 100%;
  margin-top: 4px;
  white-space: normal;
  word-break: break-word;
}
/* .gx-cloud__table--group th:nth-child(1) { width: 200px; } */
/* .gx-cloud__table--group th:nth-child(2) { width: 90px; }
.gx-cloud__table--group th:nth-child(4) { width: 70px; }
.gx-cloud__table--group th:nth-child(5) { width: 90px; }
.gx-cloud__table--group th:nth-child(6) { width: 170px; }
.gx-cloud__table--group th:nth-child(7) { width: 130px; } */
.gx-cloud__gm-count {
  font-family: 'JetBrains Mono', monospace;
  color: #C8443C;
  font-weight: 600;
}
.gx-cloud__gm-ops {
  display: flex;
  gap: 6px;
}
.gx-cloud__gm-op {
  height: 24px;
  padding: 0 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 11px;
  border: 1px solid;
  transition: all .16s;
}
.gx-cloud__gm-op--edit {
  background: #E6F4FF;
  border-color: #91CAFF;
  color: #1677FF;
}
.gx-cloud__gm-op--edit:hover {
  background: #1677FF;
  color: #fff;
}
.gx-cloud__gm-op--add {
  background: #F0F9EB;
  border-color: #B3E19D;
  color: #529B2E;
}
.gx-cloud__gm-op--add:hover {
  background: #529B2E;
  color: #fff;
}
.gx-cloud__gm-op--del {
  background: #FFF1F0;
  border-color: #FFCCC7;
  color: #F56C6C;
}
.gx-cloud__gm-op--del:hover {
  background: #F56C6C;
  border-color: #F56C6C;
  color: #fff;
}
/* 铺货弹窗：铺货到店铺 */
.gx-cloud__modal-box--dist {
  max-width: 600px;
}
.gx-cloud__modal-box--dist .gx-cloud__modal-head {
  background: #FAF6EE;
  border-bottom: none;
  padding: 18px 24px;
}
.gx-cloud__modal-box--dist .gx-cloud__modal-title {
  display: flex;
  align-items: center;
  font-family: inherit;
  font-size: 17px;
  font-weight: 700;
  color: #1A1A2E;
}
.gx-cloud__modal-box--dist .gx-cloud__modal-title::before {
  content: '';
  width: 4px;
  height: 18px;
  border-radius: 2px;
  background: #C8443C;
  margin-right: 10px;
}
.gx-cloud__modal-box--dist .gx-cloud__modal-close {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid #E4E7ED;
  background: #FFFFFF;
  color: #6A6A8A;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all .15s;
}
.gx-cloud__modal-box--dist .gx-cloud__modal-close:hover {
  color: #C8443C;
  border-color: #F2C2BB;
}
.gx-cloud__modal-box--dist .gx-cloud__modal-body {
  padding: 8px 24px 0;
}
/* 平台 tabs：下划线式 */
.gx-cloud__modal-box--dist .gx-cloud__shop-tabs {
  display: flex;
  gap: 36px;
  margin-bottom: 18px;
  border-bottom: 1px solid #E4E7ED;
}
.gx-cloud__modal-box--dist .gx-cloud__shop-tab {
  position: relative;
  padding: 6px 2px 12px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  color: #909399;
}
.gx-cloud__modal-box--dist .gx-cloud__shop-tab:hover {
  color: #C8443C;
}
.gx-cloud__modal-box--dist .gx-cloud__shop-tab--on,
.gx-cloud__modal-box--dist .gx-cloud__shop-tab--on:hover {
  color: #C8443C;
  font-weight: 600;
}
.gx-cloud__modal-box--dist .gx-cloud__shop-tab--on::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  height: 3px;
  border-radius: 2px;
  background: #C8443C;
}
/* 全选条：粉底框 */
.gx-cloud__dist-checkall {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 13px 20px;
  margin-bottom: 14px;
  border-radius: 10px;
  border: 1px solid #F8C9C4;
  background: #FEF3F2;
  color: #C8443C;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}
.gx-cloud__dist-checkall .gx-cloud__check {
  width: 19px;
  height: 19px;
  flex-shrink: 0;
}
.gx-cloud__modal-box--dist .gx-cloud__shop-item .gx-cloud__check {
  width: 17px;
  height: 17px;
  flex-shrink: 0;
}
/* 店铺列表容器 */
.gx-cloud__modal-box--dist .gx-cloud__shop-panel {
  border: 1px solid #E4E7ED;
  border-radius: 12px;
  background: #FFFFFF;
  margin-bottom: 8px;
}
.gx-cloud__modal-box--dist .gx-cloud__shop-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  max-height: 300px;
  overflow-y: auto;
  padding: 0;
}
.gx-cloud__modal-box--dist .gx-cloud__shop-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 13px 20px;
  border: none;
  border-bottom: 1px solid #F0F1F5;
  border-radius: 0;
  cursor: pointer;
  font-size: 14px;
  color: #1A1A2E;
  transition: background .15s;
}
.gx-cloud__modal-box--dist .gx-cloud__shop-item:last-child {
  border-bottom: none;
}
.gx-cloud__modal-box--dist .gx-cloud__shop-item:hover {
  background: #FAFAFC;
}
.gx-cloud__modal-box--dist .gx-cloud__shop-item--on,
.gx-cloud__modal-box--dist .gx-cloud__shop-item--on:hover {
  background: #FFF7F6;
}
.gx-cloud__shop-avatar {
  width: 38px;
  height: 38px;
  border-radius: 9px;
  border: 1px solid #F8C9C4;
  background: #FEF3F2;
  color: #C8443C;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.gx-cloud__shop-name {
  font-size: 15px;
  color: #1A1A2E;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-cloud__modal-box--dist .gx-cloud__modal-foot {
  border-top: none;
  padding: 12px 24px 22px;
  gap: 12px;
}
.gx-cloud__modal-box--dist .gx-cloud__modal-foot .gx-cloud__btn {
  min-width: 120px;
  height: 42px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
}
.gx-cloud__modal-box--dist .gx-cloud__modal-foot .gx-cloud__btn--primary:disabled {
  background: #F7A8A2;
  border: none;
  color: #FFFFFF;
  box-shadow: none;
  cursor: not-allowed;
}
.gx-cloud__shop-count {
  margin-right: auto;
  font-size: 12px;
  color: #6A6A8A;
}
/* SKU替换弹窗 */
.gx-cloud__modal-body--sku-replace {
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: column;
  gap: 12px;
}
.gx-cloud__sku-replace-filter {
  flex: 0 0 auto;
  border: 1px solid #E1E5EE;
  border-radius: 12px;
  padding: 10px 12px;
  background: #FBFBFD;
}
.gx-cloud__sku-filter-strategies {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.gx-cloud__sku-filter-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.gx-cloud__sku-filter-title {
  color: #1A1A2E;
  font-size: 12px;
  font-weight: 600;
}
.gx-cloud__filter-panel--sku-replace {
  max-height: 220px;
  margin-top: 8px;
  padding: 0;
  border-bottom: none;
  background: transparent;
}
.gx-cloud__filter-panel--sku-replace .gx-cloud__filter-actions {
  justify-content: flex-start;
  margin-top: 2px;
}
.gx-cloud__modal-body--sku-replace .gx-cloud__sku-box {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
}
.gx-cloud__sku-box {
  display: flex;
  gap: 14px;
  min-height: 460px;
  max-height: calc(90vh - 150px);
}
.gx-cloud__sku-left {
  width: 380px;
  flex-shrink: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #E1E5EE;
  border-radius: 12px;
  padding: 10px;
  background: #FBFBFD;
}
.gx-cloud__sku-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}
.gx-cloud__sku-filters .gx-cloud__select {
  min-width: 0;
  width: auto;
  flex: 1 1 45%;
  height: 28px;
  font-size: 11px;
}
.gx-cloud__sku-products {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.gx-cloud__sku-pagination {
  flex: 0 0 auto;
  min-width: 0;
  margin-top: 8px;
  border-top: 1px solid #E1E5EE;
}
.gx-cloud__sku-item {
  display: flex;
  gap: 8px;
  padding: 8px;
  border-radius: 10px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  cursor: pointer;
  transition: all .15s;
}
.gx-cloud__sku-item--on {
  border-color: #FFCCC7;
  box-shadow: 0 0 0 1px rgba(200, 68, 60, .15);
  background: #FFF5F4;
}
.gx-cloud__sku-item--done {
  opacity: .55;
}
.gx-cloud__sku-thumb {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  overflow: hidden;
  background: #F2F3F7;
  flex-shrink: 0;
}
.gx-cloud__sku-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-cloud__sku-item-body {
  min-width: 0;
  flex: 1;
}
.gx-cloud__sku-item-title {
  font-size: 12px;
  color: #1A1A2E;
  line-height: 1.35;
  margin-bottom: 3px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.gx-cloud__sku-item-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 11px;
  margin-top: 3px;
}
.gx-cloud__sku-right {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.gx-cloud__sku-detail {
  border: 1px solid #E1E5EE;
  border-radius: 12px;
  padding: 10px 12px;
  background: #FFFFFF;
}
.gx-cloud__sku-detail-head {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
}
.gx-cloud__sku-detail-title {
  font-size: 12px;
  font-weight: 600;
  color: #1A1A2E;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-cloud__sku-detail-body {
  margin-top: 8px;
  max-height: 150px;
  overflow-y: auto;
}
.gx-cloud__sku-line {
  display: flex;
  justify-content: space-between;
  padding: 5px 4px;
  font-size: 12px;
  border-bottom: 1px dashed #F0F0F5;
}
.gx-cloud__search-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid #E1E5EE;
  border-radius: 12px;
  background: #FFFFFF;
  overflow: hidden;
  min-height: 0;
}
.gx-cloud__search-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid #E1E5EE;
  gap: 8px;
  flex-wrap: wrap;
}
.gx-cloud__search-title {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  font-size: 12px;
  color: #1A1A2E;
  font-weight: 600;
}
.gx-cloud__search-count b {
  color: #C8443C;
  font-family: 'JetBrains Mono', monospace;
}
.gx-cloud__search-strategy {
  padding: 4px 12px;
  border-radius: 14px;
  font-size: 11px;
  cursor: pointer;
  border: 1px solid #E1E5EE;
  color: #4A4A6A;
  font-weight: 400;
}
.gx-cloud__search-strategy--on {
  background: linear-gradient(135deg, #E85D4E, #F47B5A);
  border-color: transparent;
  color: #FFFFFF;
}
.gx-cloud__search-tools {
  display: flex;
  align-items: center;
  gap: 6px;
}
.gx-cloud__filter-panel {
  padding: 10px 12px;
  border-bottom: 1px solid #E1E5EE;
  background: #FBFBFD;
  max-height: 220px;
  overflow-y: auto;
}
.gx-cloud__filter-group {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 8px;
  font-size: 11px;
}
.gx-cloud__filter-group-title {
  color: #6A6A8A;
  padding-top: 3px;
  min-width: 58px;
}
.gx-cloud__filter-tag {
  padding: 3px 9px;
  border-radius: 12px;
  border: 1px solid #E1E5EE;
  color: #4A4A6A;
  cursor: pointer;
  transition: all .15s;
}
.gx-cloud__filter-tag--on {
  background: #FFF1F0;
  border-color: #FFCCC7;
  color: #C8443C;
}
.gx-cloud__filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 4px;
}
@media (max-width: 900px) {
  .gx-cloud__modal-body.gx-cloud__modal-body--sku-replace {
    overflow-y: auto;
  }
  .gx-cloud__sku-filter-strategies,
  .gx-cloud__sku-filter-head {
    flex-wrap: wrap;
  }
  .gx-cloud__filter-panel--sku-replace {
    max-height: none;
  }
  .gx-cloud__modal-body--sku-replace .gx-cloud__sku-box {
    min-height: 460px;
  }
}
.gx-cloud__search-results {
  flex: 1;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 10px;
  padding: 12px;
  align-content: start;
}
.gx-cloud__result {
  border: 1px solid #E1E5EE;
  border-radius: 10px;
  overflow: visible;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  transition: all .15s;
}
.gx-cloud__result--replaced {
  border-color: #B3E19D;
}
.gx-cloud__result-img {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  background: #F2F3F7;
}
.gx-cloud__result-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-cloud__result-badge {
  position: absolute;
  top: 6px;
  left: 6px;
  padding: 2px 8px;
  border-radius: 10px;
  background: rgba(103, 194, 58, .92);
  color: #fff;
  font-size: 10px;
}
.gx-cloud__result-info {
  padding: 8px;
  flex: 1;
  min-height: 0;
}
.gx-cloud__result-title {
  font-size: 11px;
  color: #1A1A2E;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 30px;
}
.gx-cloud__result-price {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  font-size: 12px;
}
.gx-cloud__consign {
  font-size: 10px;
  color: #E6A23C;
}
.gx-cloud__result-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 5px;
}
.gx-cloud__mini-tag {
  padding: 1px 6px;
  border-radius: 8px;
  background: #ECF5FF;
  color: #409EFF;
  font-size: 10px;
}
.gx-cloud__result-actions {
  display: flex;
  border-top: 1px solid #E1E5EE;
}
.gx-cloud__result-actions .gx-cloud__op {
  flex: 1;
  height: 30px;
  border: none;
  border-radius: 0;
}
.gx-cloud__result-actions .gx-cloud__op + .gx-cloud__op {
  border-left: 1px solid #E1E5EE;
}
.gx-cloud__ai-tip {
  font-size: 12px;
  color: #8B5CF6;
  margin-right: auto;
}
.gx-cloud__link-box {
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.gx-cloud__link-input {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gx-cloud__link-input .gx-cloud__input {
  flex: 1;
}
.gx-cloud__link-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gx-cloud__link-item .gx-cloud__op {
  max-width: 460px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 批量编辑 */
.gx-cloud__edit-box {
  display: flex;
  gap: 14px;
}
.gx-cloud__edit-left {
  width: 300px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid #E1E5EE;
  border-radius: 12px;
  padding: 10px;
  background: #FBFBFD;
  max-height: 66vh;
}
.gx-cloud__edit-count {
  font-size: 11px;
  color: #6A6A8A;
  margin-bottom: 8px;
}
.gx-cloud__edit-products {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.gx-cloud__edit-item {
  display: flex;
  gap: 8px;
  padding: 8px;
  border-radius: 10px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  cursor: pointer;
}
.gx-cloud__edit-item--on {
  border-color: #FFCCC7;
  background: #FFF5F4;
}
.gx-cloud__edit-item-body {
  min-width: 0;
  flex: 1;
}
.gx-cloud__edit-item-title {
  font-size: 12px;
  color: #1A1A2E;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.gx-cloud__edit-item-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  margin-top: 3px;
}
.gx-cloud__edit-right {
  flex: 1;
  min-width: 0;
  max-height: 66vh;
  overflow-y: auto;
  border: 1px solid #E1E5EE;
  border-radius: 12px;
  padding: 14px;
  background: #FFFFFF;
}
.gx-cloud__log-group {
  font-size: 12px;
  line-height: 1.8;
  color: #1A1A2E;
}
.gx-cloud__log-ai {
  color: #8B5CF6;
}
.gx-cloud__tip {
  font-size: 12px;
  color: #6A6A8A;
  margin-bottom: 10px;
}
@media (max-width: 900px) {
  .gx-cloud__sku-box,
  .gx-cloud__edit-box {
    flex-direction: column;
  }
  .gx-cloud__sku-left,
  .gx-cloud__edit-left {
    width: 100%;
    max-height: 320px;
  }
}

/* ══ 云商品列表页样式 ══ */

/* ── 密集筛选区 ── */
.gx-cloud__filter--cloud {
  display: block;
  position: relative;
  padding: 10px 14px;
  text-align: left;
  justify-content: flex-start;
}
.gx-cloud__filter--cloud .search-wrap {
  width: 100%;
  margin: 0;
}
.gx-cloud__filter--cloud .el-form {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 2px;
}
.gx-cloud__filter--cloud .gx-cloud__filter-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 30px;
  gap: 0 10px;
  flex-wrap: wrap;
}
.gx-cloud__filter--cloud .gx-cloud__filter-row .el-form-item {
  margin: 0 0 3px;
}
.gx-cloud__filter--cloud .gx-cloud__filter-row--distribution {
  padding-right: 156px;
}
.gx-cloud__filter--cloud .gx-cloud__filter-row--time-tags {
  flex-wrap: nowrap;
}
.gx-cloud__filter--cloud .gx-cloud__filter-row--time-tags .gx-cloud__time-tag-filter {
  flex: 0 0 auto;
}
.gx-cloud__filter--cloud .gx-cloud__filter-row--time-tags .gx-cloud__time-tag-filter ::v-deep .el-form-item__content {
  flex-wrap: nowrap;
}
.gx-cloud__filter--cloud .gx-cloud__fitem--btns {
  position: absolute;
  right: 14px;
  bottom: 12px;
  gap: 6px;
  flex-wrap: nowrap;
}
.gx-cloud__filter--cloud .gx-cloud__flabel {
  color: #6A6A8A;
}
.gx-cloud__filter--cloud .gx-cloud__input {
  width: 120px;
  height: 28px;
}
.gx-cloud__filter--cloud .gx-cloud__input--num {
  width: 72px;
}
.gx-cloud__filter--cloud .gx-cloud__select {
  height: 28px;
  min-width: 106px;
}
.gx-cloud__filter--cloud .gx-cloud__fitem--btns {
  margin-left: auto;
}
.gx-cloud__filter--cloud .gx-cloud__fitem--btns .gx-cloud__btn {
  height: 28px;
}

/* ── 批量操作条：米色底 ── */
.gx-cloud__actionrow__list {
  background: #FAF6EE;
  border: 1px solid #EFE6D2;
  border-radius: 10px;
  padding: 10px 14px;
  gap: 10px;
}
.gx-cloud__actionrow__list .gx-cloud__btn {
  height: 30px;
  border-radius: 6px;
}
.gx-cloud__actionrow__list .gx-cloud__btn--ai {
  color: #1677FF;
  border-color: #91CAFF;
  background: #E6F4FF;
}
.gx-cloud__actionrow__list .gx-cloud__btn--ai:hover:not(:disabled) {
  color: #1677FF;
  border-color: #69B1FF;
  background: #D6EFFF;
}

/* ── 云商品表格 ── */
.gx-cloud__table--goods {
  overflow-x: auto;
}
.gx-cloud__table--goods table {
  min-width: 1420px;
}
.gx-cloud__table--goods th {
  padding: 10px;
  background: #FAF6EE;
  color: #6A6A8A;
  font-size: 12px;
  white-space: nowrap;
}
.gx-cloud__table--goods td {
  padding: 10px;
  vertical-align: middle;
  white-space: nowrap;
}
.gx-cloud__col-check {
  width: 42px;
}
.gx-cloud__cell-date {
  font-size: 11px;
  color: rgb(153, 153, 153)!important;
  white-space: nowrap;
}
.gx-cloud__cell-time,
.gx-cloud__cell-validity,
.gx-cloud__supplier-detail {
  color: #6A6A8A;
  font-size: 11px;
  line-height: 1.7;
  white-space: nowrap;
}
.gx-cloud__cell-time {
  min-width: 148px;
}
.gx-cloud__cell-validity {
  min-width: 92px;
}
.gx-cloud__cell-stack-line {
  display: flex;
  align-items: center;
  min-height: 20px;
  gap: 4px;
}
.gx-cloud__cell-label {
  color: #909399;
}
.gx-cloud__supplier-detail {
  min-width: 126px;
}
.gx-cloud__supplier-detail .gx-cloud__op {
  margin-top: 3px;
}
.gx-cloud__goods--row {
  min-width: 0;
  align-items: center;
  gap: 10px;
}
.gx-cloud__table--goods .gx-cloud__thumb {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  font-size: 18px;
}
.gx-cloud__goods--row .gx-cloud__goods-name {
  display: -webkit-box;
  font-size: 12px;
  line-height: 1.4;
  max-width: 210px;
  margin-bottom: 5px;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.gx-cloud__gtags {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.gx-cloud__gtags--product {
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 7px;
}
.gx-cloud__gtag {
  padding: 0 6px;
  line-height: 18px;
  border-radius: 4px;
  border: 1px solid transparent;
  font-size: 10px;
  white-space: nowrap;
}
.gx-cloud__gtag--replaced-tag {
  background: #F0F9EB;
  border-color: #B3E19D;
  color: #52A934;
}
.gx-cloud__gtag--selected-tag {
  background: #FDF6EC;
  border-color: #F5DAB1;
  color: #E6A23C;
}
.gx-cloud__gtag--notFond-tag {
  background: #FFF1F0;
  border-color: #FFCCC7;
  color: #F56C6C;
}
.gx-cloud__gtag--season {
  background: #FFF7E6;
  border-color: #FFD591;
  color: #D48806;
}
.gx-cloud__price {
  color: #F56C6C;
  font-weight: 600;
  font-size: 12px;
}
.gx-cloud__sales {
  color: #67C23A;
  font-weight: 600;
  font-size: 12px;
}
.gx-cloud__metric {
  min-width: 64px;
  color: #6A6A8A;
  font-size: 10px;
  line-height: 1.7;
  white-space: nowrap;
}
.gx-cloud__metric b {
  margin-left: 5px;
  color: #1A1A2E;
  font-family: 'JetBrains Mono', monospace;
  font-weight: 600;
}
.gx-cloud__metric--sales b {
  color: #52A934;
}
.gx-cloud__tag--muted {
  background: #F4F5F7;
  border-color: #E4E7ED;
  color: #909399;
}
.gx-cloud__table--goods .gx-cloud__statuscell {
  align-items: flex-start;
  min-width: 64px;
}
.gx-cloud__table--goods .gx-cloud__err {
  max-width: 120px;
}
.gx-cloud__gname--sub {
  font-size: 11px;
  color: #909399;
  margin-top: 2px;
}
.gx-cloud__cell-sub {
  font-size: 10px;
  color: #909399;
  margin-top: 3px;
  white-space: nowrap;
}
.gx-cloud__time-tag-filter ::v-deep .el-form-item__content {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}
.gx-cloud__time-tag-filter-btn {
  min-width: 25px;
  height: 22px;
  padding: 0 6px;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  background: #fff;
  color: #606266;
  font-size: 11px;
  line-height: 20px;
  cursor: pointer;
}
.gx-cloud__time-tag-filter-btn:hover,
.gx-cloud__time-tag-filter-btn--on {
  border-color: #ff6b6b;
  background: #fff1f0;
  color: #f56c6c;
}
.gx-cloud__time-tag-filter-btn--season {
  min-width: 28px;
}
.gx-cloud__time-tag-text {
  color: #4a4a6a;
  font-size: 12px;
  white-space: nowrap;
}
.gx-cloud__season-tags,
.gx-cloud__time-tag-options {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}
.gx-cloud__cell-validity .gx-cloud__season-tags {
  gap: 4px;
}
.gx-cloud__season-tag {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 7px;
  border: 1px solid transparent;
  border-radius: 3px;
  font-size: 11px;
  line-height: 18px;
  white-space: nowrap;
}
.gx-cloud__season-tag--春 {
  border-color: #b7eb8f;
  background: #f6ffed;
  color: #52a934;
}
.gx-cloud__season-tag--夏 {
  border-color: #91d5ff;
  background: #e6f7ff;
  color: #409eff;
}
.gx-cloud__season-tag--秋 {
  border-color: #ffd591;
  background: #fff7e6;
  color: #fa8c16;
}
.gx-cloud__season-tag--冬 {
  border-color: #d3adf7;
  background: #f9f0ff;
  color: #722ed1;
}
.gx-cloud__time-tag-setting {
  align-items: flex-start;
}
.gx-cloud__time-tag-setting .gx-cloud__label {
  min-width: 60px;
  padding-top: 2px;
}
/* ── 表格内操作按钮样式复用已有 gx-cloud__op 系列修饰类 ── */
@media (max-width: 900px) {
  .gx-cloud__filter--cloud {
    gap: 10px;
  }
  .gx-cloud__filter--cloud .gx-cloud__filter-row--time-tags {
    flex-wrap: wrap;
  }
  .gx-cloud__filter--cloud .gx-cloud__filter-row--time-tags .gx-cloud__time-tag-filter {
    max-width: 100%;
  }
  .gx-cloud__filter--cloud .gx-cloud__filter-row--time-tags .gx-cloud__time-tag-filter ::v-deep .el-form-item__content {
    flex-wrap: wrap;
    min-width: 0;
  }
}
@media (max-width: 1200px) {
  .gx-cloud__filter--cloud .gx-cloud__filter-row--distribution {
    padding-right: 0;
  }
  .gx-cloud__filter--cloud .gx-cloud__fitem--btns {
    position: static;
    justify-content: flex-end;
    margin-top: 6px;
  }
}
</style>
